{
  "level": "q305",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:q305",
    "objects": "AREAS.E3:q305.e3",
    "mesh": "TREES.E3:q305.e3"
  },
  "spawn_point": {
    "position": [
      1527.9948672967207,
      778.3336182925576,
      -276.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      1527.9948672967207,
      878.3336182925576,
      -276.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -3714.042724609375,
      -4714.78125,
      -300.0
    ],
    "bbox_max": [
      4526.4208984375,
      2266.29345703125,
      1493.904296875
    ],
    "vertex_count": 1900,
    "vertices": [
      [
        -3000.0,
        -3565.30615234375,
        1052.5999755859375
      ],
      [
        -3000.0,
        -3408.73486328125,
        667.6585693359375
      ],
      [
        -3000.0,
        -4714.78125,
        1390.1104736328125
      ],
      [
        -3000.0,
        -4650.2626953125,
        1191.9580078125
      ],
      [
        -3714.042724609375,
        -2323.521484375,
        1179.1292724609375
      ],
      [
        2400.0,
        -796.68505859375,
        0.0
      ],
      [
        2400.0,
        -796.68505859375,
        0.0
      ],
      [
        2400.0,
        -696.68505859375,
        -300.0
      ],
      [
        4526.4208984375,
        -1556.87548828125,
        543.49267578125
      ],
      [
        2400.0,
        -1844.385986328125,
        749.0462646484375
      ],
      [
        4526.4208984375,
        -1556.87548828125,
        543.49267578125
      ],
      [
        2962.5361328125,
        -1257.6373291015625,
        329.55450439453125
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        650.0,
        -2598.9130859375,
        1493.904296875
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        2400.0,
        -1546.88427734375,
        433.001953125
      ],
      [
        650.0,
        -867.0938720703125,
        16.996383666992188
      ],
      [
        650.0,
        -843.0780639648438,
        0.0
      ],
      [
        650.0,
        -867.0938720703125,
        16.99639320373535
      ],
      [
        650.0,
        -843.0780639648438,
        0.0
      ],
      [
        650.0,
        -743.0372314453125,
        -300.0
      ],
      [
        -199.69903564453125,
        -1200.0,
        0.0
      ],
      [
        582.9658203125,
        -1200.0,
        118.47282409667969
      ],
      [
        582.9658203125,
        -1200.0,
        118.47281646728516
      ],
      [
        650.0,
        -1200.0,
        124.01402282714844
      ],
      [
        4110.0,
        2266.29345703125,
        1014.1094970703125
      ],
      [
        4110.0,
        2233.390869140625,
        1007.1089477539062
      ],
      [
        4110.0,
        1355.2147216796875,
        820.262939453125
      ],
      [
        4110.0,
        1142.219970703125,
        730.4360961914062
      ],
      [
        4110.0,
        1346.6982421875,
        818.451171875
      ],
      [
        4110.0,
        1350.9073486328125,
        820.262939453125
      ],
      [
        4110.0,
        1355.2147216796875,
        820.262939453125
      ],
      [
        4110.0,
        1350.9073486328125,
        820.262939453125
      ],
      [
        3100.0,
        680.8695678710938,
        242.60870361328125
      ],
      [
        3100.0,
        1221.72412109375,
        266.89654541015625
      ],
      [
        3100.0,
        630.8695678710938,
        177.39129638671875
      ],
      [
        3100.0,
        623.04345703125,
        20.869564056396484
      ],
      [
        3100.0,
        630.8695678710938,
        177.3913116455078
      ],
      [
        3100.0,
        663.0787963867188,
        241.80979919433594
      ],
      [
        3312.43017578125,
        1790.47265625,
        489.9930419921875
      ],
      [
        3285.123046875,
        1852.6285400390625,
        488.7391357421875
      ],
      [
        3312.43017578125,
        1790.47265625,
        489.9930419921875
      ],
      [
        3100.0,
        1221.72412109375,
        266.89654541015625
      ],
      [
        3100.0,
        1690.0,
        305.5172424316406
      ],
      [
        3100.0,
        663.478271484375,
        242.60870361328125
      ],
      [
        3100.0,
        680.8695678710938,
        242.60870361328125
      ],
      [
        3100.0,
        663.478271484375,
        242.60870361328125
      ],
      [
        4110.0,
        1346.6982421875,
        818.451171875
      ],
      [
        3437.258056640625,
        1506.344482421875,
        495.7249755859375
      ],
      [
        1910.0,
        1579.9000244140625,
        1060.0
      ],
      [
        1910.0,
        1470.0,
        1060.0
      ],
      [
        1910.0,
        2050.0,
        1060.0
      ],
      [
        1910.0,
        1940.0999755859375,
        1060.0
      ],
      [
        2963.776611328125,
        666.4061279296875,
        70.78168487548828
      ],
      [
        2953.080810546875,
        669.0355834960938,
        59.19630813598633
      ],
      [
        2963.776611328125,
        666.4061279296875,
        70.78167724609375
      ],
      [
        3100.0,
        652.1339721679688,
        219.9201202392578
      ],
      [
        1910.0,
        1470.0,
        1060.0
      ],
      [
        2091.7158203125,
        1470.0,
        1060.0
      ],
      [
        1945.0999755859375,
        1931.0999755859375,
        1060.0
      ],
      [
        1910.0,
        1940.0999755859375,
        1060.0
      ],
      [
        1910.0,
        1624.5108642578125,
        1060.0
      ],
      [
        1910.0,
        1623.9998779296875,
        1059.421875
      ],
      [
        1910.0,
        1623.9998779296875,
        1059.421875
      ],
      [
        1910.0,
        1623.9998779296875,
        1060.0
      ],
      [
        1910.0,
        1896.0,
        1059.422119140625
      ],
      [
        1910.0,
        1895.4892578125,
        1060.0
      ],
      [
        1910.0,
        1619.3614501953125,
        340.0
      ],
      [
        1910.0,
        1608.986083984375,
        340.0
      ],
      [
        1911.8759765625,
        1688.1240234375,
        340.0
      ],
      [
        1941.64794921875,
        1760.0,
        340.0
      ],
      [
        1910.0,
        1676.5230712890625,
        350.0
      ],
      [
        1911.8759765625,
        1688.1240234375,
        340.0
      ],
      [
        1910.0,
        1687.346923828125,
        340.0
      ],
      [
        1910.0,
        1608.986083984375,
        340.0
      ],
      [
        1910.0,
        1608.986083984375,
        350.0
      ],
      [
        1910.0,
        1735.857666015625,
        320.0
      ],
      [
        1910.0,
        1690.0,
        337.5489196777344
      ],
      [
        1910.0,
        1784.1424560546875,
        320.0
      ],
      [
        1910.0,
        1735.857666015625,
        320.0
      ],
      [
        1910.0,
        1690.0,
        337.5489196777344
      ],
      [
        2955.16357421875,
        668.6529541015625,
        64.04112243652344
      ],
      [
        3100.0,
        663.0787963867188,
        241.80979919433594
      ],
      [
        2955.16357421875,
        668.6529541015625,
        64.04113006591797
      ],
      [
        2951.521240234375,
        669.5238037109375,
        59.6031494140625
      ],
      [
        1588.2841796875,
        1469.9998779296875,
        1060.0
      ],
      [
        1769.9998779296875,
        1469.9998779296875,
        1060.0
      ],
      [
        1549.9998779296875,
        1508.2841796875,
        1060.0
      ],
      [
        1588.2841796875,
        1469.9998779296875,
        1060.0
      ],
      [
        1550.0001220703125,
        2011.7158203125,
        1060.0
      ],
      [
        1550.0,
        1830.0,
        1060.0
      ],
      [
        1549.9998779296875,
        1689.9998779296875,
        1060.0
      ],
      [
        1549.9998779296875,
        1508.2841796875,
        1060.0
      ],
      [
        1680.0,
        1490.0,
        350.0
      ],
      [
        1680.0,
        1469.9998779296875,
        400.0
      ],
      [
        1680.0,
        1469.9998779296875,
        350.0
      ],
      [
        1840.0001220703125,
        1658.3521728515625,
        340.0
      ],
      [
        1910.0,
        1687.346923828125,
        340.0
      ],
      [
        1910.0,
        1545.0,
        340.0
      ],
      [
        1883.3333740234375,
        1545.0001220703125,
        340.0
      ],
      [
        1883.3333740234375,
        1565.0,
        340.0
      ],
      [
        1883.3333740234375,
        1545.0001220703125,
        340.0
      ],
      [
        1883.3333740234375,
        1485.0,
        340.0
      ],
      [
        1910.0,
        1485.0,
        340.0
      ],
      [
        1883.3333740234375,
        1505.0,
        340.0
      ],
      [
        1883.3333740234375,
        1485.0,
        340.0
      ],
      [
        1680.0,
        1490.0,
        340.0
      ],
      [
        1680.0,
        1485.0,
        350.0
      ],
      [
        1680.0,
        1485.0,
        340.0
      ],
      [
        1680.0,
        1469.9998779296875,
        340.0
      ],
      [
        1680.0,
        1490.0,
        320.0
      ],
      [
        1680.0,
        1469.9998779296875,
        320.0
      ],
      [
        1735.0,
        1469.9998779296875,
        280.0
      ],
      [
        1680.0,
        1469.9998779296875,
        280.0
      ],
      [
        1680.0,
        1469.9998779296875,
        280.0
      ],
      [
        1655.0,
        1469.9998779296875,
        135.0
      ],
      [
        1695.0001220703125,
        1469.9998779296875,
        135.0
      ],
      [
        1665.0,
        1918.3214111328125,
        135.0
      ],
      [
        1655.0,
        1918.3214111328125,
        135.0
      ],
      [
        1680.0001220703125,
        1910.0,
        135.0
      ],
      [
        1680.0001220703125,
        1900.0001220703125,
        135.0
      ],
      [
        1680.0,
        1620.0,
        135.0
      ],
      [
        1680.0,
        1610.0,
        135.0
      ],
      [
        1680.0,
        1665.0,
        135.0
      ],
      [
        1680.0,
        1655.0,
        135.0
      ],
      [
        1680.0,
        1715.0,
        135.0
      ],
      [
        1680.0,
        1705.0,
        135.0
      ],
      [
        1680.0,
        1765.0,
        135.0
      ],
      [
        1680.0,
        1755.0,
        135.0
      ],
      [
        1680.0,
        1815.0,
        135.0
      ],
      [
        1680.0,
        1805.0,
        135.0
      ],
      [
        1680.0,
        1865.0,
        135.0
      ],
      [
        1680.0001220703125,
        1855.0,
        135.0
      ],
      [
        1680.0,
        1610.0,
        135.0
      ],
      [
        1690.0,
        1610.0,
        135.0
      ],
      [
        1680.0,
        1705.0,
        135.0
      ],
      [
        1690.0,
        1705.0,
        135.0
      ],
      [
        1695.0,
        1469.9998779296875,
        120.0
      ],
      [
        1655.0001220703125,
        1469.9998779296875,
        120.0
      ],
      [
        1655.0001220703125,
        1469.9998779296875,
        120.0
      ],
      [
        1655.0,
        1469.9998779296875,
        135.0
      ],
      [
        1695.0001220703125,
        1469.9998779296875,
        135.0
      ],
      [
        1695.0,
        1469.9998779296875,
        120.0
      ],
      [
        1770.0,
        620.0,
        220.0
      ],
      [
        1770.0,
        670.0,
        220.0
      ],
      [
        1910.0,
        1020.0,
        220.0
      ],
      [
        1910.0,
        670.0,
        149.0
      ],
      [
        1905.0,
        670.0,
        149.0
      ],
      [
        1770.0,
        420.0,
        80.0
      ],
      [
        1770.0,
        420.0,
        140.0
      ],
      [
        1770.0,
        570.0,
        69.9788818359375
      ],
      [
        1770.0,
        636.6666870117188,
        63.31221389770508
      ],
      [
        1770.0,
        420.0,
        80.0
      ],
      [
        1770.0,
        469.78875732421875,
        80.0
      ],
      [
        1770.0,
        1020.0,
        220.0
      ],
      [
        1770.0,
        483.3333435058594,
        78.66666412353516
      ],
      [
        1770.0,
        570.0,
        69.9788818359375
      ],
      [
        1770.0,
        470.0,
        80.0
      ],
      [
        1770.0,
        483.3333435058594,
        78.66666412353516
      ],
      [
        1770.0,
        470.0,
        80.0
      ],
      [
        1770.0,
        680.0,
        98.0
      ],
      [
        1770.0,
        690.0,
        98.0
      ],
      [
        1770.0,
        680.0,
        98.0
      ],
      [
        1770.0,
        620.0,
        98.0
      ],
      [
        1770.0,
        630.0,
        100.0
      ],
      [
        1770.0,
        625.0,
        100.0
      ],
      [
        1770.0,
        690.0,
        100.0
      ],
      [
        1770.0,
        680.0,
        100.0
      ],
      [
        1770.0,
        680.0,
        100.0
      ],
      [
        1770.0,
        620.0,
        100.0
      ],
      [
        1770.0,
        690.0,
        98.0
      ],
      [
        1770.0,
        690.0,
        100.0
      ],
      [
        1770.0,
        620.0,
        98.0
      ],
      [
        1770.0,
        620.0,
        100.0
      ],
      [
        1780.0,
        670.0,
        60.0
      ],
      [
        1770.0,
        670.0,
        60.0
      ],
      [
        1770.0,
        720.0,
        60.0
      ],
      [
        1780.0,
        720.0,
        60.0
      ],
      [
        1770.0,
        670.0,
        60.0
      ],
      [
        1780.0,
        670.0,
        60.0
      ],
      [
        1780.0,
        653.3333740234375,
        61.656105041503906
      ],
      [
        1770.0,
        636.6666870117188,
        63.31221389770508
      ],
      [
        1790.0,
        620.0,
        280.0
      ],
      [
        1770.0,
        620.0,
        280.0
      ],
      [
        1770.0,
        620.0,
        338.0
      ],
      [
        1790.0,
        700.0,
        280.0
      ],
      [
        1770.0,
        700.0,
        338.0
      ],
      [
        1770.0,
        700.0,
        280.0
      ],
      [
        1770.0,
        680.0,
        258.0
      ],
      [
        1770.0,
        620.0,
        258.0
      ],
      [
        1770.0,
        700.0,
        258.0
      ],
      [
        1770.0,
        680.0,
        258.0
      ],
      [
        1770.0,
        620.0,
        258.0
      ],
      [
        1770.0,
        700.0,
        258.0
      ],
      [
        1770.0,
        670.0,
        220.0
      ],
      [
        1770.0,
        670.0,
        240.0
      ],
      [
        1770.0,
        620.0,
        240.0
      ],
      [
        1770.0,
        620.0,
        220.0
      ],
      [
        1630.0,
        1450.0,
        120.0
      ],
      [
        1680.0,
        1440.0,
        140.0
      ],
      [
        1680.0,
        1470.0,
        140.0
      ],
      [
        1680.0,
        1470.0,
        140.0
      ],
      [
        1680.0,
        1465.0,
        135.0
      ],
      [
        1680.0,
        1450.0,
        135.0
      ],
      [
        1695.0,
        1450.0,
        135.0
      ],
      [
        1680.0,
        1465.0,
        135.0
      ],
      [
        1680.0,
        1469.9998779296875,
        135.0
      ],
      [
        1680.0,
        1442.5,
        135.0
      ],
      [
        1680.0,
        1440.0,
        140.0
      ],
      [
        1680.0,
        1442.5,
        135.0
      ],
      [
        1630.0,
        1470.0,
        140.0
      ],
      [
        1630.0,
        1450.0,
        140.0
      ],
      [
        1660.0,
        1400.0,
        140.0
      ],
      [
        1630.0,
        1450.0,
        138.0
      ],
      [
        1630.0,
        1470.0,
        138.0
      ],
      [
        1660.0,
        1400.0,
        138.0
      ],
      [
        1660.0,
        1400.0,
        138.0
      ],
      [
        1660.0,
        1400.0,
        140.0
      ],
      [
        1660.0,
        1440.0001220703125,
        140.0
      ],
      [
        1680.0,
        1441.0,
        138.0
      ],
      [
        1660.0,
        1441.0001220703125,
        138.0
      ],
      [
        1630.0,
        1450.0,
        138.0
      ],
      [
        1630.0,
        1450.0,
        140.0
      ],
      [
        1630.0,
        1470.0,
        140.0
      ],
      [
        1655.0,
        1468.0,
        138.0
      ],
      [
        1630.0,
        1468.0,
        138.0
      ],
      [
        1655.0001220703125,
        1450.0,
        140.0
      ],
      [
        1653.0001220703125,
        1450.0,
        138.0
      ],
      [
        1653.0,
        1468.0,
        138.0
      ],
      [
        1653.0001220703125,
        1441.0001220703125,
        138.0
      ],
      [
        1655.0001220703125,
        1441.0001220703125,
        138.0
      ],
      [
        1653.0001220703125,
        1441.0001220703125,
        138.0
      ],
      [
        1655.0001220703125,
        1441.0001220703125,
        138.0
      ],
      [
        1630.0,
        1450.0001220703125,
        120.0
      ],
      [
        1430.0,
        1400.0,
        290.0
      ],
      [
        1430.0,
        1400.0,
        140.0
      ],
      [
        1430.0,
        1400.0,
        140.0
      ],
      [
        1430.0,
        1400.0,
        115.65217590332031
      ],
      [
        1587.455810546875,
        1467.9998779296875,
        138.0
      ],
      [
        1630.0,
        1468.0,
        138.0
      ],
      [
        1499.553466796875,
        1400.0,
        140.0
      ],
      [
        1460.0,
        1400.0,
        140.0
      ],
      [
        1680.0,
        1220.0,
        102.0
      ],
      [
        1680.0,
        1220.0,
        140.0
      ],
      [
        1680.0,
        1220.0,
        138.0
      ],
      [
        1680.0,
        1220.0,
        140.0
      ],
      [
        1660.0,
        1400.0,
        120.0
      ],
      [
        1680.0,
        1220.0,
        104.34782409667969
      ],
      [
        1660.0,
        1220.0,
        104.34782409667969
      ],
      [
        1680.0,
        1220.0,
        140.0
      ],
      [
        1680.0,
        1220.0,
        138.0
      ],
      [
        1710.0,
        1400.0,
        140.0
      ],
      [
        1710.0,
        1385.0,
        140.0
      ],
      [
        1710.0,
        1235.0,
        140.0
      ],
      [
        1710.0,
        1220.0,
        140.0
      ],
      [
        1710.0,
        1235.0,
        140.0
      ],
      [
        1688.5714111328125,
        1220.0,
        140.0
      ],
      [
        1680.0,
        1220.0,
        140.0
      ],
      [
        1688.5714111328125,
        1220.0,
        140.0
      ],
      [
        1630.0,
        1220.0,
        140.0
      ],
      [
        1630.0,
        1220.0,
        104.34782409667969
      ],
      [
        1630.0,
        1220.0,
        104.34782409667969
      ],
      [
        1370.0,
        1270.0,
        140.0
      ],
      [
        1330.0,
        1270.0,
        140.0
      ],
      [
        1300.0,
        1270.0,
        140.0
      ],
      [
        1300.0,
        1270.0,
        104.34782409667969
      ],
      [
        1370.0,
        1270.0,
        138.0
      ],
      [
        1370.0,
        1270.0,
        140.0
      ],
      [
        1350.0,
        1220.0,
        140.0
      ],
      [
        1630.0,
        1220.0,
        140.0
      ],
      [
        1516.3448486328125,
        1225.0,
        140.0
      ],
      [
        1513.2716064453125,
        1232.2733154296875,
        140.0
      ],
      [
        1514.232177734375,
        1220.0,
        134.0
      ],
      [
        1514.232177734375,
        1220.0,
        140.0
      ],
      [
        1516.3448486328125,
        1225.0,
        140.0
      ],
      [
        1496.767822265625,
        1220.0,
        139.0
      ],
      [
        1494.6551513671875,
        1225.0,
        140.0
      ],
      [
        1496.767822265625,
        1220.0,
        140.0
      ],
      [
        1496.767822265625,
        1220.0,
        141.0
      ],
      [
        1498.9390869140625,
        1220.0,
        141.0
      ],
      [
        1514.232177734375,
        1220.0,
        141.0
      ],
      [
        1496.767822265625,
        1220.0,
        141.0
      ],
      [
        685.8578491210938,
        670.0,
        80.0
      ],
      [
        550.0,
        670.0,
        80.0
      ],
      [
        1250.0,
        707.730224609375,
        60.0
      ],
      [
        1250.0,
        670.0,
        80.0
      ],
      [
        1250.0,
        707.730224609375,
        80.0
      ],
      [
        1250.0,
        707.730224609375,
        60.98158264160156
      ],
      [
        1250.0,
        670.0,
        64.0
      ],
      [
        1250.0,
        670.0,
        80.0
      ],
      [
        1250.0,
        707.730224609375,
        80.0
      ],
      [
        1426.0,
        700.0,
        80.0
      ],
      [
        1659.0,
        700.0,
        78.0
      ],
      [
        1538.6363525390625,
        680.0,
        78.0
      ],
      [
        1511.1817626953125,
        680.0,
        78.0
      ],
      [
        1664.199951171875,
        680.0,
        80.0
      ],
      [
        1659.0,
        700.0,
        78.0
      ],
      [
        1659.0,
        700.0,
        80.0
      ],
      [
        1426.0,
        690.0,
        80.0
      ],
      [
        1426.0,
        700.0,
        80.0
      ],
      [
        1426.0,
        690.0,
        80.0
      ],
      [
        1664.199951171875,
        670.0,
        80.0
      ],
      [
        1664.199951171875,
        680.0,
        80.0
      ],
      [
        1511.1817626953125,
        680.0,
        78.0
      ],
      [
        1511.1817626953125,
        670.0,
        78.0
      ],
      [
        1538.6363525390625,
        680.0,
        78.0
      ],
      [
        1538.6363525390625,
        670.0,
        78.0
      ],
      [
        1470.0,
        675.0,
        78.0
      ],
      [
        1470.0,
        675.0,
        79.99999237060547
      ],
      [
        1470.0,
        670.0,
        80.0
      ],
      [
        1470.0,
        670.0,
        78.0
      ],
      [
        1472.0,
        670.0,
        78.0
      ],
      [
        1472.0,
        670.0,
        79.99999237060547
      ],
      [
        1472.0,
        675.0,
        80.0
      ],
      [
        1472.0,
        675.0,
        78.0
      ],
      [
        1470.0,
        675.0,
        80.0
      ],
      [
        1470.0,
        675.0,
        78.0
      ],
      [
        1472.0,
        675.0,
        78.0
      ],
      [
        1472.0,
        675.0,
        79.99999237060547
      ],
      [
        1438.0,
        675.0,
        78.0
      ],
      [
        1438.0,
        675.0,
        79.99999237060547
      ],
      [
        1438.0,
        670.0,
        80.0
      ],
      [
        1438.0,
        670.0,
        78.0
      ],
      [
        1440.0,
        670.0,
        78.0
      ],
      [
        1440.0,
        670.0,
        79.99999237060547
      ],
      [
        1440.0,
        675.0,
        80.0
      ],
      [
        1440.0,
        675.0,
        78.0
      ],
      [
        1438.0,
        675.0,
        80.0
      ],
      [
        1438.0,
        675.0,
        78.0
      ],
      [
        1440.0,
        675.0,
        78.0
      ],
      [
        1440.0,
        675.0,
        79.99999237060547
      ],
      [
        1490.25,
        680.0,
        66.25
      ],
      [
        1490.25,
        680.0,
        65.0357437133789
      ],
      [
        1490.25,
        670.25,
        65.0357437133789
      ],
      [
        1480.6363525390625,
        680.25,
        59.99999237060547
      ],
      [
        1490.25,
        680.25,
        65.0357437133789
      ],
      [
        1490.25,
        680.25,
        65.0357437133789
      ],
      [
        1560.0,
        680.0,
        64.25
      ],
      [
        1567.7274169921875,
        680.0,
        59.999996185302734
      ],
      [
        1560.0,
        670.0,
        64.25
      ],
      [
        1560.0,
        680.0,
        64.25
      ],
      [
        1659.0,
        707.730224609375,
        78.0
      ],
      [
        1639.0,
        707.730224609375,
        78.0
      ],
      [
        1659.0,
        707.730224609375,
        78.0
      ],
      [
        1659.0,
        707.730224609375,
        80.0
      ],
      [
        1639.0,
        707.730224609375,
        78.0
      ],
      [
        1639.0,
        707.730224609375,
        80.0
      ],
      [
        852.9127807617188,
        707.368408203125,
        80.0
      ],
      [
        1190.468017578125,
        707.368408203125,
        80.0
      ],
      [
        730.0,
        707.730224609375,
        60.0
      ],
      [
        720.0,
        707.3684692382812,
        80.0
      ],
      [
        720.0,
        707.730224609375,
        80.0
      ],
      [
        1200.0,
        707.730224609375,
        60.0
      ],
      [
        1190.468017578125,
        707.368408203125,
        80.0
      ],
      [
        1190.468017578125,
        707.730224609375,
        80.0
      ],
      [
        833.4356689453125,
        707.730224609375,
        60.85891342163086
      ],
      [
        837.730224609375,
        707.730224609375,
        61.189266204833984
      ],
      [
        760.0,
        707.730224609375,
        78.0
      ],
      [
        760.0,
        706.631591796875,
        78.0
      ],
      [
        760.0,
        707.3684692382812,
        80.0
      ],
      [
        760.0,
        707.730224609375,
        80.0
      ],
      [
        1250.0,
        720.0,
        80.0
      ],
      [
        1250.0,
        720.0,
        80.0
      ],
      [
        1480.0,
        720.0,
        80.0
      ],
      [
        1250.0,
        720.0,
        80.0
      ],
      [
        1480.0,
        720.0,
        80.0
      ],
      [
        1190.468017578125,
        713.2186279296875,
        80.0
      ],
      [
        1190.468017578125,
        713.2186889648438,
        80.0
      ],
      [
        1194.1214599609375,
        825.0,
        80.0
      ],
      [
        546.4309692382812,
        743.2847290039062,
        80.0
      ],
      [
        556.4309692382812,
        753.2847290039062,
        80.0
      ],
      [
        546.4309692382812,
        743.2847290039062,
        80.0
      ],
      [
        1250.0,
        680.0,
        80.0
      ],
      [
        1250.0,
        670.0,
        220.0
      ],
      [
        1250.0,
        680.0,
        220.0
      ],
      [
        1250.0,
        680.0,
        80.0
      ],
      [
        1250.0,
        670.0,
        220.0
      ],
      [
        1250.0,
        680.0,
        220.0
      ],
      [
        550.0,
        680.0,
        100.0
      ],
      [
        550.0,
        670.0,
        100.0
      ],
      [
        550.0,
        670.0,
        140.0
      ],
      [
        550.0,
        680.0,
        140.0
      ],
      [
        550.0,
        680.0,
        140.0
      ],
      [
        550.0,
        670.0,
        140.0
      ],
      [
        550.0,
        670.0,
        240.0
      ],
      [
        550.0,
        680.0,
        240.0
      ],
      [
        1472.0,
        678.0,
        338.0
      ],
      [
        1472.0,
        678.0,
        160.0
      ],
      [
        1472.0,
        678.0,
        160.0
      ],
      [
        1438.0,
        678.0,
        160.0
      ],
      [
        1472.0,
        675.0,
        160.0
      ],
      [
        1470.0,
        675.0,
        160.0
      ],
      [
        1438.0,
        675.0,
        160.0
      ],
      [
        1440.0,
        675.0,
        160.0
      ],
      [
        1260.0,
        680.0,
        258.0
      ],
      [
        1260.0,
        670.0,
        258.0
      ],
      [
        1280.0,
        680.0,
        258.0
      ],
      [
        1280.0,
        680.0,
        258.0
      ],
      [
        1383.3333740234375,
        680.0,
        258.0
      ],
      [
        1383.3333740234375,
        680.0,
        258.0
      ],
      [
        1383.3333740234375,
        680.0,
        338.0
      ],
      [
        1260.0,
        670.0,
        258.0
      ],
      [
        1260.0,
        680.0,
        258.0
      ],
      [
        1260.0,
        680.0,
        338.0
      ],
      [
        1260.0,
        670.0,
        338.0
      ],
      [
        1310.0,
        680.0,
        258.0
      ],
      [
        1310.0,
        680.0,
        232.6666717529297
      ],
      [
        1300.0,
        680.0,
        232.6666717529297
      ],
      [
        1300.0,
        680.0,
        258.0
      ],
      [
        1300.0,
        680.0,
        232.6666717529297
      ],
      [
        1310.0,
        680.0,
        232.6666717529297
      ],
      [
        1250.0,
        670.0,
        100.0
      ],
      [
        1250.0,
        680.0,
        100.0
      ],
      [
        1270.0,
        670.0,
        100.0
      ],
      [
        1270.0,
        670.0,
        98.0
      ],
      [
        1250.0,
        680.0,
        98.0
      ],
      [
        1250.0,
        670.0,
        98.0
      ],
      [
        1270.0,
        670.0,
        98.0
      ],
      [
        1270.0,
        670.0,
        100.0
      ],
      [
        1360.0,
        680.0,
        258.0
      ],
      [
        1360.0,
        680.0,
        232.6666717529297
      ],
      [
        1350.0,
        680.0,
        232.6666717529297
      ],
      [
        1350.0,
        680.0,
        258.0
      ],
      [
        1350.0,
        680.0,
        232.6666717529297
      ],
      [
        1360.0,
        680.0,
        232.6666717529297
      ],
      [
        1770.0,
        670.0,
        258.0
      ],
      [
        1666.6666259765625,
        680.0,
        258.0
      ],
      [
        1666.6666259765625,
        680.0,
        338.0
      ],
      [
        1666.6666259765625,
        680.0,
        258.0
      ],
      [
        1770.0,
        670.0,
        98.0
      ],
      [
        1770.0,
        670.0,
        100.0
      ],
      [
        1700.0,
        680.0,
        258.0
      ],
      [
        1700.0,
        680.0,
        232.6666717529297
      ],
      [
        1690.0,
        680.0,
        232.6666717529297
      ],
      [
        1690.0,
        680.0,
        258.0
      ],
      [
        1690.0,
        680.0,
        232.6666717529297
      ],
      [
        1700.0,
        680.0,
        232.6666717529297
      ],
      [
        1750.0,
        680.0,
        258.0
      ],
      [
        1750.0,
        680.0,
        232.6666717529297
      ],
      [
        1740.0,
        680.0,
        232.6666717529297
      ],
      [
        1740.0,
        680.0,
        258.0
      ],
      [
        1740.0,
        680.0,
        232.6666717529297
      ],
      [
        1750.0,
        680.0,
        232.6666717529297
      ],
      [
        1680.0,
        1120.0,
        138.0
      ],
      [
        1680.0,
        1120.0,
        140.0
      ],
      [
        1660.0,
        1120.0,
        140.0
      ],
      [
        1680.0,
        1120.0,
        140.0
      ],
      [
        1680.0,
        1120.0,
        138.0
      ],
      [
        1660.0,
        1120.0,
        138.0
      ],
      [
        1660.0,
        1120.0,
        140.0
      ],
      [
        1660.0,
        1120.0,
        138.0
      ],
      [
        1657.0,
        1150.0,
        138.0
      ],
      [
        1657.0,
        1140.0,
        138.0
      ],
      [
        1657.0,
        1140.0,
        138.0
      ],
      [
        1632.9998779296875,
        1122.9998779296875,
        120.0
      ],
      [
        1632.9998779296875,
        1140.0,
        120.0
      ],
      [
        1632.9998779296875,
        1122.9998779296875,
        120.0
      ],
      [
        1632.9998779296875,
        1120.0,
        120.0
      ],
      [
        1650.0,
        1120.0,
        118.0
      ],
      [
        1650.0,
        1120.0,
        120.0
      ],
      [
        1650.0,
        1120.0,
        120.0
      ],
      [
        1650.0,
        1120.0,
        118.0
      ],
      [
        1700.0,
        1120.0,
        325.0
      ],
      [
        1700.0,
        1120.0,
        410.0
      ],
      [
        1760.0,
        1120.0,
        410.0
      ],
      [
        1760.0,
        1120.0,
        325.0
      ],
      [
        1690.0,
        1210.0,
        100.0
      ],
      [
        1690.0,
        1210.0,
        140.0
      ],
      [
        1690.0,
        1210.0,
        140.0
      ],
      [
        1690.0,
        1220.0,
        140.0
      ],
      [
        1690.0,
        1210.0,
        119.99986267089844
      ],
      [
        1513.2716064453125,
        1217.7266845703125,
        140.0
      ],
      [
        1514.232177734375,
        1220.0,
        140.0
      ],
      [
        1496.767822265625,
        1220.0,
        140.0
      ],
      [
        1497.7283935546875,
        1217.7266845703125,
        140.0
      ],
      [
        1555.0,
        1120.0,
        140.0
      ],
      [
        1555.0,
        1120.0,
        465.0
      ],
      [
        1615.0,
        1120.0,
        140.0
      ],
      [
        1615.0,
        1120.0,
        130.0
      ],
      [
        1615.0,
        1120.0,
        465.0
      ],
      [
        1615.0,
        1120.0,
        140.0
      ],
      [
        1615.0,
        1120.0,
        100.0
      ],
      [
        1555.0,
        1120.0,
        100.0
      ],
      [
        1555.0,
        1170.0,
        100.0
      ],
      [
        1615.0,
        1170.0,
        100.0
      ],
      [
        1555.0,
        1120.0,
        118.0
      ],
      [
        1615.0,
        1120.0,
        118.0
      ],
      [
        1615.0,
        1140.0,
        118.0
      ],
      [
        1555.0,
        1140.0,
        118.0
      ],
      [
        1555.0,
        1140.0,
        120.0
      ],
      [
        1615.0,
        1140.0,
        120.0
      ],
      [
        1615.0,
        1120.0,
        120.0
      ],
      [
        1555.0,
        1120.0,
        120.0
      ],
      [
        1615.0,
        1170.0,
        116.66666412353516
      ],
      [
        1615.0,
        1160.0,
        116.66666412353516
      ],
      [
        1615.0,
        1160.0,
        116.66666412353516
      ],
      [
        1615.0,
        1160.0,
        114.66666412353516
      ],
      [
        1615.0,
        1170.0,
        114.66666412353516
      ],
      [
        1615.0,
        1160.0,
        114.66666412353516
      ],
      [
        1617.0,
        1170.0,
        118.0
      ],
      [
        1617.0,
        1160.0,
        118.0
      ],
      [
        1617.0,
        1160.0,
        118.0
      ],
      [
        1455.0,
        1120.0,
        465.0
      ],
      [
        1455.0,
        1120.0,
        140.0
      ],
      [
        1395.0,
        1120.0,
        140.0
      ],
      [
        1395.0,
        1120.0,
        465.0
      ],
      [
        1455.0,
        1120.0,
        100.0
      ],
      [
        1395.0,
        1120.0,
        100.0
      ],
      [
        1395.0,
        1170.0,
        100.0
      ],
      [
        1455.0,
        1170.0,
        100.0
      ],
      [
        1395.0,
        1140.0,
        120.0
      ],
      [
        1455.0,
        1140.0,
        120.0
      ],
      [
        1455.0,
        1120.0,
        120.0
      ],
      [
        1395.0,
        1120.0,
        120.0
      ],
      [
        1395.0,
        1120.0,
        118.0
      ],
      [
        1455.0,
        1120.0,
        118.0
      ],
      [
        1455.0,
        1140.0,
        118.0
      ],
      [
        1395.0,
        1140.0,
        118.0
      ],
      [
        1390.0,
        1120.0,
        260.10211181640625
      ],
      [
        1390.0,
        1120.0,
        160.0
      ],
      [
        1390.0,
        1140.0,
        120.0
      ],
      [
        1390.0,
        1120.0,
        120.0
      ],
      [
        1390.0,
        1120.0,
        118.0
      ],
      [
        1390.0,
        1140.0,
        118.0
      ],
      [
        1390.0,
        1120.0,
        160.0
      ],
      [
        1475.0,
        1120.0,
        140.0
      ],
      [
        1475.0,
        1120.0,
        465.0
      ],
      [
        1535.0,
        1120.0,
        465.0
      ],
      [
        1535.0,
        1120.0,
        140.0
      ],
      [
        1535.0,
        1120.0,
        100.0
      ],
      [
        1475.0,
        1120.0,
        100.0
      ],
      [
        1475.0,
        1170.0,
        100.0
      ],
      [
        1535.0,
        1170.0,
        100.0
      ],
      [
        1475.0,
        1140.0,
        120.0
      ],
      [
        1535.0,
        1140.0,
        120.0
      ],
      [
        1535.0,
        1120.0,
        120.0
      ],
      [
        1475.0,
        1120.0,
        120.0
      ],
      [
        1475.0,
        1120.0,
        118.0
      ],
      [
        1535.0,
        1120.0,
        118.0
      ],
      [
        1535.0,
        1140.0,
        118.0
      ],
      [
        1475.0,
        1140.0,
        118.0
      ],
      [
        1535.0,
        1120.0,
        140.0
      ],
      [
        1555.0,
        1120.0,
        140.0
      ],
      [
        1455.0,
        1120.0,
        140.0
      ],
      [
        1475.0,
        1120.0,
        140.0
      ],
      [
        1600.0,
        960.0,
        100.0
      ],
      [
        1600.0,
        960.0,
        98.0
      ],
      [
        1630.0,
        960.0,
        120.0
      ],
      [
        1630.0,
        960.0,
        118.0
      ],
      [
        1630.0,
        960.0,
        120.0
      ],
      [
        1650.0,
        960.0,
        120.0
      ],
      [
        1650.0,
        960.0,
        118.0
      ],
      [
        1630.0,
        960.0,
        118.0
      ],
      [
        1650.0,
        987.0,
        118.0
      ],
      [
        1650.0,
        960.0,
        118.0
      ],
      [
        1650.0,
        960.0,
        120.0
      ],
      [
        1660.0,
        987.0,
        118.0
      ],
      [
        1650.0,
        987.0,
        118.0
      ],
      [
        1660.0,
        987.0,
        118.0
      ],
      [
        1660.0,
        1030.0,
        140.0
      ],
      [
        1660.0,
        1030.0,
        138.0
      ],
      [
        1690.0,
        982.5,
        80.0
      ],
      [
        1600.0,
        980.0,
        515.0
      ],
      [
        1600.0,
        980.0,
        140.0
      ],
      [
        1605.0,
        1030.0,
        140.0
      ],
      [
        1600.0,
        1030.0,
        140.0
      ],
      [
        1600.0,
        1030.0,
        465.0
      ],
      [
        1605.0,
        1030.0,
        465.0
      ],
      [
        1600.0,
        1110.0,
        140.0
      ],
      [
        1605.0,
        1110.0,
        140.0
      ],
      [
        1605.0,
        1030.0,
        140.0
      ],
      [
        1600.0,
        1030.0,
        140.0
      ],
      [
        1613.0,
        1110.0,
        140.0
      ],
      [
        1600.0,
        980.0,
        140.0
      ],
      [
        1615.0,
        1110.0,
        140.0
      ],
      [
        1615.0,
        1030.0,
        140.0
      ],
      [
        1605.0,
        1030.0,
        140.0
      ],
      [
        1615.0,
        980.0,
        140.0
      ],
      [
        1600.0,
        980.0,
        140.0
      ],
      [
        1615.0,
        980.0,
        140.0
      ],
      [
        1615.0,
        980.0,
        100.0
      ],
      [
        1600.0,
        980.0,
        100.0
      ],
      [
        1600.0,
        980.0,
        100.0
      ],
      [
        1615.0,
        980.0,
        100.0
      ],
      [
        1615.0,
        970.0,
        80.0
      ],
      [
        1600.0,
        970.0,
        80.0
      ],
      [
        1600.0,
        840.0,
        240.0
      ],
      [
        1770.0,
        840.0,
        240.0
      ],
      [
        1600.0,
        960.0,
        100.0
      ],
      [
        1600.0,
        940.0,
        100.0
      ],
      [
        1600.0,
        920.0,
        80.0
      ],
      [
        1600.0,
        920.0,
        100.0
      ],
      [
        1750.0,
        840.0,
        80.0
      ],
      [
        1750.0,
        840.0,
        100.0
      ],
      [
        1600.0,
        940.0,
        100.0
      ],
      [
        1600.0,
        940.0,
        98.0
      ],
      [
        1720.0,
        940.0,
        98.0
      ],
      [
        1600.0,
        940.0,
        98.0
      ],
      [
        1600.0,
        960.0,
        98.0
      ],
      [
        1720.0,
        940.0,
        100.0
      ],
      [
        1720.0,
        940.0,
        98.0
      ],
      [
        1770.0,
        840.0,
        120.0
      ],
      [
        1770.0,
        840.0,
        118.0
      ],
      [
        1630.0,
        940.0,
        120.0
      ],
      [
        1630.0,
        940.0,
        118.0
      ],
      [
        1750.0,
        810.0,
        80.0
      ],
      [
        1750.0,
        810.0,
        100.0
      ],
      [
        1673.333251953125,
        690.0,
        258.0
      ],
      [
        1770.0,
        690.0,
        258.0
      ],
      [
        1673.333251953125,
        690.0,
        338.0
      ],
      [
        1673.333251953125,
        690.0,
        258.0
      ],
      [
        1690.0,
        690.0,
        245.33334350585938
      ],
      [
        1700.0,
        690.0,
        245.33334350585938
      ],
      [
        1740.0,
        690.0,
        245.33334350585938
      ],
      [
        1750.0,
        690.0,
        245.33334350585938
      ],
      [
        1700.0,
        690.0,
        258.0
      ],
      [
        1700.0,
        690.0,
        245.33334350585938
      ],
      [
        1690.0,
        690.0,
        245.33334350585938
      ],
      [
        1690.0,
        690.0,
        258.0
      ],
      [
        1750.0,
        690.0,
        258.0
      ],
      [
        1750.0,
        690.0,
        245.33334350585938
      ],
      [
        1740.0,
        690.0,
        245.33334350585938
      ],
      [
        1740.0,
        690.0,
        258.0
      ],
      [
        1530.0,
        960.0,
        100.0
      ],
      [
        1530.0,
        960.0,
        98.0
      ],
      [
        1564.9998779296875,
        1030.0,
        140.0
      ],
      [
        1564.9998779296875,
        1030.0,
        465.0
      ],
      [
        1557.0,
        1110.0,
        140.0
      ],
      [
        1600.0,
        1030.0,
        140.0
      ],
      [
        1565.0,
        1030.0,
        140.0
      ],
      [
        1570.0,
        980.0,
        140.0
      ],
      [
        1570.0,
        980.0,
        140.0
      ],
      [
        1570.0,
        980.0,
        100.0
      ],
      [
        1570.0,
        980.0,
        100.0
      ],
      [
        1598.9998779296875,
        970.0,
        80.0
      ],
      [
        1571.0,
        970.0,
        80.0
      ],
      [
        1530.0,
        1030.0,
        140.0
      ],
      [
        1530.0,
        1030.0,
        465.0
      ],
      [
        1530.0,
        1110.0,
        140.0
      ],
      [
        1535.0,
        1110.0,
        140.0
      ],
      [
        1535.0,
        1030.0,
        140.0
      ],
      [
        1530.0,
        1030.0,
        140.0
      ],
      [
        1535.0,
        980.0,
        140.0
      ],
      [
        1535.0,
        980.0,
        140.0
      ],
      [
        1535.0,
        980.0,
        100.0
      ],
      [
        1535.0,
        980.0,
        100.0
      ],
      [
        1535.0,
        970.0,
        80.0
      ],
      [
        1555.0,
        1110.0,
        140.0
      ],
      [
        1565.0,
        1030.0,
        140.0
      ],
      [
        1555.0,
        1030.0,
        140.0
      ],
      [
        1555.0,
        980.0,
        140.0
      ],
      [
        1555.0,
        980.0,
        140.0
      ],
      [
        1555.0,
        980.0,
        100.0
      ],
      [
        1555.0,
        980.0,
        100.0
      ],
      [
        1555.0,
        970.0,
        80.0
      ],
      [
        1530.0,
        940.0,
        100.0
      ],
      [
        1530.0,
        940.0,
        98.0
      ],
      [
        1530.0,
        840.0,
        220.0
      ],
      [
        1550.0,
        840.0,
        160.0
      ],
      [
        1550.0,
        840.0,
        135.0
      ],
      [
        1550.0,
        840.0,
        160.0
      ],
      [
        1550.0,
        840.0,
        135.0
      ],
      [
        1572.0,
        883.0,
        135.0
      ],
      [
        1578.0,
        883.0,
        135.0
      ],
      [
        1572.0,
        884.0,
        135.0
      ],
      [
        1578.0,
        884.0,
        135.0
      ],
      [
        1572.0,
        884.0,
        135.0
      ],
      [
        1572.0,
        883.0,
        135.0
      ],
      [
        1578.0,
        883.0,
        135.0
      ],
      [
        1578.0,
        884.0,
        135.0
      ],
      [
        1572.0,
        866.5,
        135.0
      ],
      [
        1578.0,
        866.5,
        135.0
      ],
      [
        1572.0,
        867.5,
        135.0
      ],
      [
        1578.0,
        867.5,
        135.0
      ],
      [
        1572.0,
        867.5,
        135.0
      ],
      [
        1572.0,
        866.5,
        135.0
      ],
      [
        1578.0,
        866.5,
        135.0
      ],
      [
        1578.0,
        867.5,
        135.0
      ],
      [
        1530.0,
        960.0,
        100.0
      ],
      [
        1530.0,
        940.0,
        100.0
      ],
      [
        1530.0,
        940.0,
        98.0
      ],
      [
        1530.0,
        960.0,
        98.0
      ],
      [
        1562.5999755859375,
        760.0,
        220.0
      ],
      [
        1562.5999755859375,
        840.0,
        220.0
      ],
      [
        1562.5999755859375,
        760.0,
        135.0
      ],
      [
        1562.5999755859375,
        760.0,
        160.0
      ],
      [
        1562.5999755859375,
        760.0,
        135.0
      ],
      [
        1562.5999755859375,
        760.0,
        80.0
      ],
      [
        1562.5999755859375,
        760.0,
        220.0
      ],
      [
        1562.5999755859375,
        760.0,
        160.0
      ],
      [
        1562.5999755859375,
        810.0,
        160.0
      ],
      [
        1562.5999755859375,
        840.0,
        160.0
      ],
      [
        1562.5999755859375,
        810.0,
        135.0
      ],
      [
        1562.5999755859375,
        840.0,
        135.0
      ],
      [
        1560.0,
        810.0,
        135.0
      ],
      [
        1560.0,
        830.0,
        135.0
      ],
      [
        1550.0,
        830.0,
        135.0
      ],
      [
        1560.0,
        830.0,
        135.0
      ],
      [
        1562.5999755859375,
        810.0,
        160.0
      ],
      [
        1562.5999755859375,
        810.0,
        135.0
      ],
      [
        1562.5999755859375,
        720.0,
        135.0
      ],
      [
        1562.5999755859375,
        725.0,
        135.0
      ],
      [
        1562.5999755859375,
        725.0,
        135.0
      ],
      [
        1562.5999755859375,
        760.0,
        135.0
      ],
      [
        1562.5999755859375,
        760.0,
        135.0
      ],
      [
        1562.5999755859375,
        725.0,
        135.0
      ],
      [
        1562.5999755859375,
        720.0,
        110.0
      ],
      [
        1562.5999755859375,
        725.0,
        110.0
      ],
      [
        1562.5999755859375,
        720.0,
        105.0
      ],
      [
        1562.5999755859375,
        725.0,
        105.0
      ],
      [
        1535.0,
        720.0,
        110.0
      ],
      [
        1562.5999755859375,
        725.0,
        105.0
      ],
      [
        1562.5999755859375,
        725.0,
        110.0
      ],
      [
        1562.5999755859375,
        720.0,
        105.0
      ],
      [
        1562.5999755859375,
        720.0,
        110.0
      ],
      [
        1562.5999755859375,
        725.0,
        130.0
      ],
      [
        1562.5999755859375,
        720.0,
        130.0
      ],
      [
        1535.0,
        720.0,
        130.0
      ],
      [
        1535.0,
        720.0,
        135.0
      ],
      [
        1562.5999755859375,
        725.0,
        135.0
      ],
      [
        1562.5999755859375,
        725.0,
        130.0
      ],
      [
        1562.5999755859375,
        720.0,
        130.0
      ],
      [
        1562.5999755859375,
        720.0,
        135.0
      ],
      [
        1381.503662109375,
        960.0,
        261.6824645996094
      ],
      [
        1381.503662109375,
        960.0,
        160.0
      ],
      [
        1411.0897216796875,
        969.1033325195312,
        140.0
      ],
      [
        1411.0897216796875,
        969.1033325195312,
        515.0
      ],
      [
        1439.7935791015625,
        977.935302734375,
        515.0
      ],
      [
        1439.7935791015625,
        977.935302734375,
        140.0
      ],
      [
        1445.0001220703125,
        1030.0,
        140.0
      ],
      [
        1405.0,
        1030.0,
        140.0
      ],
      [
        1405.0,
        1030.0,
        465.0
      ],
      [
        1445.0001220703125,
        1030.0,
        465.0
      ],
      [
        1397.0,
        1110.0,
        140.0
      ],
      [
        1453.0,
        1110.0,
        140.0
      ],
      [
        1445.0001220703125,
        1030.0,
        140.0
      ],
      [
        1405.0,
        1030.0,
        140.0
      ],
      [
        1411.0897216796875,
        969.1033325195312,
        140.0
      ],
      [
        1439.7935791015625,
        977.935302734375,
        140.0
      ],
      [
        1440.0001220703125,
        980.0,
        140.0
      ],
      [
        1410.0,
        980.0,
        140.0
      ],
      [
        1410.0,
        980.0,
        140.0
      ],
      [
        1440.0001220703125,
        980.0,
        140.0
      ],
      [
        1440.0001220703125,
        980.0,
        100.0
      ],
      [
        1410.0,
        980.0,
        100.0
      ],
      [
        1410.0,
        980.0,
        100.0
      ],
      [
        1440.0001220703125,
        980.0,
        100.0
      ],
      [
        1439.7935791015625,
        977.935302734375,
        95.87065124511719
      ],
      [
        1414.0037841796875,
        970.0,
        80.0
      ],
      [
        1411.0001220703125,
        970.0,
        80.0
      ],
      [
        1488.70166015625,
        992.9840087890625,
        140.0
      ],
      [
        1488.70166015625,
        992.9839477539062,
        515.0
      ],
      [
        1522.333251953125,
        1003.3321533203125,
        515.0
      ],
      [
        1522.333251953125,
        1003.3321533203125,
        140.0
      ],
      [
        1525.0001220703125,
        1030.0,
        140.0
      ],
      [
        1485.0,
        1030.0,
        140.0
      ],
      [
        1485.0,
        1030.0,
        465.0
      ],
      [
        1525.0001220703125,
        1030.0,
        465.0
      ],
      [
        1477.0,
        1110.0,
        140.0
      ],
      [
        1525.0,
        1110.0,
        140.0
      ],
      [
        1525.0,
        1030.0,
        140.0
      ],
      [
        1485.0,
        1030.0,
        140.0
      ],
      [
        1530.0,
        1079.999755859375,
        140.0
      ],
      [
        1522.333251953125,
        1003.3321533203125,
        140.0
      ],
      [
        1488.7015380859375,
        992.9839477539062,
        140.0
      ],
      [
        1530.0,
        1030.0,
        140.0
      ],
      [
        1525.0,
        1030.0,
        140.0
      ],
      [
        1530.0,
        1005.691162109375,
        140.0
      ],
      [
        1455.0,
        1110.0,
        140.0
      ],
      [
        1455.0,
        1030.0,
        140.0
      ],
      [
        1445.0001220703125,
        1030.0,
        140.0
      ],
      [
        1455.0,
        982.6141967773438,
        140.0
      ],
      [
        1446.5037841796875,
        980.0,
        140.0
      ],
      [
        1446.5037841796875,
        980.0,
        140.0
      ],
      [
        1446.5037841796875,
        980.0,
        100.0
      ],
      [
        1446.5037841796875,
        980.0,
        100.0
      ],
      [
        1475.0,
        1110.0,
        140.0
      ],
      [
        1485.0,
        1030.0,
        140.0
      ],
      [
        1475.0,
        1030.0,
        140.0
      ],
      [
        1475.0,
        988.76806640625,
        140.0
      ],
      [
        1395.0,
        964.1527099609375,
        160.0
      ],
      [
        1395.0,
        964.1527099609375,
        161.1999969482422
      ],
      [
        1395.0,
        1110.0,
        140.0
      ],
      [
        1405.0,
        1030.0,
        140.0
      ],
      [
        1395.0,
        1030.0,
        140.0
      ],
      [
        1395.0,
        980.0,
        140.0
      ],
      [
        1395.0,
        980.0,
        140.0
      ],
      [
        1395.0,
        980.0,
        100.0
      ],
      [
        1395.0,
        980.0,
        100.0
      ],
      [
        1395.0,
        970.0,
        80.0
      ],
      [
        1250.0,
        1050.0,
        330.10211181640625
      ],
      [
        1250.0,
        1050.0,
        160.0
      ],
      [
        1380.0,
        1050.0,
        140.0
      ],
      [
        1380.0,
        1050.0,
        140.0
      ],
      [
        1380.0,
        1050.0,
        130.6666717529297
      ],
      [
        1380.0,
        1050.0,
        110.66666412353516
      ],
      [
        1380.0,
        1050.0,
        130.6666717529297
      ],
      [
        1380.0,
        1050.0,
        110.66666412353516
      ],
      [
        1380.0,
        1050.0,
        90.66666412353516
      ],
      [
        1390.0,
        1110.0,
        140.0
      ],
      [
        1390.0,
        1050.0,
        140.0
      ],
      [
        1380.0,
        1050.0,
        140.0
      ],
      [
        1395.0,
        1050.0,
        140.0
      ],
      [
        1250.0,
        1040.0,
        283.118408203125
      ],
      [
        1250.0,
        1040.0,
        160.0
      ],
      [
        1380.0,
        1040.0,
        140.0
      ],
      [
        1347.5,
        960.0,
        140.0
      ],
      [
        1381.503662109375,
        960.0,
        160.0
      ],
      [
        1381.4197998046875,
        960.0,
        161.1999969482422
      ],
      [
        1390.0,
        962.6142578125,
        161.1999969482422
      ],
      [
        1381.5037841796875,
        960.0,
        161.1999969482422
      ],
      [
        1381.4197998046875,
        960.0,
        160.0
      ],
      [
        1381.5037841796875,
        960.0,
        160.0
      ],
      [
        1390.0,
        962.6142578125,
        160.0
      ],
      [
        1347.5,
        960.0,
        140.0
      ],
      [
        1370.0,
        966.923095703125,
        120.0
      ],
      [
        1347.5,
        960.0,
        120.0
      ],
      [
        1360.0,
        963.8461303710938,
        100.0
      ],
      [
        1347.5,
        960.0,
        100.0
      ],
      [
        1347.5,
        960.0,
        120.0
      ],
      [
        1370.0,
        966.923095703125,
        120.0
      ],
      [
        1347.5,
        960.0,
        100.0
      ],
      [
        1360.0,
        963.8461303710938,
        100.0
      ],
      [
        1350.0,
        960.7692260742188,
        80.0
      ],
      [
        1347.5,
        960.0,
        80.0
      ],
      [
        1380.0,
        1040.0,
        140.0
      ],
      [
        1380.0,
        1040.0,
        129.33334350585938
      ],
      [
        1380.0,
        1040.0,
        109.33332824707031
      ],
      [
        1380.0,
        1040.0,
        129.33334350585938
      ],
      [
        1380.0,
        1040.0,
        109.33332824707031
      ],
      [
        1380.0,
        1040.0,
        89.33332824707031
      ],
      [
        1390.0,
        980.0,
        140.0
      ],
      [
        1380.0,
        1040.0,
        140.0
      ],
      [
        1390.0,
        1040.0,
        140.0
      ],
      [
        1390.0,
        980.0,
        140.0
      ],
      [
        1390.0,
        980.0,
        100.0
      ],
      [
        1390.0,
        980.0,
        100.0
      ],
      [
        1390.0,
        970.0,
        80.0
      ],
      [
        1395.0,
        1040.0,
        140.0
      ],
      [
        1390.0,
        962.6142578125,
        160.0
      ],
      [
        1395.0,
        964.1527099609375,
        160.0
      ],
      [
        1395.0,
        964.1527099609375,
        161.1999969482422
      ],
      [
        1390.0,
        962.6142578125,
        161.1999969482422
      ],
      [
        1490.0,
        980.0,
        140.0
      ],
      [
        1520.0,
        980.0,
        140.0
      ],
      [
        1520.0,
        980.0,
        100.0
      ],
      [
        1490.0,
        980.0,
        100.0
      ],
      [
        1520.0,
        980.0,
        140.0
      ],
      [
        1490.0,
        980.0,
        140.0
      ],
      [
        1488.7015380859375,
        992.9839477539062,
        140.0
      ],
      [
        1522.333251953125,
        1003.3321533203125,
        140.0
      ],
      [
        1490.0,
        980.0,
        100.0
      ],
      [
        1520.0,
        980.0,
        100.0
      ],
      [
        1519.0001220703125,
        970.0,
        80.0
      ],
      [
        1491.0,
        970.0,
        80.0
      ],
      [
        1439.0,
        970.0,
        80.0
      ],
      [
        1439.7935791015625,
        977.935302734375,
        95.87065124511719
      ],
      [
        1390.0,
        960.0,
        160.0
      ],
      [
        1395.0,
        960.0,
        160.0
      ],
      [
        1390.0,
        960.0,
        160.0
      ],
      [
        1395.0,
        960.0,
        161.1999969482422
      ],
      [
        1390.0,
        960.0,
        161.1999969482422
      ],
      [
        1390.0,
        960.0,
        161.1999969482422
      ],
      [
        1395.0,
        960.0,
        160.0
      ],
      [
        1395.0,
        960.0,
        161.1999969482422
      ],
      [
        1250.0,
        919.5372924804688,
        250.84054565429688
      ],
      [
        1250.0,
        919.5372924804688,
        160.0
      ],
      [
        1250.0,
        919.5852661132812,
        160.0
      ],
      [
        1250.0,
        919.5372924804688,
        160.0
      ],
      [
        1381.5037841796875,
        960.0,
        160.0
      ],
      [
        1250.0,
        919.5372924804688,
        161.1999969482422
      ],
      [
        1250.0,
        919.5852661132812,
        161.1999969482422
      ],
      [
        1381.5037841796875,
        960.0,
        161.1999969482422
      ],
      [
        1250.0,
        919.5372924804688,
        160.0
      ],
      [
        1330.0,
        944.1526489257812,
        98.0
      ],
      [
        1380.0,
        959.5372924804688,
        98.0
      ],
      [
        1250.0,
        919.5372924804688,
        98.0
      ],
      [
        1330.0,
        944.1526489257812,
        98.0
      ],
      [
        1380.0,
        959.5372924804688,
        98.0
      ],
      [
        1381.5037841796875,
        960.0,
        98.0
      ],
      [
        1380.0,
        959.5372924804688,
        100.0
      ],
      [
        1330.0,
        944.1526489257812,
        100.0
      ],
      [
        1250.0,
        919.5372924804688,
        100.0
      ],
      [
        1330.0,
        944.1526489257812,
        100.0
      ],
      [
        1380.0,
        959.5372924804688,
        100.0
      ],
      [
        1381.5037841796875,
        960.0,
        100.0
      ],
      [
        1281.0,
        845.0,
        179.49993896484375
      ],
      [
        1299.0,
        845.0,
        170.49998474121094
      ],
      [
        1250.0,
        914.8063354492188,
        160.0
      ],
      [
        1250.0,
        914.8063354492188,
        161.1999969482422
      ],
      [
        1395.0,
        959.397216796875,
        160.0
      ],
      [
        1250.0,
        914.8063354492188,
        160.0
      ],
      [
        1395.0,
        959.397216796875,
        161.1999969482422
      ],
      [
        1250.0,
        914.8063354492188,
        161.1999969482422
      ],
      [
        1395.0,
        959.397216796875,
        160.0
      ],
      [
        1395.0,
        959.397216796875,
        161.1999969482422
      ],
      [
        1330.0,
        939.408203125,
        98.0
      ],
      [
        1380.0,
        954.784423828125,
        98.0
      ],
      [
        1250.0,
        914.8063354492188,
        98.0
      ],
      [
        1330.0,
        939.408203125,
        98.0
      ],
      [
        1380.0,
        954.784423828125,
        98.0
      ],
      [
        1396.9600830078125,
        960.0,
        98.0
      ],
      [
        1380.0,
        954.784423828125,
        100.0
      ],
      [
        1330.0,
        939.408203125,
        100.0
      ],
      [
        1250.0,
        914.8063354492188,
        100.0
      ],
      [
        1330.0,
        939.408203125,
        100.0
      ],
      [
        1380.0,
        954.784423828125,
        100.0
      ],
      [
        1396.9600830078125,
        960.0,
        100.0
      ],
      [
        1480.0,
        950.7692260742188,
        100.0
      ],
      [
        1445.0,
        940.0,
        100.0
      ],
      [
        1445.0,
        940.0,
        98.0
      ],
      [
        1480.0,
        950.7692260742188,
        98.0
      ],
      [
        1445.0,
        940.0,
        98.0
      ],
      [
        1445.0,
        940.0,
        100.0
      ],
      [
        1480.0,
        960.0,
        100.0
      ],
      [
        1480.0,
        960.0,
        98.0
      ],
      [
        1500.0,
        720.0,
        100.0
      ],
      [
        1500.0,
        720.0,
        98.0
      ],
      [
        1500.0,
        720.0,
        98.0
      ],
      [
        1500.0,
        720.0,
        100.0
      ],
      [
        1520.0,
        904.0,
        98.0
      ],
      [
        1510.0,
        904.0,
        98.0
      ],
      [
        1520.0,
        904.0,
        98.0
      ],
      [
        1510.0,
        904.0,
        98.0
      ],
      [
        1520.0,
        930.0,
        83.00000762939453
      ],
      [
        1510.0,
        930.0,
        83.00000762939453
      ],
      [
        1394.0,
        700.0,
        98.0
      ],
      [
        1394.0,
        700.0,
        98.0
      ],
      [
        1394.0,
        690.0,
        98.0
      ],
      [
        1394.0,
        690.0,
        98.0
      ],
      [
        1190.468017578125,
        707.730224609375,
        80.0
      ],
      [
        794.298828125,
        707.730224609375,
        118.0
      ],
      [
        794.298828125,
        707.730224609375,
        120.0
      ],
      [
        1200.0,
        1120.0,
        120.0
      ],
      [
        1200.0,
        1120.0,
        118.0
      ],
      [
        1200.0,
        930.0,
        118.0
      ],
      [
        1200.0,
        930.0,
        120.0
      ],
      [
        1200.0,
        930.0,
        120.0
      ],
      [
        1200.0,
        930.0,
        118.0
      ],
      [
        1010.0,
        930.0,
        118.0
      ],
      [
        1010.0,
        930.0,
        120.0
      ],
      [
        1000.0,
        930.0,
        120.0
      ],
      [
        1000.0,
        930.0,
        118.0
      ],
      [
        1014.1600952148438,
        867.8525390625,
        118.0
      ],
      [
        1200.0,
        867.8525390625,
        118.0
      ],
      [
        1190.0,
        825.0,
        118.0
      ],
      [
        1190.0,
        707.730224609375,
        118.0
      ],
      [
        926.1368408203125,
        867.8525390625,
        120.0
      ],
      [
        926.1368408203125,
        867.8525390625,
        118.0
      ],
      [
        1113.0,
        887.8524780273438,
        118.0
      ],
      [
        1200.0,
        887.8524780273438,
        120.0
      ],
      [
        1200.0,
        887.8524780273438,
        118.0
      ],
      [
        946.1367797851562,
        887.8524780273438,
        120.0
      ],
      [
        946.1367797851562,
        887.8524780273438,
        118.0
      ],
      [
        1000.0,
        887.8524780273438,
        120.0
      ],
      [
        1000.0,
        887.8524780273438,
        118.0
      ],
      [
        1113.0,
        887.8524780273438,
        118.0
      ],
      [
        1113.0,
        900.0,
        118.0
      ],
      [
        1113.0,
        900.0,
        118.0
      ],
      [
        1235.0,
        867.8525390625,
        120.0
      ],
      [
        1200.0,
        867.8525390625,
        118.0
      ],
      [
        1235.0,
        867.8525390625,
        118.0
      ],
      [
        1235.0,
        1120.0,
        100.0
      ],
      [
        1235.0,
        930.0,
        80.0
      ],
      [
        1235.0,
        880.0,
        80.0
      ],
      [
        1235.0,
        867.8525390625,
        98.77336120605469
      ],
      [
        1235.0,
        867.8525390625,
        98.77336120605469
      ],
      [
        1235.0,
        920.0,
        100.0
      ],
      [
        1235.0,
        920.0,
        98.0
      ],
      [
        1235.0,
        920.0,
        98.0
      ],
      [
        1235.0,
        900.0,
        98.0
      ],
      [
        1235.0,
        900.0,
        100.0
      ],
      [
        1235.0,
        920.0,
        100.0
      ],
      [
        1137.0,
        900.0,
        100.0
      ],
      [
        1125.0,
        900.0,
        98.0
      ],
      [
        1235.0,
        900.0,
        98.0
      ],
      [
        1235.0,
        900.0,
        100.0
      ],
      [
        1125.0,
        910.0,
        98.0
      ],
      [
        1137.0,
        887.8524780273438,
        100.0
      ],
      [
        1095.0,
        910.0,
        84.0000228881836
      ],
      [
        1095.0,
        900.0,
        84.0000228881836
      ],
      [
        854.0377807617188,
        707.730224609375,
        140.0
      ],
      [
        1060.0,
        707.730224609375,
        140.0
      ],
      [
        1020.4000244140625,
        940.4000244140625,
        140.0
      ],
      [
        1189.5999755859375,
        940.4000244140625,
        140.0
      ],
      [
        1189.5999755859375,
        940.4000244140625,
        140.0
      ],
      [
        1189.5999755859375,
        1109.5999755859375,
        140.0
      ],
      [
        1189.5999755859375,
        970.0000610351562,
        140.0
      ],
      [
        1189.199951171875,
        970.4000244140625,
        140.0
      ],
      [
        1050.0,
        940.4000244140625,
        140.0
      ],
      [
        1050.4000244140625,
        940.7999877929688,
        140.0
      ],
      [
        1200.0,
        940.0,
        130.0
      ],
      [
        1199.199951171875,
        940.4000244140625,
        140.0
      ],
      [
        1199.199951171875,
        960.4000244140625,
        140.0
      ],
      [
        1199.199951171875,
        960.4000244140625,
        140.0
      ],
      [
        1163.3333740234375,
        936.6666870117188,
        140.0
      ],
      [
        1046.6666259765625,
        936.6666870117188,
        140.0
      ],
      [
        1046.2667236328125,
        936.6666870117188,
        140.0
      ],
      [
        1199.199951171875,
        936.6666870117188,
        140.0
      ],
      [
        1010.7999877929688,
        930.7999877929688,
        140.0
      ],
      [
        1040.4000244140625,
        930.7999877929688,
        140.0
      ],
      [
        1169.5999755859375,
        930.7999877929688,
        140.0
      ],
      [
        1199.199951171875,
        930.7999877929688,
        140.0
      ],
      [
        1040.4000244140625,
        930.7999877929688,
        140.0
      ],
      [
        1199.199951171875,
        930.7999877929688,
        140.0
      ],
      [
        1060.0,
        707.730224609375,
        140.0
      ],
      [
        1060.0,
        825.0,
        140.0
      ],
      [
        1014.1600952148438,
        867.8525390625,
        140.0
      ],
      [
        1024.16015625,
        867.8525390625,
        140.0
      ],
      [
        1060.0,
        867.8525390625,
        140.0
      ],
      [
        1024.16015625,
        867.8525390625,
        140.0
      ],
      [
        1060.0,
        867.8525390625,
        135.0
      ],
      [
        1060.0,
        867.8525390625,
        120.0
      ],
      [
        1060.0,
        867.8525390625,
        135.0
      ],
      [
        1142.5,
        867.8525390625,
        140.0
      ],
      [
        1200.0,
        867.8525390625,
        140.0
      ],
      [
        1107.5,
        867.8525390625,
        140.0
      ],
      [
        1200.0,
        867.8525390625,
        140.0
      ],
      [
        1200.0,
        825.0,
        140.0
      ],
      [
        1107.5,
        867.8525390625,
        140.0
      ],
      [
        1107.5,
        825.0,
        140.0
      ],
      [
        1100.0,
        747.730224609375,
        140.0
      ],
      [
        1150.0,
        747.730224609375,
        140.0
      ],
      [
        1150.0,
        747.730224609375,
        140.0
      ],
      [
        1150.0,
        785.0,
        140.0
      ],
      [
        766.0144653320312,
        707.730224609375,
        140.0
      ],
      [
        766.0144653320312,
        707.730224609375,
        220.0
      ],
      [
        766.0144653320312,
        707.730224609375,
        220.0
      ],
      [
        762.6031494140625,
        707.730224609375,
        232.14804077148438
      ],
      [
        926.1367797851562,
        867.8525390625,
        220.0
      ],
      [
        831.906494140625,
        867.8525390625,
        555.5635375976562
      ],
      [
        926.1367797851562,
        867.8525390625,
        140.0
      ],
      [
        926.1367797851562,
        867.8525390625,
        220.0
      ],
      [
        1190.0,
        737.730224609375,
        195.0
      ],
      [
        1160.0,
        707.730224609375,
        195.0
      ],
      [
        1150.0,
        825.0,
        195.0
      ],
      [
        1150.0,
        785.0,
        195.0
      ],
      [
        1170.0,
        749.0,
        190.0
      ],
      [
        1150.0,
        825.0,
        190.0
      ],
      [
        1150.0,
        785.0,
        190.0
      ],
      [
        1170.0,
        749.0,
        190.0
      ],
      [
        1170.0,
        770.0,
        190.0
      ],
      [
        1240.0,
        916.4603881835938,
        161.1999969482422
      ],
      [
        1250.0,
        919.5372924804688,
        161.1999969482422
      ],
      [
        1240.0,
        916.4603881835938,
        160.0
      ],
      [
        1250.0,
        919.5372924804688,
        160.0
      ],
      [
        1189.5999755859375,
        950.0,
        140.0
      ],
      [
        1171.9998779296875,
        957.0,
        580.0
      ],
      [
        1189.5999755859375,
        970.0000610351562,
        140.0
      ],
      [
        1055.0,
        950.0,
        255.0000762939453
      ],
      [
        1199.199951171875,
        950.0,
        140.0
      ],
      [
        1199.199951171875,
        940.4000244140625,
        140.0
      ],
      [
        1050.0,
        940.4000244140625,
        140.0
      ],
      [
        998.6842041015625,
        940.3999633789062,
        140.0
      ],
      [
        1001.8842163085938,
        943.5999755859375,
        220.0
      ],
      [
        1001.8842163085938,
        943.5999755859375,
        220.0
      ],
      [
        995.8233032226562,
        944.6067504882812,
        245.16859436035156
      ],
      [
        989.084228515625,
        930.7999877929688,
        140.0
      ],
      [
        995.4842529296875,
        937.2000122070312,
        220.0
      ],
      [
        995.4842529296875,
        937.2000122070312,
        220.0
      ],
      [
        986.7498168945312,
        940.6796264648438,
        263.4952392578125
      ],
      [
        958.2842407226562,
        900.0,
        220.0
      ],
      [
        950.0,
        900.0,
        249.50100708007812
      ],
      [
        950.0,
        924.7737426757812,
        337.72265625
      ],
      [
        958.2842407226562,
        900.0,
        140.0
      ],
      [
        958.2842407226562,
        900.0,
        220.0
      ],
      [
        892.7614135742188,
        900.0,
        453.3333435058594
      ],
      [
        410.03387451171875,
        750.0,
        360.0
      ],
      [
        410.03387451171875,
        750.0,
        460.0
      ],
      [
        559.7156982421875,
        750.0,
        81.70327758789062
      ],
      [
        553.146240234375,
        750.0,
        80.0
      ],
      [
        550.0,
        746.853759765625,
        80.0
      ],
      [
        550.0,
        739.7156982421875,
        81.85070037841797
      ],
      [
        550.0,
        739.7156982421875,
        81.85070037841797
      ],
      [
        550.0,
        739.7156982421875,
        80.0
      ],
      [
        560.8578491210938,
        719.1421508789062,
        90.0
      ],
      [
        1550.0,
        510.0,
        80.0
      ],
      [
        1570.0,
        510.0,
        80.0
      ],
      [
        1500.0,
        510.0,
        80.0
      ],
      [
        1480.0,
        510.0,
        80.0
      ],
      [
        1683.6575927734375,
        510.0,
        80.0
      ],
      [
        1740.0,
        510.0,
        80.0
      ],
      [
        1250.0,
        510.0,
        76.0
      ],
      [
        1250.0,
        510.0,
        80.0
      ],
      [
        1250.0,
        670.0,
        80.0
      ],
      [
        1250.0,
        510.0,
        76.80000305175781
      ],
      [
        1250.0,
        510.0,
        80.0
      ],
      [
        1250.0,
        670.0,
        80.0
      ],
      [
        1760.0,
        510.0,
        75.99512481689453
      ],
      [
        1770.0,
        510.0,
        75.99349975585938
      ],
      [
        1624.6153564453125,
        510.0,
        75.99512481689453
      ],
      [
        1652.2601318359375,
        510.0,
        75.9950942993164
      ],
      [
        1397.7398681640625,
        510.0,
        75.9950942993164
      ],
      [
        1425.3846435546875,
        510.0,
        75.99512481689453
      ],
      [
        1740.0,
        556.557861328125,
        71.32803344726562
      ],
      [
        1683.6575927734375,
        510.0,
        75.99516296386719
      ],
      [
        1740.0,
        510.0,
        75.99519348144531
      ],
      [
        1740.0,
        556.557861328125,
        71.32803344726562
      ],
      [
        1290.0,
        510.0,
        76.0
      ],
      [
        1270.0,
        510.0,
        76.0
      ],
      [
        1250.0,
        510.0,
        76.0
      ],
      [
        1270.0,
        510.0,
        76.0
      ],
      [
        1290.0,
        599.029052734375,
        67.09709930419922
      ],
      [
        1397.7398681640625,
        510.0,
        75.9950942993164
      ],
      [
        1290.0,
        510.0,
        75.99513244628906
      ],
      [
        1290.0,
        599.029052734375,
        67.09709930419922
      ],
      [
        1652.2601318359375,
        510.0,
        75.9950942993164
      ],
      [
        1760.0,
        599.029052734375,
        67.09709930419922
      ],
      [
        1760.0,
        599.029052734375,
        67.09709930419922
      ],
      [
        1760.0,
        510.0,
        75.99513244628906
      ],
      [
        1740.0,
        556.557861328125,
        71.3442153930664
      ],
      [
        1740.0,
        556.557861328125,
        71.34420776367188
      ],
      [
        1763.599365234375,
        602.0033569335938,
        66.77178955078125
      ],
      [
        1770.0,
        607.2925415039062,
        66.2496337890625
      ],
      [
        1409.9024658203125,
        522.5792846679688,
        74.74208068847656
      ],
      [
        1390.0,
        538.75,
        73.12501525878906
      ],
      [
        1425.3846435546875,
        510.0,
        75.99512481689453
      ],
      [
        1410.0,
        522.5,
        74.75000762939453
      ],
      [
        1390.0,
        538.75,
        73.12501525878906
      ],
      [
        1290.0,
        620.0,
        65.00000762939453
      ],
      [
        1640.097412109375,
        522.5791015625,
        74.74209594726562
      ],
      [
        1660.0,
        538.75,
        73.12501525878906
      ],
      [
        1640.0,
        522.5,
        74.75000762939453
      ],
      [
        1624.6153564453125,
        510.0,
        75.99513244628906
      ],
      [
        1660.0,
        538.75,
        73.12501525878906
      ],
      [
        1760.0,
        620.0,
        65.00000762939453
      ],
      [
        1760.0,
        620.0,
        65.00000762939453
      ],
      [
        1290.0,
        620.0,
        65.00000762939453
      ],
      [
        1410.0,
        522.5792846679688,
        74.74208068847656
      ],
      [
        1409.9024658203125,
        522.5792846679688,
        74.74208068847656
      ],
      [
        1640.097412109375,
        522.5791015625,
        74.74209594726562
      ],
      [
        1640.0,
        522.5791015625,
        74.74209594726562
      ],
      [
        1410.0,
        522.5792846679688,
        74.74208068847656
      ],
      [
        1410.0,
        522.5,
        74.75000762939453
      ],
      [
        1640.0,
        522.5791015625,
        74.74209594726562
      ],
      [
        1640.0,
        522.5,
        74.75000762939453
      ],
      [
        1770.0,
        628.125,
        64.16638946533203
      ],
      [
        1760.0,
        599.029052734375,
        80.0
      ],
      [
        1652.2601318359375,
        510.0,
        80.0
      ],
      [
        1760.0,
        599.029052734375,
        80.0
      ],
      [
        1760.0,
        510.0,
        80.0
      ],
      [
        1740.0,
        556.557861328125,
        80.0
      ],
      [
        1683.6575927734375,
        510.0,
        80.0
      ],
      [
        1740.0,
        510.0,
        80.0
      ],
      [
        1740.0,
        556.557861328125,
        80.0
      ],
      [
        1290.0,
        599.029052734375,
        80.0
      ],
      [
        1397.7398681640625,
        510.0,
        80.0
      ],
      [
        1290.0,
        599.029052734375,
        80.0
      ],
      [
        1290.0,
        510.0,
        80.0
      ],
      [
        1624.6153564453125,
        510.0,
        80.0
      ],
      [
        1640.0,
        522.5,
        80.0
      ],
      [
        1660.0,
        538.75,
        80.0
      ],
      [
        1760.0,
        620.0,
        80.0
      ],
      [
        1410.0,
        522.5,
        80.0
      ],
      [
        1425.3846435546875,
        510.0,
        80.0
      ],
      [
        1390.0,
        538.75,
        80.0
      ],
      [
        1290.0,
        620.0,
        80.0
      ],
      [
        1760.0,
        620.0,
        80.0
      ],
      [
        1290.0,
        620.0,
        80.0
      ],
      [
        1640.0,
        560.0,
        80.0
      ],
      [
        1640.0,
        522.5,
        80.0
      ],
      [
        1410.0,
        560.0,
        80.0
      ],
      [
        1410.0,
        522.5,
        80.0
      ],
      [
        1390.0,
        560.0,
        80.0
      ],
      [
        1390.0,
        538.75,
        80.0
      ],
      [
        1390.0,
        560.0,
        80.0
      ],
      [
        1410.0,
        560.0,
        80.0
      ],
      [
        1660.0,
        538.75,
        80.0
      ],
      [
        1660.0,
        560.0,
        80.0
      ],
      [
        1640.0,
        560.0,
        80.0
      ],
      [
        1660.0,
        560.0,
        80.0
      ],
      [
        1450.0,
        490.0,
        80.0
      ],
      [
        1480.0,
        490.0,
        80.0
      ],
      [
        1570.0,
        490.0,
        80.0
      ],
      [
        1600.0,
        490.0,
        80.0
      ],
      [
        1760.0,
        490.0,
        80.0
      ],
      [
        1628.056884765625,
        490.0,
        80.0
      ],
      [
        1421.943115234375,
        490.0,
        80.0
      ],
      [
        1290.0,
        490.0,
        80.0
      ],
      [
        1570.0,
        490.0,
        79.0
      ],
      [
        1480.0,
        490.0,
        79.0
      ],
      [
        1600.0,
        490.0,
        79.0
      ],
      [
        1624.6153564453125,
        510.0,
        78.0
      ],
      [
        1425.3846435546875,
        510.0,
        78.0
      ],
      [
        1450.0,
        490.0,
        79.0
      ],
      [
        1480.0,
        490.0,
        79.0
      ],
      [
        1570.0,
        490.0,
        79.0
      ],
      [
        1421.943115234375,
        490.0,
        79.0
      ],
      [
        1397.7398681640625,
        510.0,
        78.0
      ],
      [
        1290.0,
        490.0,
        79.0
      ],
      [
        1290.0,
        510.0,
        78.0
      ],
      [
        1628.056884765625,
        490.0,
        79.0
      ],
      [
        1652.2601318359375,
        510.0,
        78.0
      ],
      [
        1760.0,
        490.0,
        79.0
      ],
      [
        1760.0,
        510.0,
        78.0
      ],
      [
        1600.0,
        490.0,
        80.0
      ],
      [
        1450.0,
        490.0,
        80.0
      ],
      [
        1550.0,
        510.0,
        80.0
      ],
      [
        1550.0,
        490.0,
        79.0
      ],
      [
        1550.0,
        490.0,
        80.0
      ],
      [
        1480.0,
        510.0,
        80.0
      ],
      [
        1480.0,
        490.0,
        80.0
      ],
      [
        1500.0,
        510.0,
        80.0
      ],
      [
        1500.0,
        490.0,
        80.0
      ],
      [
        1500.0,
        490.0,
        79.0
      ],
      [
        1570.0,
        510.0,
        80.0
      ],
      [
        1570.0,
        490.0,
        80.0
      ],
      [
        1421.943115234375,
        490.0,
        80.0
      ],
      [
        1290.0,
        490.0,
        80.0
      ],
      [
        1628.056884765625,
        490.0,
        80.0
      ],
      [
        1760.0,
        490.0,
        80.0
      ],
      [
        1562.5999755859375,
        510.0,
        125.0
      ],
      [
        1562.5999755859375,
        510.0,
        118.0
      ],
      [
        1562.5999755859375,
        510.0,
        100.0
      ],
      [
        1562.5999755859375,
        510.0,
        80.0
      ],
      [
        1562.5999755859375,
        510.0,
        107.5
      ],
      [
        1562.5999755859375,
        510.0,
        100.0
      ],
      [
        1562.5999755859375,
        510.0,
        107.5
      ],
      [
        1562.5999755859375,
        510.0,
        118.0
      ],
      [
        1562.5999755859375,
        510.0,
        125.0
      ],
      [
        1562.5999755859375,
        510.0,
        140.0
      ],
      [
        1425.3846435546875,
        510.0,
        80.0
      ],
      [
        1425.3846435546875,
        510.0,
        98.0
      ],
      [
        1425.3846435546875,
        510.0,
        140.0
      ],
      [
        1425.3846435546875,
        510.0,
        80.0
      ],
      [
        1425.3846435546875,
        510.0,
        258.0
      ],
      [
        1425.3846435546875,
        510.0,
        338.0
      ],
      [
        1425.3846435546875,
        510.0,
        140.0
      ],
      [
        1425.3846435546875,
        510.0,
        258.0
      ],
      [
        1480.0,
        510.0,
        338.0
      ],
      [
        1480.0,
        510.0,
        258.0
      ],
      [
        1480.0,
        510.0,
        140.0
      ],
      [
        1480.0,
        510.0,
        258.0
      ],
      [
        1480.0,
        510.0,
        338.0
      ],
      [
        1470.0,
        510.0,
        348.0
      ],
      [
        1425.3846435546875,
        510.0,
        98.0
      ],
      [
        1410.0,
        670.0,
        98.0
      ],
      [
        1410.0,
        650.0,
        98.0
      ],
      [
        1410.0,
        560.0,
        98.0
      ],
      [
        1410.0,
        522.5,
        98.0
      ],
      [
        1465.284423828125,
        669.0,
        105.71559143066406
      ],
      [
        1466.284423828125,
        669.0,
        105.71558380126953
      ],
      [
        1466.284423828125,
        669.0,
        105.71558380126953
      ],
      [
        1466.6986083984375,
        670.0,
        105.30136108398438
      ],
      [
        1462.75,
        657.25,
        110.5826644897461
      ],
      [
        1462.75,
        657.75,
        110.37557220458984
      ],
      [
        1462.25,
        657.25,
        110.5826644897461
      ],
      [
        1462.75,
        657.25,
        110.5826644897461
      ],
      [
        1480.0,
        637.0,
        330.0
      ],
      [
        1450.0,
        637.0,
        330.0
      ],
      [
        1440.0,
        637.0,
        330.0
      ],
      [
        1410.0,
        637.0,
        330.0
      ],
      [
        1423.5,
        668.0,
        323.0
      ],
      [
        1423.5,
        670.0,
        323.0
      ],
      [
        1474.5,
        668.0,
        322.0
      ],
      [
        1466.5,
        668.0,
        317.0
      ],
      [
        1466.5,
        668.0,
        322.0
      ],
      [
        1466.5,
        670.0,
        323.0
      ],
      [
        1466.5,
        668.0,
        323.0
      ],
      [
        1466.5,
        668.0,
        323.0
      ],
      [
        1462.75,
        657.25,
        104.36932373046875
      ],
      [
        1462.75,
        657.75,
        104.16224670410156
      ],
      [
        1462.25,
        657.25,
        104.36932373046875
      ],
      [
        1462.75,
        657.25,
        104.36932373046875
      ],
      [
        1463.3963623046875,
        657.25,
        103.25
      ],
      [
        1464.4788818359375,
        657.25,
        102.75
      ],
      [
        1473.0,
        590.0,
        127.80006408691406
      ],
      [
        1470.0,
        590.0,
        132.0
      ],
      [
        1473.0,
        590.0,
        127.80006408691406
      ],
      [
        1470.0,
        570.0,
        132.0
      ],
      [
        1470.0,
        590.0,
        132.0
      ],
      [
        1480.0,
        605.0,
        125.0
      ],
      [
        1480.0,
        605.0,
        125.0
      ],
      [
        1390.0,
        650.0,
        98.0
      ],
      [
        1390.0,
        670.0,
        98.0
      ],
      [
        1390.0,
        560.0,
        98.0
      ],
      [
        1390.0,
        538.75,
        98.0
      ],
      [
        1390.0,
        560.0,
        98.0
      ],
      [
        1410.0,
        560.0,
        98.0
      ],
      [
        1410.0,
        650.0,
        98.0
      ],
      [
        1390.0,
        650.0,
        98.0
      ],
      [
        1410.0,
        670.0,
        91.0
      ],
      [
        1410.0,
        650.0,
        91.0
      ],
      [
        1390.0,
        650.0,
        91.0
      ],
      [
        1390.0,
        670.0,
        91.0
      ],
      [
        1410.0,
        650.0,
        91.0
      ],
      [
        1390.0,
        650.0,
        91.0
      ],
      [
        1562.5999755859375,
        630.0,
        338.0
      ],
      [
        1562.5999755859375,
        630.0,
        315.1800231933594
      ],
      [
        1562.5999755859375,
        630.0,
        98.0
      ],
      [
        1562.5999755859375,
        630.0,
        90.0
      ],
      [
        1562.5999755859375,
        630.0,
        90.0
      ],
      [
        1562.5999755859375,
        630.0,
        80.0
      ],
      [
        1562.5999755859375,
        630.0,
        100.0
      ],
      [
        1562.5999755859375,
        630.0,
        116.0
      ],
      [
        1562.5999755859375,
        630.0,
        120.0
      ],
      [
        1562.5999755859375,
        630.0,
        98.0
      ],
      [
        1562.5999755859375,
        510.0,
        140.0
      ],
      [
        1562.5999755859375,
        630.0,
        140.0
      ],
      [
        1562.5999755859375,
        520.0,
        100.0
      ],
      [
        1562.5999755859375,
        630.0,
        100.0
      ],
      [
        1562.5999755859375,
        610.0,
        98.0
      ],
      [
        1562.5999755859375,
        628.0,
        98.0
      ],
      [
        1562.5999755859375,
        610.0,
        98.0
      ],
      [
        1562.5999755859375,
        510.0,
        98.0
      ],
      [
        1562.5999755859375,
        610.0,
        80.0
      ],
      [
        1562.5999755859375,
        610.0,
        91.0
      ],
      [
        1562.5999755859375,
        610.0,
        91.0
      ],
      [
        1562.5999755859375,
        610.0,
        98.0
      ],
      [
        1562.5999755859375,
        610.0,
        98.0
      ],
      [
        1562.5999755859375,
        610.0,
        90.0
      ],
      [
        1562.5999755859375,
        610.0,
        90.0
      ],
      [
        1562.5999755859375,
        610.0,
        80.0
      ],
      [
        1562.5999755859375,
        628.0,
        80.0
      ],
      [
        1562.5999755859375,
        628.0,
        90.0
      ],
      [
        1562.5999755859375,
        628.0,
        98.0
      ],
      [
        1562.5999755859375,
        628.0,
        90.0
      ],
      [
        1562.5999755859375,
        520.0,
        116.0
      ],
      [
        1562.5999755859375,
        527.4000244140625,
        116.0
      ],
      [
        1562.5999755859375,
        630.0,
        116.0
      ],
      [
        1562.5999755859375,
        618.8999633789062,
        116.0
      ],
      [
        1562.5999755859375,
        618.8999633789062,
        116.0
      ],
      [
        1562.5999755859375,
        527.4000244140625,
        116.0
      ],
      [
        1562.5999755859375,
        600.0,
        132.0
      ],
      [
        1562.5999755859375,
        607.4000244140625,
        132.0
      ],
      [
        1562.5999755859375,
        520.0,
        132.0
      ],
      [
        1562.5999755859375,
        527.4000244140625,
        132.0
      ],
      [
        1562.5999755859375,
        527.4000244140625,
        132.0
      ],
      [
        1562.5999755859375,
        600.0,
        132.0
      ],
      [
        1562.5999755859375,
        607.4000244140625,
        118.0
      ],
      [
        1562.5999755859375,
        600.0,
        118.0
      ],
      [
        1562.5999755859375,
        527.4000244140625,
        118.0
      ],
      [
        1562.5999755859375,
        520.0,
        118.0
      ],
      [
        1562.5999755859375,
        600.0,
        118.0
      ],
      [
        1562.5999755859375,
        527.4000244140625,
        118.0
      ],
      [
        1480.0,
        602.8571166992188,
        122.0
      ],
      [
        1500.0,
        622.8571166992188,
        122.0
      ],
      [
        1480.0,
        520.0,
        122.0
      ],
      [
        1500.0,
        520.0,
        122.0
      ],
      [
        1550.0,
        622.8571166992188,
        122.0
      ],
      [
        1562.5999755859375,
        610.2571411132812,
        122.0
      ],
      [
        1562.5999755859375,
        607.4000244140625,
        118.0
      ],
      [
        1550.0,
        520.0,
        122.0
      ],
      [
        1562.5999755859375,
        520.0,
        118.0
      ],
      [
        1562.5999755859375,
        520.0,
        122.0
      ],
      [
        1562.5999755859375,
        607.4000244140625,
        132.0
      ],
      [
        1562.5999755859375,
        612.4000244140625,
        125.0
      ],
      [
        1562.5999755859375,
        612.4000244140625,
        125.0
      ],
      [
        1562.5999755859375,
        520.0,
        132.0
      ],
      [
        1540.7142333984375,
        510.0,
        120.00000762939453
      ],
      [
        1509.2857666015625,
        510.0,
        120.00000762939453
      ],
      [
        1558.0,
        629.7440185546875,
        104.5
      ],
      [
        1562.5999755859375,
        630.0,
        104.5
      ],
      [
        1562.5999755859375,
        629.7439575195312,
        104.5
      ],
      [
        1497.800048828125,
        629.2999267578125,
        102.0
      ],
      [
        1480.0,
        629.2999267578125,
        102.0
      ],
      [
        1551.4000244140625,
        625.0,
        102.0
      ],
      [
        1558.0,
        625.0,
        102.0
      ],
      [
        1544.800048828125,
        625.0,
        102.0
      ],
      [
        1551.4000244140625,
        625.0,
        102.0
      ],
      [
        1562.5999755859375,
        627.0,
        104.5
      ],
      [
        1562.5999755859375,
        627.0,
        104.0
      ],
      [
        1562.5999755859375,
        627.0,
        104.5
      ],
      [
        1562.5999755859375,
        520.0,
        100.0
      ],
      [
        1562.5999755859375,
        520.0,
        107.5
      ],
      [
        1562.5999755859375,
        520.0,
        107.5
      ],
      [
        1562.5999755859375,
        520.0,
        116.0
      ],
      [
        1487.071044921875,
        597.071044921875,
        105.0
      ],
      [
        1487.928955078125,
        595.0,
        100.0
      ],
      [
        1487.928955078125,
        595.0,
        105.0
      ],
      [
        1487.928955078125,
        595.0,
        116.0
      ],
      [
        1562.5999755859375,
        536.27685546875,
        116.0
      ],
      [
        1562.5999755859375,
        536.27685546875,
        100.0
      ],
      [
        1562.5999755859375,
        523.72314453125,
        116.0
      ],
      [
        1562.5999755859375,
        523.72314453125,
        100.0
      ],
      [
        1502.35302734375,
        523.80712890625,
        103.0
      ],
      [
        1502.35302734375,
        523.80712890625,
        112.0
      ],
      [
        1547.6470947265625,
        523.8072509765625,
        112.0
      ],
      [
        1547.6470947265625,
        523.8072509765625,
        103.0
      ],
      [
        1562.5999755859375,
        630.0,
        160.0
      ],
      [
        1562.5999755859375,
        590.0,
        160.0
      ],
      [
        1562.5999755859375,
        590.0,
        150.0
      ],
      [
        1562.5999755859375,
        590.0,
        140.0
      ],
      [
        1562.5999755859375,
        590.0,
        160.0
      ],
      [
        1562.5999755859375,
        590.0,
        150.0
      ],
      [
        1480.0,
        600.0,
        317.0
      ],
      [
        1562.5999755859375,
        600.0,
        338.0
      ],
      [
        1562.5999755859375,
        600.0,
        317.0
      ],
      [
        1562.5999755859375,
        630.0,
        315.1800231933594
      ],
      [
        1562.5999755859375,
        600.0,
        315.1800231933594
      ],
      [
        1562.5999755859375,
        600.0,
        315.1800231933594
      ],
      [
        1562.5999755859375,
        630.0,
        160.0
      ],
      [
        1562.5999755859375,
        651.2188720703125,
        160.0
      ],
      [
        1562.5999755859375,
        651.2188720703125,
        120.0
      ],
      [
        1562.5999755859375,
        630.0,
        120.0
      ],
      [
        1562.5999755859375,
        651.2188720703125,
        140.0
      ],
      [
        1562.5999755859375,
        651.2188720703125,
        120.0
      ],
      [
        1562.5999755859375,
        651.2188720703125,
        140.0
      ],
      [
        1562.5999755859375,
        651.2188720703125,
        160.0
      ],
      [
        1397.7398681640625,
        510.0,
        88.0
      ],
      [
        1397.7398681640625,
        510.0,
        80.0
      ],
      [
        1290.0,
        510.0,
        88.0
      ],
      [
        1305.0,
        510.0,
        88.0
      ],
      [
        1397.7398681640625,
        510.0,
        88.0
      ],
      [
        1374.1917724609375,
        510.0,
        88.0
      ],
      [
        1374.1917724609375,
        510.0,
        88.0
      ],
      [
        1371.052001953125,
        510.0,
        98.0
      ],
      [
        1307.0,
        510.0,
        98.0
      ],
      [
        1371.052001953125,
        510.0,
        98.0
      ],
      [
        1305.0,
        560.6896362304688,
        88.0
      ],
      [
        1307.0,
        559.0369262695312,
        98.0
      ],
      [
        1305.0,
        510.0,
        88.0
      ],
      [
        1305.4000244140625,
        560.3590698242188,
        90.0
      ],
      [
        1305.4000244140625,
        510.0,
        90.0
      ],
      [
        1310.0,
        556.557861328125,
        90.0
      ],
      [
        1310.0,
        510.0,
        90.0
      ],
      [
        1307.0,
        510.0,
        98.0
      ],
      [
        1562.1053466796875,
        490.0,
        118.0
      ],
      [
        1556.449951171875,
        490.0,
        118.0
      ],
      [
        1493.550048828125,
        490.0,
        118.0
      ],
      [
        1487.894775390625,
        490.0,
        118.0
      ],
      [
        1562.5999755859375,
        510.0,
        118.0
      ],
      [
        1562.5999755859375,
        490.0,
        118.0
      ],
      [
        1562.5999755859375,
        510.0,
        138.0
      ],
      [
        1493.5548095703125,
        490.0,
        138.0
      ],
      [
        1556.4451904296875,
        490.0,
        138.0
      ],
      [
        1562.5999755859375,
        502.7752990722656,
        138.0
      ],
      [
        1548.9193115234375,
        490.0,
        140.0
      ],
      [
        1501.0806884765625,
        490.0,
        140.0
      ],
      [
        1562.5999755859375,
        502.7752990722656,
        138.0
      ],
      [
        1562.5999755859375,
        510.0,
        138.8340606689453
      ],
      [
        1556.4451904296875,
        490.0,
        138.0
      ],
      [
        1548.9193115234375,
        490.0,
        140.0
      ],
      [
        1493.5548095703125,
        490.0,
        138.0
      ],
      [
        1501.0806884765625,
        490.0,
        140.0
      ],
      [
        1556.449951171875,
        490.0,
        120.0
      ],
      [
        1562.1053466796875,
        490.0,
        120.0
      ],
      [
        1487.894775390625,
        490.0,
        120.0
      ],
      [
        1493.550048828125,
        490.0,
        120.0
      ],
      [
        1562.5999755859375,
        502.7655334472656,
        120.0
      ],
      [
        1556.448974609375,
        490.0,
        120.0
      ],
      [
        1493.551025390625,
        490.0,
        120.0
      ],
      [
        1562.5999755859375,
        510.0,
        120.0
      ],
      [
        1562.5999755859375,
        502.7655334472656,
        120.0
      ],
      [
        1556.448974609375,
        490.0,
        120.0
      ],
      [
        1493.551025390625,
        490.0,
        120.0
      ],
      [
        1562.5999755859375,
        510.0,
        120.0
      ],
      [
        1562.5999755859375,
        502.7655334472656,
        120.0
      ],
      [
        1556.448974609375,
        490.0,
        120.0
      ],
      [
        1493.551025390625,
        490.0,
        120.0
      ],
      [
        1562.5999755859375,
        510.0,
        120.0
      ],
      [
        1562.5999755859375,
        502.7655334472656,
        120.0
      ],
      [
        1556.448974609375,
        490.0,
        120.0
      ],
      [
        1493.551025390625,
        490.0,
        120.0
      ],
      [
        1562.5999755859375,
        510.0,
        120.0
      ],
      [
        1562.5999755859375,
        490.87835693359375,
        118.62738037109375
      ],
      [
        1562.5999755859375,
        502.7655334472656,
        120.0
      ],
      [
        1492.342529296875,
        490.0,
        119.67891693115234
      ],
      [
        1493.551025390625,
        490.0,
        120.0
      ],
      [
        1492.342529296875,
        490.0,
        119.67891693115234
      ],
      [
        1487.894775390625,
        490.0,
        118.0
      ],
      [
        1487.894775390625,
        490.0,
        118.49620056152344
      ],
      [
        1556.448974609375,
        490.0,
        120.0
      ],
      [
        1557.657470703125,
        490.0,
        119.67891693115234
      ],
      [
        1562.5999755859375,
        490.87835693359375,
        118.62738037109375
      ],
      [
        1562.5999755859375,
        490.0,
        118.3646240234375
      ],
      [
        1557.657470703125,
        490.0,
        119.67891693115234
      ],
      [
        1562.1053466796875,
        490.0,
        118.0
      ],
      [
        1562.1053466796875,
        490.0,
        118.49617767333984
      ],
      [
        1562.1053466796875,
        490.0,
        118.7156982421875
      ],
      [
        1487.894775390625,
        490.0,
        118.7146224975586
      ],
      [
        1562.1053466796875,
        490.0,
        120.0
      ],
      [
        1487.894775390625,
        490.0,
        120.0
      ],
      [
        1494.966064453125,
        495.0,
        120.0
      ],
      [
        1494.966064453125,
        495.0,
        138.0
      ],
      [
        1494.7852783203125,
        495.60009765625,
        138.0
      ],
      [
        1494.7852783203125,
        495.60009765625,
        120.0
      ],
      [
        1555.2147216796875,
        495.60009765625,
        120.0
      ],
      [
        1555.2147216796875,
        495.60009765625,
        138.0
      ],
      [
        1555.0338134765625,
        495.0,
        138.0
      ],
      [
        1555.0338134765625,
        495.0,
        120.0
      ],
      [
        1562.5999755859375,
        490.87835693359375,
        100.0
      ],
      [
        1562.5999755859375,
        502.7655334472656,
        100.0
      ],
      [
        1556.45263671875,
        490.0,
        100.0
      ],
      [
        1562.5999755859375,
        490.87835693359375,
        100.0
      ],
      [
        1562.5999755859375,
        490.0,
        100.0
      ],
      [
        1493.54736328125,
        490.0,
        100.0
      ],
      [
        1493.54736328125,
        490.0,
        100.0
      ],
      [
        1508.0,
        490.0,
        100.0
      ],
      [
        1562.5999755859375,
        502.7655334472656,
        100.0
      ],
      [
        1556.45263671875,
        490.0,
        100.0
      ],
      [
        1542.0,
        490.0,
        100.0
      ],
      [
        1562.5999755859375,
        510.0,
        100.0
      ],
      [
        1508.0,
        490.0,
        100.0
      ],
      [
        1493.54736328125,
        490.0,
        100.0
      ],
      [
        1542.0,
        490.0,
        100.0
      ],
      [
        1508.0,
        490.0,
        100.0
      ],
      [
        1562.5999755859375,
        502.77642822265625,
        98.0
      ],
      [
        1562.5999755859375,
        490.8768005371094,
        98.0
      ],
      [
        1493.5494384765625,
        490.0,
        98.0
      ],
      [
        1562.5999755859375,
        490.0,
        98.0
      ],
      [
        1562.5999755859375,
        490.8768005371094,
        98.0
      ],
      [
        1556.4505615234375,
        490.0,
        98.0
      ],
      [
        1541.3333740234375,
        490.0,
        98.0
      ],
      [
        1508.6666259765625,
        490.0,
        98.0
      ],
      [
        1544.0,
        510.0,
        98.0
      ],
      [
        1544.0,
        490.0,
        98.0
      ],
      [
        1542.0,
        490.0,
        100.0
      ],
      [
        1506.0,
        510.0,
        98.0
      ],
      [
        1508.0,
        490.0,
        100.0
      ],
      [
        1506.0,
        490.0,
        98.0
      ],
      [
        1550.0,
        490.0,
        80.0
      ],
      [
        1550.0,
        490.0,
        92.0
      ],
      [
        1500.0,
        490.0,
        92.0
      ],
      [
        1500.0,
        490.0,
        80.0
      ],
      [
        1508.6666259765625,
        490.0,
        98.0
      ],
      [
        1502.0,
        490.0,
        91.0
      ],
      [
        1500.0,
        490.0,
        92.0
      ],
      [
        1502.0,
        490.0,
        91.0
      ],
      [
        1502.0,
        490.0,
        80.0
      ],
      [
        1548.0,
        490.0,
        91.0
      ],
      [
        1541.3333740234375,
        490.0,
        98.0
      ],
      [
        1550.0,
        490.0,
        92.0
      ],
      [
        1548.0,
        490.0,
        80.0
      ],
      [
        1548.0,
        490.0,
        91.0
      ],
      [
        1562.5999755859375,
        502.7655334472656,
        100.0
      ],
      [
        1562.5999755859375,
        502.7655334472656,
        118.0
      ],
      [
        1562.5999755859375,
        502.7655334472656,
        118.0
      ],
      [
        1562.5999755859375,
        502.7655334472656,
        100.0
      ],
      [
        1556.45263671875,
        490.0,
        100.0
      ],
      [
        1556.45263671875,
        490.0,
        118.0
      ],
      [
        1556.45263671875,
        490.0,
        118.0
      ],
      [
        1556.45263671875,
        490.0,
        100.0
      ],
      [
        1493.54736328125,
        490.0,
        100.0
      ],
      [
        1493.54736328125,
        490.0,
        118.0
      ],
      [
        1493.54736328125,
        490.0,
        118.0
      ],
      [
        1493.54736328125,
        490.0,
        100.0
      ],
      [
        1562.5999755859375,
        420.0,
        140.0
      ],
      [
        1562.5999755859375,
        420.0,
        80.0
      ],
      [
        1290.0,
        420.0,
        80.0
      ],
      [
        1562.5999755859375,
        420.0,
        80.0
      ],
      [
        1562.5999755859375,
        420.0,
        140.0
      ],
      [
        1290.0,
        420.0,
        140.0
      ],
      [
        1562.5999755859375,
        450.0,
        91.760009765625
      ],
      [
        1562.5999755859375,
        450.0,
        89.760009765625
      ],
      [
        1290.0,
        450.0,
        98.0
      ],
      [
        1290.0,
        450.0,
        100.0
      ],
      [
        1562.5999755859375,
        461.875,
        120.0
      ],
      [
        1562.5999755859375,
        489.4471130371094,
        120.0
      ],
      [
        1562.5999755859375,
        489.4471130371094,
        118.0
      ],
      [
        1562.5999755859375,
        461.875,
        118.0
      ],
      [
        1562.5999755859375,
        488.7811279296875,
        118.0
      ],
      [
        1495.2000732421875,
        470.0,
        120.0
      ],
      [
        1495.2000732421875,
        470.0,
        118.0
      ],
      [
        1386.0,
        450.0,
        118.0
      ],
      [
        1386.0,
        460.0,
        118.0
      ],
      [
        1386.0,
        460.0,
        118.0
      ],
      [
        1562.5999755859375,
        461.875,
        118.0
      ],
      [
        1554.7999267578125,
        470.0,
        118.0
      ],
      [
        1554.7999267578125,
        470.0,
        120.0
      ],
      [
        1562.5999755859375,
        461.875,
        120.0
      ],
      [
        1487.068115234375,
        489.0761413574219,
        118.0
      ],
      [
        1487.894775390625,
        490.0,
        118.49618530273438
      ],
      [
        1562.5999755859375,
        488.7811279296875,
        118.0
      ],
      [
        1548.6629638671875,
        476.3926086425781,
        118.0
      ],
      [
        1562.1053466796875,
        490.0,
        118.49616241455078
      ],
      [
        1562.5999755859375,
        489.4471130371094,
        118.0
      ],
      [
        1562.5999755859375,
        489.4471130371094,
        118.19926452636719
      ],
      [
        1501.3369140625,
        476.392578125,
        118.0
      ],
      [
        1549.2542724609375,
        475.77667236328125,
        118.0
      ],
      [
        1545.23828125,
        479.9600830078125,
        120.0
      ],
      [
        1562.5999755859375,
        489.4471130371094,
        120.0
      ],
      [
        1504.76171875,
        479.96002197265625,
        120.0
      ],
      [
        1500.7457275390625,
        475.7767028808594,
        118.0
      ],
      [
        1562.5999755859375,
        488.7811279296875,
        100.0
      ],
      [
        1290.0,
        450.0,
        100.0
      ],
      [
        1290.0,
        470.0,
        100.0
      ],
      [
        1290.0,
        470.0,
        100.0
      ],
      [
        1290.0,
        470.0,
        98.0
      ],
      [
        1290.0,
        450.0,
        98.0
      ],
      [
        1290.0,
        470.0,
        98.0
      ],
      [
        1503.199951171875,
        460.0,
        98.0
      ],
      [
        1503.199951171875,
        450.0,
        98.0
      ],
      [
        1547.0,
        460.0,
        98.0
      ],
      [
        1547.0,
        450.0,
        98.0
      ],
      [
        1503.199951171875,
        460.0,
        98.0
      ],
      [
        1547.0,
        460.0,
        98.0
      ],
      [
        1354.0,
        460.0,
        98.0
      ],
      [
        1354.0,
        460.0,
        100.0
      ],
      [
        1354.0,
        470.0,
        98.0
      ],
      [
        1354.0,
        460.0,
        98.0
      ],
      [
        1354.0,
        460.0,
        100.0
      ],
      [
        1354.0,
        450.0,
        100.0
      ],
      [
        1562.5999755859375,
        460.0,
        91.760009765625
      ],
      [
        1562.5999755859375,
        460.0,
        89.760009765625
      ],
      [
        1477.25,
        450.04998779296875,
        85.18753051757812
      ],
      [
        1464.7999267578125,
        450.04998779296875,
        79.99999237060547
      ],
      [
        1477.25,
        460.0,
        86.25
      ],
      [
        1477.25,
        460.0,
        85.18753051757812
      ],
      [
        1477.25,
        450.04998779296875,
        85.18753051757812
      ],
      [
        1562.5999755859375,
        450.0,
        89.760009765625
      ],
      [
        1562.5999755859375,
        460.0,
        89.760009765625
      ],
      [
        1562.5999755859375,
        460.0,
        91.760009765625
      ],
      [
        1562.5999755859375,
        450.0,
        91.760009765625
      ],
      [
        1477.25,
        460.0,
        80.0
      ],
      [
        1374.9000244140625,
        460.0,
        85.54999542236328
      ],
      [
        1374.9000244140625,
        470.0,
        85.54999542236328
      ],
      [
        1562.5999755859375,
        488.7811279296875,
        98.0
      ],
      [
        1544.0,
        470.0,
        98.0
      ],
      [
        1544.0,
        490.0,
        98.0
      ],
      [
        1508.0,
        470.47003173828125,
        100.0
      ],
      [
        1506.0,
        472.2476806640625,
        98.0
      ],
      [
        1506.0,
        490.0,
        98.0
      ],
      [
        1562.5999755859375,
        488.7811279296875,
        100.0
      ],
      [
        1562.5999755859375,
        488.7811279296875,
        98.0
      ],
      [
        1506.0,
        470.0,
        98.0
      ],
      [
        1507.2640380859375,
        484.5038146972656,
        138.0
      ],
      [
        1507.2640380859375,
        484.5038146972656,
        120.0
      ],
      [
        1506.6640625,
        484.646728515625,
        120.0
      ],
      [
        1506.6640625,
        484.646728515625,
        138.0
      ],
      [
        1542.7359619140625,
        484.50384521484375,
        120.0
      ],
      [
        1542.7359619140625,
        484.50384521484375,
        138.0
      ],
      [
        1543.3359375,
        484.6466979980469,
        138.0
      ],
      [
        1543.3359375,
        484.6466979980469,
        120.0
      ],
      [
        1570.0,
        510.0,
        85.0
      ],
      [
        1562.5999755859375,
        510.0,
        85.0
      ],
      [
        1683.6575927734375,
        510.0,
        85.0
      ],
      [
        1740.0,
        510.0,
        85.0
      ],
      [
        1652.2601318359375,
        510.0,
        80.0
      ],
      [
        1760.0,
        599.029052734375,
        85.0
      ],
      [
        1652.2601318359375,
        510.0,
        85.0
      ],
      [
        1760.0,
        599.029052734375,
        85.0
      ],
      [
        1760.0,
        510.0,
        80.0
      ],
      [
        1760.0,
        510.0,
        85.0
      ],
      [
        1740.0,
        556.557861328125,
        85.0
      ],
      [
        1683.6575927734375,
        510.0,
        85.0
      ],
      [
        1740.0,
        510.0,
        85.0
      ],
      [
        1740.0,
        556.557861328125,
        85.0
      ],
      [
        1624.6153564453125,
        510.0,
        85.0
      ],
      [
        1640.0,
        522.5,
        85.0
      ],
      [
        1624.6153564453125,
        510.0,
        80.0
      ],
      [
        1660.0,
        538.75,
        85.0
      ],
      [
        1760.0,
        620.0,
        85.0
      ],
      [
        1760.0,
        620.0,
        85.0
      ],
      [
        1760.0,
        670.0,
        85.0
      ],
      [
        1760.0,
        670.0,
        85.0
      ],
      [
        1760.0,
        620.0,
        85.0
      ],
      [
        1570.0,
        628.0,
        85.0
      ],
      [
        1570.0,
        610.0,
        85.0
      ],
      [
        1570.0,
        670.0,
        85.0
      ],
      [
        1570.0,
        630.0,
        85.0
      ],
      [
        1640.0,
        560.0,
        85.0
      ],
      [
        1640.0,
        522.5,
        85.0
      ],
      [
        1640.0,
        650.0,
        85.0
      ],
      [
        1640.0,
        670.0,
        85.0
      ],
      [
        1640.0,
        560.0,
        85.0
      ],
      [
        1640.0,
        522.5,
        85.0
      ],
      [
        1640.0,
        630.0,
        85.0
      ],
      [
        1620.0,
        630.0,
        85.0
      ],
      [
        1600.0,
        630.0,
        85.0
      ],
      [
        1570.0,
        630.0,
        85.0
      ],
      [
        1620.0,
        640.0,
        85.0
      ],
      [
        1620.0,
        630.0,
        85.0
      ],
      [
        1620.0,
        670.0,
        85.0
      ],
      [
        1620.0,
        650.0,
        85.0
      ],
      [
        1620.0,
        650.0,
        85.0
      ],
      [
        1625.0,
        650.0,
        85.0
      ],
      [
        1580.0,
        667.5,
        85.0
      ],
      [
        1580.0,
        652.5,
        85.0
      ],
      [
        1660.0,
        670.0,
        85.0
      ],
      [
        1660.0,
        650.0,
        85.0
      ],
      [
        1660.0,
        538.75,
        85.0
      ],
      [
        1660.0,
        560.0,
        85.0
      ],
      [
        1640.0,
        650.0,
        85.0
      ],
      [
        1660.0,
        650.0,
        85.0
      ],
      [
        1660.0,
        650.0,
        85.0
      ],
      [
        1640.0,
        650.0,
        85.0
      ],
      [
        1640.0,
        560.0,
        85.0
      ],
      [
        1660.0,
        560.0,
        85.0
      ],
      [
        1570.0,
        610.0,
        85.0
      ],
      [
        1562.5999755859375,
        610.0,
        85.0
      ],
      [
        1570.0,
        610.0,
        85.0
      ],
      [
        1562.5999755859375,
        610.0,
        85.0
      ],
      [
        1570.0,
        630.0,
        85.0
      ],
      [
        1562.5999755859375,
        630.0,
        85.0
      ],
      [
        1562.5999755859375,
        628.0,
        85.0
      ],
      [
        1570.0,
        628.0,
        85.0
      ],
      [
        1562.5999755859375,
        420.0,
        85.0
      ],
      [
        1650.0,
        420.0,
        85.0
      ],
      [
        1770.0,
        420.0,
        85.0
      ],
      [
        1562.5999755859375,
        420.0,
        85.0
      ],
      [
        1570.0,
        490.0,
        85.0
      ],
      [
        1600.0,
        490.0,
        85.0
      ],
      [
        1760.0,
        490.0,
        85.0
      ],
      [
        1628.056884765625,
        490.0,
        85.0
      ],
      [
        1600.0,
        490.0,
        85.0
      ],
      [
        1570.0,
        510.0,
        85.0
      ],
      [
        1570.0,
        490.0,
        85.0
      ],
      [
        1628.056884765625,
        490.0,
        85.0
      ],
      [
        1760.0,
        490.0,
        85.0
      ],
      [
        1579.5,
        460.0,
        85.0
      ],
      [
        1579.5,
        450.0,
        85.0
      ],
      [
        1578.292724609375,
        460.0,
        85.0
      ],
      [
        1575.5,
        460.0,
        85.0
      ],
      [
        1579.5,
        460.0,
        85.0
      ],
      [
        1574.5,
        460.0,
        85.0
      ],
      [
        1575.5,
        450.0,
        85.0
      ],
      [
        1578.292724609375,
        450.0,
        85.0
      ],
      [
        1579.5,
        450.0,
        85.0
      ],
      [
        1574.5,
        450.0,
        85.0
      ],
      [
        1574.5,
        450.0,
        85.0
      ],
      [
        1574.5,
        460.0,
        85.0
      ],
      [
        1575.5,
        450.0,
        85.0
      ],
      [
        1575.5,
        450.0,
        84.59999084472656
      ],
      [
        1575.5,
        460.0,
        84.59999084472656
      ],
      [
        1575.5,
        460.0,
        85.0
      ],
      [
        1702.5,
        450.0,
        85.0
      ],
      [
        1702.5,
        460.0,
        85.0
      ],
      [
        1707.5999755859375,
        460.0,
        85.0
      ],
      [
        1704.7999267578125,
        460.0,
        85.0
      ],
      [
        1702.5,
        460.0,
        85.0
      ],
      [
        1707.5,
        460.0,
        85.0
      ],
      [
        1707.5,
        460.0,
        85.0
      ],
      [
        1707.5,
        450.0,
        85.0
      ],
      [
        1704.7999267578125,
        450.0,
        85.0
      ],
      [
        1707.5,
        450.0,
        85.0
      ],
      [
        1695.0,
        450.0,
        80.0
      ],
      [
        1702.5,
        450.0,
        85.0
      ],
      [
        1707.5,
        450.0,
        85.0
      ],
      [
        1707.5999755859375,
        450.0,
        85.0
      ],
      [
        1707.5999755859375,
        460.0,
        85.0
      ],
      [
        1707.5999755859375,
        450.0,
        85.0
      ],
      [
        1624.6153564453125,
        510.0,
        140.0
      ],
      [
        1624.6153564453125,
        510.0,
        85.0
      ],
      [
        1624.6153564453125,
        510.0,
        338.0
      ],
      [
        1624.6153564453125,
        510.0,
        258.0
      ],
      [
        1624.6153564453125,
        510.0,
        258.0
      ],
      [
        1624.6153564453125,
        510.0,
        140.0
      ],
      [
        1570.0,
        510.0,
        258.0
      ],
      [
        1570.0,
        510.0,
        338.0
      ],
      [
        1570.0,
        510.0,
        140.0
      ],
      [
        1570.0,
        510.0,
        258.0
      ],
      [
        1570.0,
        510.0,
        338.0
      ],
      [
        1580.0,
        510.0,
        348.0
      ],
      [
        1580.0,
        630.0,
        98.0
      ],
      [
        1580.0,
        510.0,
        98.0
      ],
      [
        1580.0,
        585.0,
        116.0
      ],
      [
        1580.0,
        600.0,
        116.0
      ],
      [
        1580.0,
        545.0,
        118.0
      ],
      [
        1580.0,
        555.0,
        118.0
      ],
      [
        1580.0,
        555.0,
        118.0
      ],
      [
        1580.0,
        560.0,
        125.0
      ],
      [
        1580.0,
        560.0,
        125.0
      ],
      [
        1580.0,
        555.0,
        132.0
      ],
      [
        1580.0,
        600.0,
        100.0
      ],
      [
        1580.0,
        585.0,
        100.0
      ],
      [
        1580.0,
        600.0,
        116.0
      ],
      [
        1580.0,
        605.0,
        108.0
      ],
      [
        1580.0,
        605.0,
        108.0
      ],
      [
        1580.0,
        600.0,
        100.0
      ],
      [
        1580.0,
        555.0,
        132.0
      ],
      [
        1580.0,
        545.0,
        132.0
      ],
      [
        1570.0,
        605.0,
        125.0
      ],
      [
        1570.0,
        605.0,
        125.0
      ],
      [
        1580.0,
        630.0,
        98.0
      ],
      [
        1580.0,
        630.0,
        91.0
      ],
      [
        1580.0,
        630.0,
        85.0
      ],
      [
        1580.0,
        630.0,
        91.0
      ],
      [
        1624.6153564453125,
        510.0,
        98.0
      ],
      [
        1600.0,
        510.0,
        98.0
      ],
      [
        1600.0,
        510.0,
        98.0
      ],
      [
        1624.0,
        637.5,
        180.0
      ],
      [
        1624.0,
        637.5,
        195.0
      ],
      [
        1624.0,
        637.5,
        190.0
      ],
      [
        1624.0,
        637.5,
        195.0
      ],
      [
        1624.0,
        637.5,
        190.0
      ],
      [
        1624.0,
        637.5,
        180.0
      ],
      [
        1562.5999755859375,
        630.0,
        118.0
      ],
      [
        1562.5999755859375,
        630.0,
        116.0
      ],
      [
        1570.0,
        630.0,
        116.0
      ],
      [
        1570.0,
        630.0,
        118.0
      ],
      [
        1563.97119140625,
        650.0,
        132.0
      ],
      [
        1570.0,
        630.0,
        132.0
      ],
      [
        1562.5999755859375,
        651.2188720703125,
        132.0
      ],
      [
        1563.97119140625,
        650.0,
        132.0
      ],
      [
        1570.0,
        520.0,
        120.0
      ],
      [
        1562.5999755859375,
        520.0,
        120.0
      ],
      [
        1570.0,
        601.4285888671875,
        120.0
      ],
      [
        1562.5999755859375,
        608.82861328125,
        120.0
      ],
      [
        1562.5999755859375,
        630.0,
        100.0
      ],
      [
        1570.0,
        630.0,
        100.0
      ],
      [
        1564.800048828125,
        626.199951171875,
        104.5
      ],
      [
        1564.800048828125,
        626.199951171875,
        104.0
      ],
      [
        1760.0,
        650.0,
        98.0
      ],
      [
        1770.0,
        628.125,
        98.0
      ],
      [
        1770.0,
        650.0,
        98.0
      ],
      [
        1760.0,
        650.0,
        98.0
      ],
      [
        1760.0,
        650.0,
        140.0
      ],
      [
        1760.0,
        650.0,
        98.0
      ],
      [
        1760.0,
        620.0,
        98.0
      ],
      [
        1760.0,
        650.0,
        140.0
      ],
      [
        1760.0,
        650.0,
        258.0
      ],
      [
        1660.0,
        538.75,
        98.0
      ],
      [
        1660.0,
        560.0,
        98.0
      ],
      [
        1660.0,
        650.0,
        348.0
      ],
      [
        1660.0,
        650.0,
        338.0
      ],
      [
        1640.0,
        560.0,
        98.0
      ],
      [
        1660.0,
        560.0,
        98.0
      ],
      [
        1767.5,
        626.09375,
        100.0
      ],
      [
        1770.0,
        628.1249389648438,
        100.0
      ],
      [
        1770.0,
        650.0,
        100.0
      ],
      [
        1770.0,
        628.125,
        100.0
      ],
      [
        1760.0,
        650.0,
        100.0
      ],
      [
        1760.0,
        650.0,
        220.0
      ],
      [
        1770.0,
        628.125,
        220.0
      ],
      [
        1770.0,
        650.0,
        220.0
      ],
      [
        1760.0,
        650.0,
        258.0
      ],
      [
        1770.0,
        628.125,
        258.0
      ],
      [
        1770.0,
        650.0,
        258.0
      ],
      [
        1760.0,
        650.0,
        85.0
      ],
      [
        1760.0,
        650.0,
        98.0
      ],
      [
        1760.0,
        650.0,
        85.0
      ],
      [
        1652.2601318359375,
        510.0,
        88.0
      ],
      [
        1652.2601318359375,
        510.0,
        85.0
      ],
      [
        1760.0,
        510.0,
        88.0
      ],
      [
        1745.0,
        510.0,
        88.0
      ],
      [
        1652.2601318359375,
        510.0,
        88.0
      ],
      [
        1675.8082275390625,
        510.0,
        88.0
      ],
      [
        1760.0,
        510.0,
        88.0
      ],
      [
        1760.0,
        510.0,
        85.0
      ],
      [
        1675.8082275390625,
        510.0,
        88.0
      ],
      [
        1678.947998046875,
        510.0,
        98.0
      ],
      [
        1743.0,
        510.0,
        98.0
      ],
      [
        1678.947998046875,
        510.0,
        98.0
      ],
      [
        1745.0,
        560.6896362304688,
        88.0
      ],
      [
        1743.0,
        559.0369262695312,
        98.0
      ],
      [
        1745.0,
        510.0,
        88.0
      ],
      [
        1744.5999755859375,
        510.0,
        90.0
      ],
      [
        1744.5999755859375,
        560.3590698242188,
        90.0
      ],
      [
        1740.0,
        510.0,
        90.0
      ],
      [
        1740.0,
        556.557861328125,
        90.0
      ],
      [
        1743.0,
        510.0,
        98.0
      ],
      [
        1661.4000244140625,
        460.0,
        100.0
      ],
      [
        1735.0,
        460.0,
        98.0
      ],
      [
        1661.4000244140625,
        460.0,
        100.0
      ],
      [
        1661.4000244140625,
        470.0,
        100.0
      ],
      [
        1760.0,
        460.0,
        98.0
      ],
      [
        1760.0,
        460.0,
        100.0
      ],
      [
        1735.0,
        450.0,
        98.0
      ],
      [
        1735.0,
        450.0,
        98.0
      ],
      [
        1735.0,
        460.0,
        98.0
      ],
      [
        1707.5999755859375,
        460.0,
        85.03997039794922
      ],
      [
        1707.5999755859375,
        450.0,
        85.03997039794922
      ],
      [
        1562.5999755859375,
        470.0,
        120.0
      ],
      [
        1577.0,
        460.0,
        118.0
      ],
      [
        1562.5999755859375,
        470.0,
        118.0
      ],
      [
        1564.4000244140625,
        460.0,
        118.0
      ],
      [
        1577.0,
        460.0,
        118.0
      ],
      [
        1564.4000244140625,
        460.0,
        118.0
      ],
      [
        1564.4000244140625,
        460.0,
        120.0
      ],
      [
        1562.5999755859375,
        490.0,
        118.0
      ],
      [
        1562.5999755859375,
        490.0,
        118.3646240234375
      ],
      [
        1562.5999755859375,
        490.0,
        98.0
      ],
      [
        1562.5999755859375,
        490.0,
        100.0
      ],
      [
        1562.931884765625,
        489.0761413574219,
        118.0
      ],
      [
        1562.5999755859375,
        489.4471435546875,
        118.19923400878906
      ],
      [
        1910.0,
        1800.41455078125,
        1130.0
      ],
      [
        1910.0,
        1812.9425048828125,
        1130.0
      ],
      [
        1910.0,
        1760.0001220703125,
        1130.0
      ],
      [
        1910.0,
        1800.41455078125,
        1130.0
      ],
      [
        1910.0,
        1719.58544921875,
        1130.0
      ],
      [
        1910.0,
        1760.0001220703125,
        1130.0
      ],
      [
        1910.0,
        1626.639892578125,
        1130.0
      ],
      [
        1910.0,
        1595.58154296875,
        1130.0
      ],
      [
        1910.0,
        1812.9425048828125,
        1130.0
      ],
      [
        1910.0,
        1881.243408203125,
        1130.0
      ],
      [
        1910.0,
        1881.243408203125,
        1130.0
      ],
      [
        1910.0,
        1893.3603515625,
        1130.0
      ],
      [
        1910.0,
        1812.9425048828125,
        1130.0
      ],
      [
        1910.0,
        1812.9425048828125,
        1150.0
      ],
      [
        1926.6507568359375,
        1772.5001220703125,
        1110.0
      ],
      [
        1921.2918701171875,
        1792.5001220703125,
        1110.0
      ],
      [
        1926.6507568359375,
        1772.5001220703125,
        1115.0
      ],
      [
        1926.6507568359375,
        1772.5001220703125,
        1110.0
      ],
      [
        1910.0,
        1812.9425048828125,
        1060.0
      ],
      [
        1910.0,
        1812.9427490234375,
        1106.0
      ],
      [
        1910.0,
        1704.3255615234375,
        1110.0
      ],
      [
        1910.0,
        1704.6409912109375,
        1110.0
      ],
      [
        1910.0,
        1768.03857421875,
        1110.0
      ],
      [
        1910.0,
        1789.4744873046875,
        1110.0
      ],
      [
        1910.0,
        1768.03857421875,
        1115.0
      ],
      [
        1910.0,
        1768.03857421875,
        1110.0
      ],
      [
        1840.0,
        1579.9000244140625,
        1150.0
      ],
      [
        1840.0,
        1579.9000244140625,
        1180.0
      ],
      [
        1847.498046875,
        1579.900146484375,
        1130.0
      ],
      [
        1851.47607421875,
        1579.900146484375,
        1130.0
      ],
      [
        1885.000244140625,
        1837.9425048828125,
        1110.0
      ],
      [
        1840.000244140625,
        1850.0001220703125,
        1110.0
      ],
      [
        1886.000244140625,
        1839.674560546875,
        1110.0
      ],
      [
        1885.000244140625,
        1837.9425048828125,
        1110.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -6971.595703125,
        -5072.0185546875,
        -300.0
      ],
      "bbox_max": [
        7986.5068359375,
        5100.0,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -3080.0,
        -3580.0,
        667.6585693359375
      ],
      "bbox_max": [
        -3000.0,
        -3408.73486328125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.60302734375,
      "bbox_min": [
        -3833.671875,
        -4714.78125,
        1040.098388671875
      ],
      "bbox_max": [
        -3000.0,
        -4327.0185546875,
        1390.1221923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6971.595703125,
        -2619.10009765625,
        0.0
      ],
      "bbox_max": [
        -3605.199951171875,
        2921.382080078125,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -4912.15185546875,
        -2323.521484375,
        0.0
      ],
      "bbox_max": [
        -3605.199951171875,
        2200.0,
        1179.1292724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7714905142784119,
        0.08541621267795563,
        0.6304812431335449
      ],
      "plane_d": 2975.195556640625,
      "bbox_min": [
        -4912.15185546875,
        -2269.10009765625,
        0.0
      ],
      "bbox_max": [
        -3605.199951171875,
        2200.0,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -4912.15185546875,
        -2329.10009765625,
        1000.0
      ],
      "bbox_max": [
        -3714.042724609375,
        2154.178466796875,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -3000.0,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        400.0,
        -2021.68505859375,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -3000.0,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        400.0,
        -2275.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3156070411205292,
        0.8320549726486206,
        0.45615431666374207
      ],
      "plane_d": 1686.0640869140625,
      "bbox_min": [
        -3000.0,
        -3565.30615234375,
        0.0
      ],
      "bbox_max": [
        -1701.24462890625,
        -2671.68505859375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -3000.0,
        -3565.30615234375,
        0.0
      ],
      "bbox_max": [
        -2100.0,
        -3111.68505859375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.60302734375,
      "bbox_min": [
        -3000.0,
        -5072.0185546875,
        1191.9580078125
      ],
      "bbox_max": [
        -2147.99658203125,
        -4650.2626953125,
        1390.1104736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5815920829772949,
        0.8134805560112
      ],
      "plane_d": 463.345703125,
      "bbox_min": [
        2400.0,
        -2050.0,
        -300.0
      ],
      "bbox_max": [
        7823.75537109375,
        -696.68505859375,
        1152.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.41241455078125,
      "bbox_min": [
        2400.0,
        -1844.385986328125,
        252.5999755859375
      ],
      "bbox_max": [
        4526.4208984375,
        -1150.0,
        749.0462646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        2400.0,
        -1844.385986328125,
        502.5999755859375
      ],
      "bbox_max": [
        4526.4208984375,
        -1556.87548828125,
        749.0462646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01684202253818512,
        0.7395898699760437,
        0.6728469729423523
      ],
      "plane_d": 720.988037109375,
      "bbox_min": [
        2400.0,
        -2050.0,
        0.0
      ],
      "bbox_max": [
        7823.75537109375,
        -796.68505859375,
        1152.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.02753951959311962,
        0.7068385481834412,
        0.7068385481834412
      ],
      "plane_d": 737.5914916992188,
      "bbox_min": [
        2400.0,
        -2050.0,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1150.0,
        1152.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        2400.0,
        -2050.0,
        329.55450439453125
      ],
      "bbox_max": [
        7600.0,
        -1257.6373291015625,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.41241455078125,
      "bbox_min": [
        2962.5361328125,
        -1556.87548828125,
        329.55450439453125
      ],
      "bbox_max": [
        7600.0,
        -1257.6373291015625,
        602.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.41241455078125,
      "bbox_min": [
        2400.0,
        -1350.0,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1150.0,
        602.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        650.0,
        -2850.0,
        -300.0
      ],
      "bbox_max": [
        2400.0,
        -696.68505859375,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001831054688,
      "bbox_min": [
        650.0,
        -2850.0,
        1100.0
      ],
      "bbox_max": [
        2400.0,
        -2050.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.4764099121094,
      "bbox_min": [
        650.0,
        -1700.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1546.88427734375,
        502.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        650.0,
        -1600.0,
        -300.0
      ],
      "bbox_max": [
        2400.0,
        -696.68505859375,
        433.001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.027094179764389992,
        0.9482963681221008,
        0.31622782349586487
      ],
      "plane_d": 817.0990600585938,
      "bbox_min": [
        650.0,
        -1150.0,
        -300.0
      ],
      "bbox_max": [
        2400.0,
        -696.68505859375,
        252.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5815920829772949,
        0.8134805560112
      ],
      "plane_d": 463.345703125,
      "bbox_min": [
        2272.3271484375,
        -1150.0,
        -300.0
      ],
      "bbox_max": [
        2400.0,
        -696.68505859375,
        252.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486833810806274,
        0.3162277936935425
      ],
      "plane_d": 755.8018798828125,
      "bbox_min": [
        2272.3271484375,
        -796.68505859375,
        -300.0
      ],
      "bbox_max": [
        2400.0,
        -696.68505859375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.4764099121094,
      "bbox_min": [
        650.0,
        -1600.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1150.0,
        433.001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -1100.0,
        -2598.9130859375,
        0.0
      ],
      "bbox_max": [
        650.0,
        -1200.0,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -1100.0,
        -2500.0,
        0.0
      ],
      "bbox_max": [
        0.0,
        -1371.68505859375,
        1352.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18530525267124176,
        0.5702676773071289,
        0.8002853393554688
      ],
      "plane_d": 680.0791015625,
      "bbox_min": [
        -1100.0,
        -2050.0,
        0.0
      ],
      "bbox_max": [
        -551.24462890625,
        -1371.68505859375,
        402.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        -551.24462890625,
        -2598.9130859375,
        0.0
      ],
      "bbox_max": [
        650.0,
        -1200.0,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001831054688,
      "bbox_min": [
        0.0,
        -2598.9130859375,
        1284.1875
      ],
      "bbox_max": [
        650.0,
        -2378.125,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14309725165367126,
        0.2930086553096771,
        0.9453407526016235
      ],
      "plane_d": 323.03399658203125,
      "bbox_min": [
        -551.24462890625,
        -1600.0,
        0.0
      ],
      "bbox_max": [
        650.0,
        -1200.0,
        252.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        582.9658203125,
        -1600.0,
        118.47281646728516
      ],
      "bbox_max": [
        650.0,
        -1200.0,
        252.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14309725165367126,
        0.2930086553096771,
        0.9453407526016235
      ],
      "plane_d": 323.03399658203125,
      "bbox_min": [
        -199.69903564453125,
        -1200.0,
        -300.0
      ],
      "bbox_max": [
        650.0,
        -743.0372314453125,
        124.01402282714844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        499.2938232421875,
        -1200.0,
        -300.0
      ],
      "bbox_max": [
        650.0,
        -743.0372314453125,
        124.01402282714844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016502970829606056,
        0.5776039958000183,
        0.8161503076553345
      ],
      "plane_d": 497.69219970703125,
      "bbox_min": [
        523.75537109375,
        -867.0938720703125,
        0.0
      ],
      "bbox_max": [
        650.0,
        -843.0780639648438,
        16.99639320373535
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1491488516330719,
        -0.38985106348991394,
        0.9087193608283997
      ],
      "plane_d": 568.5121459960938,
      "bbox_min": [
        4110.0,
        1142.219970703125,
        730.4360961914062
      ],
      "bbox_max": [
        7986.5068359375,
        3895.50634765625,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        4110.0,
        2233.390869140625,
        1007.1089477539062
      ],
      "bbox_max": [
        4137.6171875,
        2280.14306640625,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        4110.0,
        1142.219970703125,
        730.4360961914062
      ],
      "bbox_max": [
        4137.6171875,
        2280.14306640625,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4713583290576935,
        -0.3486906588077545,
        0.8100841641426086
      ],
      "plane_d": 1743.849609375,
      "bbox_min": [
        4110.0,
        1142.219970703125,
        730.4360961914062
      ],
      "bbox_max": [
        4137.6171875,
        1346.6982421875,
        831.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3825902044773102,
        0.0,
        0.9239181876182556
      ],
      "plane_d": 814.5899047851562,
      "bbox_min": [
        4110.0,
        1340.1431884765625,
        818.451171875
      ],
      "bbox_max": [
        4137.6171875,
        1355.2147216796875,
        831.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4713583290576935,
        -0.3486906588077545,
        0.8100841641426086
      ],
      "plane_d": 1743.849609375,
      "bbox_min": [
        4110.0,
        1340.1431884765625,
        818.451171875
      ],
      "bbox_max": [
        4137.6171875,
        1350.9073486328125,
        831.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26363566517829895,
        -0.09646245092153549,
        0.9597871899604797
      ],
      "plane_d": 575.6990966796875,
      "bbox_min": [
        3100.0,
        598.0,
        0.0
      ],
      "bbox_max": [
        4110.0,
        2266.29345703125,
        1014.1094970703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7753851413726807,
        -0.028329361230134964,
        0.6308528780937195
      ],
      "plane_d": 2269.93212890625,
      "bbox_min": [
        3100.0,
        598.0,
        0.0
      ],
      "bbox_max": [
        3312.43017578125,
        1852.6285400390625,
        489.9930419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28701892495155334,
        -0.9567298293113708,
        0.04783649370074272
      ],
      "plane_d": 1484.8446044921875,
      "bbox_min": [
        3100.0,
        598.0,
        0.0
      ],
      "bbox_max": [
        3312.43017578125,
        1852.6285400390625,
        489.9930419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5038637518882751,
        -0.7725911140441895,
        0.3862955570220947
      ],
      "plane_d": 1980.8563232421875,
      "bbox_min": [
        3100.0,
        610.0,
        177.3913116455078
      ],
      "bbox_max": [
        3312.43017578125,
        1852.6285400390625,
        489.9930419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3825902044773102,
        0.0,
        0.9239181876182556
      ],
      "plane_d": 814.5899047851562,
      "bbox_min": [
        3240.0,
        1690.0,
        460.0
      ],
      "bbox_max": [
        3312.43017578125,
        1852.6285400390625,
        489.9930419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        3240.0,
        1790.47265625,
        460.0
      ],
      "bbox_max": [
        3312.43017578125,
        1852.6285400390625,
        489.9930419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7398530840873718,
        -0.055298302322626114,
        0.6704919338226318
      ],
      "plane_d": 2182.15185546875,
      "bbox_min": [
        3100.0,
        660.0,
        241.80979919433594
      ],
      "bbox_max": [
        3240.0,
        1690.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7727262377738953,
        0.0,
        0.6347393989562988
      ],
      "plane_d": 2241.4580078125,
      "bbox_min": [
        3100.0,
        660.0,
        241.80979919433594
      ],
      "bbox_max": [
        3180.0,
        680.8695678710938,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5038637518882751,
        -0.7725911140441895,
        0.3862955570220947
      ],
      "plane_d": 1980.8563232421875,
      "bbox_min": [
        3100.0,
        660.0,
        241.80979919433594
      ],
      "bbox_max": [
        3180.0,
        663.478271484375,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        3240.0,
        910.1431274414062,
        460.0
      ],
      "bbox_max": [
        4110.0,
        2266.29345703125,
        1014.1094970703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4713583290576935,
        -0.3486906588077545,
        0.8100841641426086
      ],
      "plane_d": 1743.849609375,
      "bbox_min": [
        3437.258056640625,
        910.1431274414062,
        495.7249755859375
      ],
      "bbox_max": [
        4110.0,
        1506.344482421875,
        818.451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4713583290576935,
        -0.3486906588077545,
        0.8100841641426086
      ],
      "plane_d": 1743.849609375,
      "bbox_min": [
        3240.0,
        1346.6982421875,
        460.0
      ],
      "bbox_max": [
        4110.0,
        1690.0,
        820.262939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1059.9998779296875,
      "bbox_min": [
        -100.0,
        250.0,
        20.869564056396484
      ],
      "bbox_max": [
        3100.0,
        2050.0,
        1180.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        -100.0,
        250.0,
        20.869564056396484
      ],
      "bbox_max": [
        3100.0,
        2050.0,
        1060.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.7398530840873718,
        -0.055298302322626114,
        0.6704919338226318
      ],
      "plane_d": 2182.15185546875,
      "bbox_min": [
        1910.0,
        623.04345703125,
        20.869564056396484
      ],
      "bbox_max": [
        3100.0,
        1940.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28701892495155334,
        -0.9567298293113708,
        0.04783649370074272
      ],
      "plane_d": 1484.8446044921875,
      "bbox_min": [
        2953.080810546875,
        623.04345703125,
        20.869564056396484
      ],
      "bbox_max": [
        3100.0,
        669.0355834960938,
        219.9201202392578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5038637518882751,
        -0.7725911140441895,
        0.3862955570220947
      ],
      "plane_d": 1980.8563232421875,
      "bbox_min": [
        2963.776611328125,
        630.8695678710938,
        70.78167724609375
      ],
      "bbox_max": [
        3100.0,
        666.4061279296875,
        219.9201202392578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1910.0,
        652.1339721679688,
        59.19630813598633
      ],
      "bbox_max": [
        3100.0,
        1940.0999755859375,
        1060.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.2483755201101303,
        -0.9686638712882996,
        -0.0
      ],
      "plane_d": 2353.7021484375,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        205.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2740.887451171875,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        205.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1060.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        320.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 732.9856567382812,
      "bbox_min": [
        1910.0,
        1588.9000244140625,
        980.0
      ],
      "bbox_max": [
        2011.0,
        1931.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071055173873901,
        -0.7071080207824707,
        0.0
      ],
      "plane_d": 2498.914794921875,
      "bbox_min": [
        1910.0,
        1588.9000244140625,
        980.0
      ],
      "bbox_max": [
        1945.0999755859375,
        1623.9998779296875,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.666748046875,
      "bbox_min": [
        1910.0,
        1829.8446044921875,
        980.0
      ],
      "bbox_max": [
        2011.0,
        1931.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 339.9999694824219,
      "bbox_min": [
        1910.0,
        1608.986083984375,
        320.0
      ],
      "bbox_max": [
        1983.250732421875,
        1907.4766845703125,
        350.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6532807946205139,
        -0.2705976068973541,
        -0.7071075439453125
      ],
      "plane_d": -551.77294921875,
      "bbox_min": [
        1910.0,
        1608.986083984375,
        340.0
      ],
      "bbox_max": [
        1952.4718017578125,
        1760.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27059727907180786,
        -0.6532820463180542,
        -0.7071065902709961
      ],
      "plane_d": 825.888916015625,
      "bbox_min": [
        1910.0,
        1676.5230712890625,
        340.0
      ],
      "bbox_max": [
        1919.5296630859375,
        1688.1240234375,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2665826082229614,
        -0.9638121128082275,
        0.0
      ],
      "plane_d": 1041.5875244140625,
      "bbox_min": [
        1910.0,
        1608.986083984375,
        340.0
      ],
      "bbox_max": [
        1922.788818359375,
        1612.5233154296875,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532807946205139,
        -0.2705976068973541,
        -0.7071075439453125
      ],
      "plane_d": -551.77294921875,
      "bbox_min": [
        1910.0,
        1687.346923828125,
        320.0
      ],
      "bbox_max": [
        1941.64794921875,
        1784.1424560546875,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 319.9999694824219,
      "bbox_min": [
        1910.0,
        1687.346923828125,
        320.0
      ],
      "bbox_max": [
        1920.0001220703125,
        1784.1424560546875,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27059727907180786,
        -0.6532820463180542,
        -0.7071065902709961
      ],
      "plane_d": 825.888916015625,
      "bbox_min": [
        1910.0,
        1687.346923828125,
        337.5489196777344
      ],
      "bbox_max": [
        1911.8759765625,
        1690.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7753851413726807,
        -0.028329361230134964,
        0.6308528780937195
      ],
      "plane_d": 2269.93212890625,
      "bbox_min": [
        2950.0,
        652.1339721679688,
        59.19630813598633
      ],
      "bbox_max": [
        3100.0,
        1221.72412109375,
        266.89654541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5038637518882751,
        -0.7725911140441895,
        0.3862955570220947
      ],
      "plane_d": 1980.8563232421875,
      "bbox_min": [
        2951.521240234375,
        652.1339721679688,
        59.19630813598633
      ],
      "bbox_max": [
        3100.0,
        669.5238037109375,
        241.80979919433594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28701892495155334,
        -0.9567298293113708,
        0.04783649370074272
      ],
      "plane_d": 1484.8446044921875,
      "bbox_min": [
        2951.521240234375,
        666.4061279296875,
        59.19630813598633
      ],
      "bbox_max": [
        2963.776611328125,
        669.5238037109375,
        70.78168487548828
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7727262377738953,
        0.0,
        0.6347393989562988
      ],
      "plane_d": 2241.4580078125,
      "bbox_min": [
        2950.0,
        663.0787963867188,
        59.6031494140625
      ],
      "bbox_max": [
        3100.0,
        720.0,
        242.60870361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5038637518882751,
        -0.7725911140441895,
        0.3862955570220947
      ],
      "plane_d": 1980.8563232421875,
      "bbox_min": [
        2950.0,
        663.0787963867188,
        59.6031494140625
      ],
      "bbox_max": [
        3100.0,
        670.0,
        242.60870361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28701892495155334,
        -0.9567298293113708,
        0.04783649370074272
      ],
      "plane_d": 1484.8446044921875,
      "bbox_min": [
        2950.0,
        668.6529541015625,
        59.6031494140625
      ],
      "bbox_max": [
        2955.16357421875,
        670.0,
        64.04113006591797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        -100.0,
        250.0,
        59.9999885559082
      ],
      "bbox_max": [
        1910.0001220703125,
        2011.7158203125,
        1060.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 2162.533447265625,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        119.99995422363281
      ],
      "bbox_max": [
        1910.0001220703125,
        2011.7158203125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1549.998779296875,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        119.99995422363281
      ],
      "bbox_max": [
        1910.0001220703125,
        2011.7158203125,
        1060.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        1655.0,
        1469.9998779296875,
        119.99995422363281
      ],
      "bbox_max": [
        1910.0001220703125,
        1965.0001220703125,
        1060.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 637.0455932617188,
      "bbox_min": [
        1668.9998779296875,
        1469.9998779296875,
        350.0
      ],
      "bbox_max": [
        1910.0,
        1931.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1469.9998779296875,
        350.0
      ],
      "bbox_max": [
        1910.0,
        1896.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071055173873901,
        -0.7071080207824707,
        0.0
      ],
      "plane_d": 2498.914794921875,
      "bbox_min": [
        1909.7445068359375,
        1623.9998779296875,
        1059.421875
      ],
      "bbox_max": [
        1910.0,
        1624.25537109375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.666748046875,
      "bbox_min": [
        1909.74462890625,
        1895.4892578125,
        1059.422119140625
      ],
      "bbox_max": [
        1910.0,
        1896.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1655.0,
        1469.9998779296875,
        119.99995422363281
      ],
      "bbox_max": [
        1910.0001220703125,
        1965.0001220703125,
        350.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 319.9999694824219,
      "bbox_min": [
        1680.0,
        1469.9998779296875,
        220.0
      ],
      "bbox_max": [
        1910.0001220703125,
        1840.0001220703125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        1680.0,
        1469.9998779296875,
        320.0
      ],
      "bbox_max": [
        1910.0001220703125,
        1735.857666015625,
        350.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.27059727907180786,
        -0.6532820463180542,
        -0.7071065902709961
      ],
      "plane_d": 825.888916015625,
      "bbox_min": [
        1680.0,
        1469.9998779296875,
        340.0
      ],
      "bbox_max": [
        1910.0,
        1687.346923828125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.0517671802954283e-06,
        -1.0,
        0.0
      ],
      "plane_d": 1545.005859375,
      "bbox_min": [
        1680.0,
        1469.9998779296875,
        340.0
      ],
      "bbox_max": [
        1910.0,
        1565.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        -0.0,
        -0.8000000715255737
      ],
      "plane_d": 1402.0,
      "bbox_min": [
        1870.0,
        1545.0001220703125,
        340.0
      ],
      "bbox_max": [
        1883.3333740234375,
        1565.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1485.0,
      "bbox_min": [
        1680.0,
        1469.9998779296875,
        340.0
      ],
      "bbox_max": [
        1910.0,
        1505.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5999988913536072,
        -0.0,
        -0.8000009655952454
      ],
      "plane_d": 1401.998291015625,
      "bbox_min": [
        1680.0,
        1485.0,
        340.0
      ],
      "bbox_max": [
        1883.3333740234375,
        1505.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1485.0,
        340.0
      ],
      "bbox_max": [
        1680.0,
        1490.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1469.9998779296875,
        340.0
      ],
      "bbox_max": [
        1680.0,
        1485.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27059727907180786,
        -0.6532820463180542,
        -0.7071065902709961
      ],
      "plane_d": 825.888916015625,
      "bbox_min": [
        1680.0,
        1469.9998779296875,
        320.0
      ],
      "bbox_max": [
        1910.0001220703125,
        1735.857666015625,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532807946205139,
        -0.2705976068973541,
        -0.7071075439453125
      ],
      "plane_d": -551.77294921875,
      "bbox_min": [
        1896.568603515625,
        1690.0,
        320.0
      ],
      "bbox_max": [
        1910.0,
        1735.857666015625,
        337.5489196777344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5999988913536072,
        -0.0,
        -0.8000009655952454
      ],
      "plane_d": 1401.998291015625,
      "bbox_min": [
        1680.0,
        1469.9998779296875,
        320.0
      ],
      "bbox_max": [
        1910.0001220703125,
        1565.0,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -3.0517671802954283e-06,
        -1.0,
        0.0
      ],
      "plane_d": 1545.005859375,
      "bbox_min": [
        1883.3333740234375,
        1485.0,
        320.0
      ],
      "bbox_max": [
        1910.0,
        1545.0001220703125,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1485.0,
      "bbox_min": [
        1883.3333740234375,
        1485.0,
        320.0
      ],
      "bbox_max": [
        1910.0,
        1485.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1469.9998779296875,
        320.0
      ],
      "bbox_max": [
        1680.0,
        1490.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000015497207642,
        -0.8660245537757874,
        0.0
      ],
      "plane_d": 562.5496826171875,
      "bbox_min": [
        1680.0,
        1469.9998779296875,
        220.0
      ],
      "bbox_max": [
        1901.650634765625,
        1747.5,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        1680.0,
        1469.9998779296875,
        280.0
      ],
      "bbox_max": [
        1735.0,
        1490.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1469.9998779296875,
        280.0
      ],
      "bbox_max": [
        1680.0,
        1490.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1655.0,
        1469.9998779296875,
        119.99995422363281
      ],
      "bbox_max": [
        1695.0001220703125,
        1943.2857666015625,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -3.9238043427758384e-06,
        -0.515036940574646,
        -0.8571680784225464
      ],
      "plane_d": 1103.7305908203125,
      "bbox_min": [
        1655.0,
        1610.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1918.3214111328125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1610.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1910.0,
        140.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1680.0,
        1610.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1705.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1705.0,
      "bbox_min": [
        1680.0,
        1705.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1705.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1655.0,
        1469.9998779296875,
        119.99995422363281
      ],
      "bbox_max": [
        1695.0001220703125,
        1943.2857666015625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.9238043427758384e-06,
        -0.515036940574646,
        -0.8571680784225464
      ],
      "plane_d": 1103.7305908203125,
      "bbox_min": [
        1655.0,
        1469.9998779296875,
        119.99995422363281
      ],
      "bbox_max": [
        1695.0001220703125,
        1943.2857666015625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        8.138020348269492e-06
      ],
      "plane_d": -1655.0009765625,
      "bbox_min": [
        1655.0,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1695.0001220703125,
        1910.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -4.069010628882097e-06,
        1.220703143189894e-05
      ],
      "plane_d": 1695.00439453125,
      "bbox_min": [
        1680.0,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1695.0001220703125,
        1910.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1910.0,
        135.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1680.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1705.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1705.0,
      "bbox_min": [
        1680.0,
        1705.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1705.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1769.9998779296875,
      "bbox_min": [
        -100.0,
        250.0,
        59.9999885559082
      ],
      "bbox_max": [
        1910.0,
        1470.0,
        810.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -220.0,
      "bbox_min": [
        1770.0,
        420.0,
        60.0
      ],
      "bbox_max": [
        1910.0,
        1440.0,
        338.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1770.0,
        420.0,
        60.0
      ],
      "bbox_max": [
        1910.0,
        1140.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": 1499.06640625,
      "bbox_min": [
        1900.0,
        650.0,
        144.0
      ],
      "bbox_max": [
        1910.0,
        1140.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 2071.82275390625,
      "bbox_min": [
        1900.0,
        1020.0,
        210.0
      ],
      "bbox_max": [
        1910.0,
        1030.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -149.0,
      "bbox_min": [
        1905.0,
        670.0,
        144.0
      ],
      "bbox_max": [
        1910.0,
        760.0,
        199.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        1905.0,
        670.0,
        144.0
      ],
      "bbox_max": [
        1910.0,
        670.0,
        149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        1905.0,
        670.0,
        149.0
      ],
      "bbox_max": [
        1910.0,
        670.0,
        199.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -420.0,
      "bbox_min": [
        1770.0,
        420.0,
        60.0
      ],
      "bbox_max": [
        1790.0,
        1140.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.001050728838890791,
        0.09950366616249084,
        0.9950367212295532
      ],
      "plane_d": -124.48885345458984,
      "bbox_min": [
        1770.0,
        420.0,
        60.0
      ],
      "bbox_max": [
        1790.0,
        1140.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1770.0,
        420.0,
        80.0
      ],
      "bbox_max": [
        1790.0,
        470.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -1103.0865478515625,
      "bbox_min": [
        1770.0,
        469.78875732421875,
        60.0
      ],
      "bbox_max": [
        1790.0,
        1140.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -530.3301391601562,
      "bbox_min": [
        1770.0,
        1020.0,
        210.0
      ],
      "bbox_max": [
        1780.0,
        1030.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1770.0,
        469.78875732421875,
        80.0
      ],
      "bbox_max": [
        1790.0,
        470.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1770.0,
        620.0,
        60.0
      ],
      "bbox_max": [
        1790.0,
        720.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1780.0,
      "bbox_min": [
        1770.0,
        620.0,
        60.0
      ],
      "bbox_max": [
        1790.0,
        720.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1770.0,
        620.0,
        60.0
      ],
      "bbox_max": [
        1780.0,
        720.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1770.0,
        620.0,
        98.0
      ],
      "bbox_max": [
        1780.0,
        690.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        1770.0,
        620.0,
        98.0
      ],
      "bbox_max": [
        1780.0,
        690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 620.0,
      "bbox_min": [
        1770.0,
        620.0,
        98.0
      ],
      "bbox_max": [
        1780.0,
        620.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        1770.0,
        636.6666870117188,
        60.0
      ],
      "bbox_max": [
        1780.0,
        720.0,
        63.31221389770508
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.09887950867414474,
        0.9950994849205017
      ],
      "plane_d": -125.95524597167969,
      "bbox_min": [
        1770.0,
        636.6666870117188,
        60.0
      ],
      "bbox_max": [
        1780.0,
        670.0,
        63.31221389770508
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        1780.0,
        653.3333740234375,
        60.0
      ],
      "bbox_max": [
        1790.0,
        720.0,
        61.656105041503906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.09887950867414474,
        0.9950994849205017
      ],
      "plane_d": -125.95524597167969,
      "bbox_min": [
        1780.0,
        653.3333740234375,
        60.0
      ],
      "bbox_max": [
        1790.0,
        670.0,
        61.656105041503906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        1770.0,
        620.0,
        220.0
      ],
      "bbox_max": [
        1910.0,
        1440.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 620.0,
      "bbox_min": [
        1770.0,
        620.0,
        280.0
      ],
      "bbox_max": [
        1790.0,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        1770.0,
        700.0,
        280.0
      ],
      "bbox_max": [
        1790.0,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1770.0,
        620.0,
        220.0
      ],
      "bbox_max": [
        1910.0,
        1100.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1100.0,
      "bbox_min": [
        1780.0,
        1060.0,
        220.0
      ],
      "bbox_max": [
        1900.0,
        1100.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1900.0,
      "bbox_min": [
        1900.0,
        1060.0,
        220.0
      ],
      "bbox_max": [
        1900.0,
        1100.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 257.9999694824219,
      "bbox_min": [
        1770.0,
        620.0,
        220.0
      ],
      "bbox_max": [
        1910.0,
        1030.0,
        280.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 620.0,
      "bbox_min": [
        1770.0,
        620.0,
        258.0
      ],
      "bbox_max": [
        1790.0,
        700.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        1770.0,
        700.0,
        258.0
      ],
      "bbox_max": [
        1790.0,
        700.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -530.3301391601562,
      "bbox_min": [
        1770.0,
        620.0,
        220.0
      ],
      "bbox_max": [
        1910.0,
        1030.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 620.0,
      "bbox_min": [
        1770.0,
        620.0,
        220.0
      ],
      "bbox_max": [
        1790.0,
        620.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1220.0,
      "bbox_min": [
        -100.0,
        250.0,
        59.9999885559082
      ],
      "bbox_max": [
        1770.0,
        1470.0,
        810.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1400.0,
      "bbox_min": [
        1250.0,
        1220.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        1470.0,
        784.9600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1630.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1470.0,
        400.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.49613896012306213,
        0.0,
        0.8682432174682617
      ],
      "plane_d": 711.9593505859375,
      "bbox_min": [
        1680.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1470.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -139.99998474121094,
      "bbox_min": [
        1680.0,
        1440.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1470.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -4.069010628882097e-06,
        1.220703143189894e-05
      ],
      "plane_d": 1695.00439453125,
      "bbox_min": [
        1680.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1695.0001220703125,
        1469.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1680.0,
        1450.0,
        135.0
      ],
      "bbox_max": [
        1695.0001220703125,
        1469.9998779296875,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1680.0,
        1442.5,
        135.0
      ],
      "bbox_max": [
        1695.0,
        1450.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        1680.0,
        1420.0,
        280.0
      ],
      "bbox_max": [
        1735.0,
        1469.9998779296875,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -139.99998474121094,
      "bbox_min": [
        1630.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1680.0,
        1470.0,
        140.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1630.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1680.0,
        1470.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.8944272398948669,
        -0.44721361994743347
      ],
      "plane_d": 1350.5850830078125,
      "bbox_min": [
        1660.0,
        1440.0,
        138.0
      ],
      "bbox_max": [
        1680.0,
        1441.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        1630.0,
        1440.0001220703125,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2938015743202413e-06,
        -0.7071091532707214,
        0.7071043252944946
      ],
      "plane_d": 940.45361328125,
      "bbox_min": [
        1630.0,
        1450.0,
        138.0
      ],
      "bbox_max": [
        1655.0001220703125,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070988416671753,
        -2.8772044515790185e-06,
        0.7071146368980408
      ],
      "plane_d": 1071.2567138671875,
      "bbox_min": [
        1653.0,
        1450.0,
        138.0
      ],
      "bbox_max": [
        1655.0001220703125,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070988416671753,
        -2.8772044515790185e-06,
        0.7071146368980408
      ],
      "plane_d": 1071.2567138671875,
      "bbox_min": [
        1653.0001220703125,
        1440.0001220703125,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8944272398948669,
        -0.44721361994743347
      ],
      "plane_d": 1350.5850830078125,
      "bbox_min": [
        1653.0001220703125,
        1440.0001220703125,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1441.0001220703125,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.2938015743202413e-06,
        -0.7071091532707214,
        0.7071043252944946
      ],
      "plane_d": 940.45361328125,
      "bbox_min": [
        1630.0,
        1441.0,
        120.0
      ],
      "bbox_max": [
        1680.0,
        1469.9998779296875,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1655.0,
        1450.0001220703125,
        120.0
      ],
      "bbox_max": [
        1680.0,
        1469.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        8.138020348269492e-06
      ],
      "plane_d": -1655.0009765625,
      "bbox_min": [
        1655.0,
        1450.0001220703125,
        120.0
      ],
      "bbox_max": [
        1655.0001220703125,
        1469.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1650.0,
        1441.0,
        120.0
      ],
      "bbox_max": [
        1680.0,
        1468.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070988416671753,
        -2.8772044515790185e-06,
        0.7071146368980408
      ],
      "plane_d": 1071.2567138671875,
      "bbox_min": [
        1650.0,
        1441.0,
        135.0
      ],
      "bbox_max": [
        1680.0,
        1468.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8944272398948669,
        -0.44721361994743347
      ],
      "plane_d": 1350.5850830078125,
      "bbox_min": [
        1650.0,
        1441.0,
        135.0
      ],
      "bbox_max": [
        1680.0,
        1442.5,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1650.0,
      "bbox_min": [
        1650.0,
        1442.5,
        120.0
      ],
      "bbox_max": [
        1655.0001220703125,
        1465.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        8.138020348269492e-06
      ],
      "plane_d": -1655.0009765625,
      "bbox_min": [
        1650.0,
        1442.5,
        120.0
      ],
      "bbox_max": [
        1655.0001220703125,
        1465.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1835996449226514e-05,
        -0.894424319267273,
        -0.44721946120262146
      ],
      "plane_d": 1350.545654296875,
      "bbox_min": [
        1650.0,
        1442.5,
        120.0
      ],
      "bbox_max": [
        1655.0001220703125,
        1450.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        1430.0,
        1400.0,
        115.65217590332031
      ],
      "bbox_max": [
        1630.0,
        1470.0,
        290.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        1460.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1535.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1535.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2938015743202413e-06,
        -0.7071091532707214,
        0.7071043252944946
      ],
      "plane_d": 940.45361328125,
      "bbox_min": [
        1587.455810546875,
        1467.9998779296875,
        138.0
      ],
      "bbox_max": [
        1630.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2938015743202413e-06,
        -0.7071091532707214,
        0.7071043252944946
      ],
      "plane_d": 940.45361328125,
      "bbox_min": [
        1580.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1468.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1460.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1460.0,
        1400.0,
        140.0
      ],
      "bbox_max": [
        1499.553466796875,
        1419.7767333984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        1250.0,
        1220.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        1400.0,
        784.9600830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1680.0,
      "bbox_min": [
        1660.0,
        1220.0,
        102.0
      ],
      "bbox_max": [
        1770.0,
        1400.0,
        280.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 1371.7872314453125,
      "bbox_min": [
        1660.0,
        1220.0,
        104.34782409667969
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.08662962168455124,
        0.9962406754493713
      ],
      "plane_d": 1.7325897216796875,
      "bbox_min": [
        1660.0,
        1220.0,
        104.34782409667969
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1660.0,
        1220.0,
        138.0
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.800000011920929,
        -0.0,
        -0.5999999642372131
      ],
      "plane_d": 1452.0,
      "bbox_min": [
        1680.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1400.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.800000011920929,
        -0.5999999642372131
      ],
      "plane_d": 1084.0,
      "bbox_min": [
        1680.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1400.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -139.99998474121094,
      "bbox_min": [
        1680.0,
        1250.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1400.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1680.0,
        1250.0,
        200.0
      ],
      "bbox_max": [
        1710.0,
        1360.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        1680.0,
        1290.0,
        220.0
      ],
      "bbox_max": [
        1700.0,
        1330.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 1096.015625,
      "bbox_min": [
        1680.0,
        1320.0,
        220.0
      ],
      "bbox_max": [
        1700.0,
        1330.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1320.0,
      "bbox_min": [
        1680.0,
        1320.0,
        230.0
      ],
      "bbox_max": [
        1700.0,
        1320.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 791.9596557617188,
      "bbox_min": [
        1680.0,
        1320.0,
        200.0
      ],
      "bbox_max": [
        1710.0,
        1360.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1360.0,
      "bbox_min": [
        1680.0,
        1360.0,
        210.0
      ],
      "bbox_max": [
        1700.0,
        1360.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        1695.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1755.0,
        1235.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -139.99998474121094,
      "bbox_min": [
        1710.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1755.0,
        1235.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -139.99998474121094,
      "bbox_min": [
        1680.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1710.0,
        1400.0,
        160.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        1695.0,
        1235.0,
        140.0
      ],
      "bbox_max": [
        1710.0,
        1235.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1629.9998779296875,
      "bbox_min": [
        1250.0,
        1220.0,
        100.0
      ],
      "bbox_max": [
        1660.0,
        1400.0,
        784.9600830078125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.08662962168455124,
        0.9962406754493713
      ],
      "plane_d": 1.7325897216796875,
      "bbox_min": [
        1630.0,
        1220.0,
        104.34782409667969
      ],
      "bbox_max": [
        1660.0,
        1400.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1300.0,
        1270.0,
        104.34782409667969
      ],
      "bbox_max": [
        1499.7767333984375,
        1400.0,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        1300.0,
        1270.0,
        104.34782409667969
      ],
      "bbox_max": [
        1499.7767333984375,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -70.71063232421875,
      "bbox_min": [
        1370.0,
        1270.0,
        138.0
      ],
      "bbox_max": [
        1499.7767333984375,
        1399.7767333984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        1350.0,
        1320.0,
        140.0
      ],
      "bbox_max": [
        1430.0,
        1400.0,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -139.99998474121094,
      "bbox_min": [
        1250.0,
        1220.0,
        100.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1270.0,
        141.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        1250.0,
        1220.0,
        100.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1270.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -70.71063232421875,
      "bbox_min": [
        1347.071044921875,
        1220.0,
        134.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1270.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211457371711731,
        0.3892177939414978,
        -0.0
      ],
      "plane_d": -1873.56640625,
      "bbox_min": [
        1494.6551513671875,
        1220.0,
        134.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1232.2733154296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211457371711731,
        -0.3892177939414978,
        0.0
      ],
      "plane_d": -919.9827270507812,
      "bbox_min": [
        1494.6551513671875,
        1220.0,
        134.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1225.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9211457371711731,
        -0.3892177939414978,
        0.0
      ],
      "plane_d": 1853.5870361328125,
      "bbox_min": [
        1494.6551513671875,
        1220.0,
        139.0
      ],
      "bbox_max": [
        1496.767822265625,
        1225.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -141.0,
      "bbox_min": [
        1494.6551513671875,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1235.4296875,
        141.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9211457371711731,
        0.3892177939414978,
        -0.0
      ],
      "plane_d": -1873.56640625,
      "bbox_min": [
        1494.6551513671875,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1232.2733154296875,
        141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211457371711731,
        -0.3892177939414978,
        0.0
      ],
      "plane_d": -919.9827270507812,
      "bbox_min": [
        1494.6551513671875,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1225.0,
        141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9211457371711731,
        -0.3892177939414978,
        0.0
      ],
      "plane_d": 1853.5870361328125,
      "bbox_min": [
        1494.6551513671875,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1496.767822265625,
        1225.0,
        141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -100.0,
        250.0,
        59.9999885559082
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        810.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        -100.0,
        830.0,
        100.0
      ],
      "bbox_max": [
        310.0,
        1050.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853102684021,
        -0.1950904279947281,
        0.0
      ],
      "plane_d": -59.91375732421875,
      "bbox_min": [
        107.05952453613281,
        881.3681640625,
        100.0
      ],
      "bbox_max": [
        310.0,
        1000.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853698730469,
        -0.195090189576149,
        0.0
      ],
      "plane_d": 77.39595031738281,
      "bbox_min": [
        107.05952453613281,
        934.9437866210938,
        130.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        175.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        260.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        310.0,
        980.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        260.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        310.0,
        960.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        310.0,
        420.0,
        59.9999885559082
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        810.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        1250.0,
        670.0,
        59.9999885559082
      ],
      "bbox_max": [
        1664.199951171875,
        707.730224609375,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        1426.0,
        670.0,
        59.9999885559082
      ],
      "bbox_max": [
        1664.199951171875,
        700.0,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        1426.0,
        670.0,
        78.0
      ],
      "bbox_max": [
        1664.199951171875,
        700.0,
        80.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 689.9999389648438,
      "bbox_min": [
        1426.0,
        690.0,
        78.0
      ],
      "bbox_max": [
        1430.0,
        690.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35897910594940186,
        0.0,
        -0.9333456754684448
      ],
      "plane_d": -522.745361328125,
      "bbox_min": [
        1438.0,
        670.0,
        78.0
      ],
      "bbox_max": [
        1664.199951171875,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4640069603919983,
        0.0,
        0.8858315348625183
      ],
      "plane_d": 632.1040649414062,
      "bbox_min": [
        1438.0,
        670.0,
        78.0
      ],
      "bbox_max": [
        1639.0,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4819187819957733,
        0.0,
        0.876215934753418
      ],
      "plane_d": -809.8425903320312,
      "bbox_min": [
        1535.0,
        670.0,
        78.0
      ],
      "bbox_max": [
        1639.0,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1639.0,
      "bbox_min": [
        1639.0,
        670.0,
        78.0
      ],
      "bbox_max": [
        1639.0,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1438.0,
        670.0,
        78.0
      ],
      "bbox_max": [
        1472.0,
        675.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1472.0,
      "bbox_min": [
        1470.0,
        670.0,
        78.0
      ],
      "bbox_max": [
        1472.0,
        675.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -675.0,
      "bbox_min": [
        1470.0,
        675.0,
        78.0
      ],
      "bbox_max": [
        1472.0,
        675.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1438.0,
      "bbox_min": [
        1438.0,
        670.0,
        78.0
      ],
      "bbox_max": [
        1440.0,
        675.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        1438.0,
        670.0,
        78.0
      ],
      "bbox_max": [
        1440.0,
        675.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -675.0,
      "bbox_min": [
        1438.0,
        675.0,
        78.0
      ],
      "bbox_max": [
        1440.0,
        675.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4640069603919983,
        0.0,
        0.8858315348625183
      ],
      "plane_d": 632.1040649414062,
      "bbox_min": [
        1438.0,
        670.0,
        59.9999885559082
      ],
      "bbox_max": [
        1571.3636474609375,
        680.25,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46400707960128784,
        0.0,
        -0.8858315944671631
      ],
      "plane_d": -633.8758544921875,
      "bbox_min": [
        1476.8182373046875,
        670.0,
        59.9999885559082
      ],
      "bbox_max": [
        1571.3636474609375,
        680.25,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1490.25,
      "bbox_min": [
        1490.25,
        670.25,
        65.0357437133789
      ],
      "bbox_max": [
        1490.25,
        680.0,
        66.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4819187819957733,
        0.0,
        0.876215934753418
      ],
      "plane_d": -809.8425903320312,
      "bbox_min": [
        1480.6363525390625,
        670.0,
        59.9999885559082
      ],
      "bbox_max": [
        1571.3636474609375,
        680.25,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48191872239112854,
        -0.0,
        -0.876215934753418
      ],
      "plane_d": 808.090087890625,
      "bbox_min": [
        1480.6363525390625,
        670.0,
        59.9999885559082
      ],
      "bbox_max": [
        1571.3636474609375,
        680.25,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        1535.0,
        670.0,
        59.9999885559082
      ],
      "bbox_max": [
        1571.3636474609375,
        680.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1560.0,
      "bbox_min": [
        1560.0,
        670.0,
        64.25
      ],
      "bbox_max": [
        1560.0,
        680.0,
        66.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1490.25,
      "bbox_min": [
        1480.6363525390625,
        670.0,
        59.99999237060547
      ],
      "bbox_max": [
        1567.7274169921875,
        680.25,
        65.0357437133789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -680.25,
      "bbox_min": [
        1480.6363525390625,
        680.25,
        59.99999237060547
      ],
      "bbox_max": [
        1490.25,
        680.25,
        65.0357437133789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1560.0,
      "bbox_min": [
        1560.0,
        670.0,
        59.999996185302734
      ],
      "bbox_max": [
        1567.7274169921875,
        680.0,
        64.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        1560.0,
        680.0,
        59.999996185302734
      ],
      "bbox_max": [
        1567.7274169921875,
        680.0,
        64.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        1438.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1472.0,
        675.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1438.0,
      "bbox_min": [
        1438.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1440.0,
        675.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -675.0,
      "bbox_min": [
        1438.0,
        675.0,
        60.0
      ],
      "bbox_max": [
        1440.0,
        675.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1470.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1472.0,
        675.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1472.0,
      "bbox_min": [
        1470.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1472.0,
        675.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -675.0,
      "bbox_min": [
        1470.0,
        675.0,
        60.0
      ],
      "bbox_max": [
        1472.0,
        675.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        1639.0,
        700.0,
        78.0
      ],
      "bbox_max": [
        1659.0,
        707.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1639.0,
      "bbox_min": [
        1639.0,
        700.0,
        78.0
      ],
      "bbox_max": [
        1639.0,
        707.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9383428692817688,
        0.3457059860229492
      ],
      "plane_d": 636.09765625,
      "bbox_min": [
        720.0,
        686.0,
        60.0
      ],
      "bbox_max": [
        1200.0,
        707.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271206855774,
        -0.0,
        0.4472135603427887
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        720.0,
        700.0,
        60.0
      ],
      "bbox_max": [
        1200.0,
        707.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -760.0,
      "bbox_min": [
        760.0,
        706.631591796875,
        78.0
      ],
      "bbox_max": [
        760.0,
        707.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271206855774,
        -0.0,
        0.4472135603427887
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        720.0,
        686.0,
        60.0
      ],
      "bbox_max": [
        760.0,
        707.3684692382812,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -760.0,
      "bbox_min": [
        760.0,
        686.0,
        78.0
      ],
      "bbox_max": [
        760.0,
        707.3684692382812,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        1250.0,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        1770.0,
        920.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        1480.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        920.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.09950372576713562,
        0.9950372576713562
      ],
      "plane_d": 11.940444946289062,
      "bbox_min": [
        1480.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        920.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1480.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1480.0,
        920.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        1639.0,
        707.730224609375,
        78.0
      ],
      "bbox_max": [
        1659.0,
        720.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1639.0,
      "bbox_min": [
        1639.0,
        707.730224609375,
        78.0
      ],
      "bbox_max": [
        1659.0,
        720.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1659.0,
      "bbox_min": [
        1659.0,
        707.730224609375,
        78.0
      ],
      "bbox_max": [
        1659.0,
        720.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -760.0,
      "bbox_min": [
        760.0,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        1200.0,
        1130.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        780.0,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        1200.0,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": 26.50357437133789,
      "bbox_min": [
        780.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07647190988063812,
        -0.07647190988063812,
        0.9941348433494568
      ],
      "plane_d": 57.35393142700195,
      "bbox_min": [
        833.4356689453125,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        1200.0,
        880.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9027172923088074,
        -0.0,
        0.43023425340652466
      ],
      "plane_d": -1109.0748291015625,
      "bbox_min": [
        1190.468017578125,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        1200.0,
        825.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9589435458183289,
        -0.03134186938405037,
        0.281859815120697
      ],
      "plane_d": -1141.786865234375,
      "bbox_min": [
        1190.468017578125,
        713.2186889648438,
        60.0
      ],
      "bbox_max": [
        1200.0,
        825.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        310.0,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        730.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271206855774,
        -0.0,
        0.4472135603427887
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        544.5025024414062,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        730.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -911.966796875,
      "bbox_min": [
        544.5025024414062,
        724.0,
        65.0
      ],
      "bbox_max": [
        565.7156982421875,
        755.2131958007812,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24342486262321472,
        -0.24342486262321472,
        -0.9388762712478638
      ],
      "plane_d": 123.0291976928711,
      "bbox_min": [
        544.5025024414062,
        743.2847290039062,
        79.0
      ],
      "bbox_max": [
        556.4309692382812,
        755.2131958007812,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        310.0,
        670.0,
        79.99999237060547
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        810.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        550.0,
        670.0,
        79.99999237060547
      ],
      "bbox_max": [
        1472.0,
        680.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -550.0,
      "bbox_min": [
        550.0,
        670.0,
        100.0
      ],
      "bbox_max": [
        550.0,
        680.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1438.0,
      "bbox_min": [
        1250.0,
        670.0,
        79.99999237060547
      ],
      "bbox_max": [
        1472.0,
        680.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 678.0,
      "bbox_min": [
        1438.0,
        670.0,
        79.99999237060547
      ],
      "bbox_max": [
        1472.0,
        680.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1472.0,
      "bbox_min": [
        1438.0,
        678.0,
        160.0
      ],
      "bbox_max": [
        1472.0,
        680.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 159.99998474121094,
      "bbox_min": [
        1438.0,
        678.0,
        160.0
      ],
      "bbox_max": [
        1472.0,
        680.0,
        160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1472.0,
      "bbox_min": [
        1470.0,
        670.0,
        79.99999237060547
      ],
      "bbox_max": [
        1472.0,
        678.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -675.0,
      "bbox_min": [
        1470.0,
        670.0,
        79.99999237060547
      ],
      "bbox_max": [
        1472.0,
        678.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 159.99998474121094,
      "bbox_min": [
        1470.0,
        670.0,
        160.0
      ],
      "bbox_max": [
        1472.0,
        675.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 159.99998474121094,
      "bbox_min": [
        1470.0,
        675.0,
        160.0
      ],
      "bbox_max": [
        1472.0,
        678.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        1438.0,
        670.0,
        79.99999237060547
      ],
      "bbox_max": [
        1470.0,
        678.0,
        338.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -675.0,
      "bbox_min": [
        1438.0,
        670.0,
        79.99999237060547
      ],
      "bbox_max": [
        1440.0,
        678.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1438.0,
        670.0,
        160.0
      ],
      "bbox_max": [
        1440.0,
        675.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1438.0,
        675.0,
        160.0
      ],
      "bbox_max": [
        1440.0,
        678.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 338.0,
      "bbox_min": [
        1440.0,
        670.0,
        338.0
      ],
      "bbox_max": [
        1470.0,
        678.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 257.9999694824219,
      "bbox_min": [
        1250.0,
        670.0,
        98.0
      ],
      "bbox_max": [
        1390.0,
        680.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1260.0,
      "bbox_min": [
        1260.0,
        670.0,
        258.0
      ],
      "bbox_max": [
        1260.0,
        680.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1310.0,
      "bbox_min": [
        1250.0,
        670.0,
        98.0
      ],
      "bbox_max": [
        1360.0,
        680.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1250.0,
        670.0,
        98.0
      ],
      "bbox_max": [
        1310.0,
        680.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7848828434944153,
        -0.6196443438529968
      ],
      "plane_d": -389.54974365234375,
      "bbox_min": [
        1300.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1310.0,
        680.0,
        232.6666717529297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1250.0,
        670.0,
        98.0
      ],
      "bbox_max": [
        1270.0,
        680.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1250.0,
        670.0,
        98.0
      ],
      "bbox_max": [
        1270.0,
        680.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1270.0,
      "bbox_min": [
        1270.0,
        670.0,
        98.0
      ],
      "bbox_max": [
        1270.0,
        680.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1360.0,
      "bbox_min": [
        1350.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1360.0,
        680.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1350.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1360.0,
        680.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7848828434944153,
        -0.6196443438529968
      ],
      "plane_d": -389.54974365234375,
      "bbox_min": [
        1350.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1360.0,
        680.0,
        232.6666717529297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 257.9999694824219,
      "bbox_min": [
        1659.0,
        670.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        680.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": 1009.5543212890625,
      "bbox_min": [
        1660.0,
        670.0,
        258.0
      ],
      "bbox_max": [
        1666.6666259765625,
        680.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35897910594940186,
        0.0,
        0.9333456754684448
      ],
      "plane_d": 520.878662109375,
      "bbox_min": [
        1659.0,
        670.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        680.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1664.199951171875,
        670.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        680.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1711.0,
        670.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        680.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.35897910594940186,
        0.0,
        -0.9333456754684448
      ],
      "plane_d": -522.745361328125,
      "bbox_min": [
        1664.199951171875,
        670.0,
        80.0
      ],
      "bbox_max": [
        1711.0,
        680.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1700.0,
      "bbox_min": [
        1690.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1750.0,
        680.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        1690.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1700.0,
        680.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7848828434944153,
        -0.6196443438529968
      ],
      "plane_d": -389.54974365234375,
      "bbox_min": [
        1690.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1700.0,
        680.0,
        232.6666717529297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1750.0,
      "bbox_min": [
        1740.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1750.0,
        680.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1740.0,
      "bbox_min": [
        1740.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1750.0,
        680.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7848828434944153,
        -0.6196443438529968
      ],
      "plane_d": -389.54974365234375,
      "bbox_min": [
        1740.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1750.0,
        680.0,
        232.6666717529297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        760.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1629.9998779296875,
      "bbox_min": [
        1300.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1760.0,
        1220.0,
        465.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1680.0,
      "bbox_min": [
        1630.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1760.0,
        1220.0,
        410.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.08662962168455124,
        0.9962406754493713
      ],
      "plane_d": 1.7325897216796875,
      "bbox_min": [
        1630.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1630.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -139.99998474121094,
      "bbox_min": [
        1630.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        1220.0,
        140.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1630.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        1220.0,
        140.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        1630.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1200.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.0,
      "bbox_min": [
        1630.0,
        1140.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1200.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 804.3154296875,
      "bbox_min": [
        1657.0,
        1140.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1657.0,
        1140.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1140.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -805.9794921875,
      "bbox_min": [
        1630.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1630.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 804.3154296875,
      "bbox_min": [
        1630.0,
        1140.0,
        120.0
      ],
      "bbox_max": [
        1657.0,
        1150.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1630.0,
        1120.0,
        120.0
      ],
      "bbox_max": [
        1632.9998779296875,
        1140.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        1630.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1650.0,
        1140.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1632.9998779296875,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1650.0,
        1140.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1650.0,
      "bbox_min": [
        1650.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1650.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        1680.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1760.0,
        1220.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1700.0,
      "bbox_min": [
        1690.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1760.0,
        1220.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1760.0,
        1120.0,
        325.0
      ],
      "bbox_max": [
        1760.0,
        1195.85791015625,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -339.41131591796875,
      "bbox_min": [
        1690.0,
        1210.0,
        100.0
      ],
      "bbox_max": [
        1700.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1690.0,
        1210.0,
        140.0
      ],
      "bbox_max": [
        1700.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        0.44721361994743347
      ],
      "plane_d": 1457.91650390625,
      "bbox_min": [
        1680.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1690.0,
        1220.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -339.41131591796875,
      "bbox_min": [
        1680.0,
        1200.0,
        100.0
      ],
      "bbox_max": [
        1690.0,
        1210.0,
        119.99986267089844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -339.41131591796875,
      "bbox_min": [
        1680.0,
        1200.0,
        100.0
      ],
      "bbox_max": [
        1690.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -139.99998474121094,
      "bbox_min": [
        1680.0,
        1200.0,
        140.0
      ],
      "bbox_max": [
        1690.0,
        1220.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        1300.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1220.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -139.99998474121094,
      "bbox_min": [
        1300.0,
        1170.0,
        134.0
      ],
      "bbox_max": [
        1630.0,
        1220.0,
        141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211457371711731,
        -0.3892177939414978,
        0.0
      ],
      "plane_d": -919.9827270507812,
      "bbox_min": [
        1496.767822265625,
        1217.7266845703125,
        134.0
      ],
      "bbox_max": [
        1514.232177734375,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9211457371711731,
        -0.3892177939414978,
        0.0
      ],
      "plane_d": 1853.5870361328125,
      "bbox_min": [
        1496.767822265625,
        1217.7266845703125,
        139.0
      ],
      "bbox_max": [
        1497.7283935546875,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -141.0,
      "bbox_min": [
        1496.767822265625,
        1217.7266845703125,
        140.0
      ],
      "bbox_max": [
        1514.232177734375,
        1220.0,
        141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211457371711731,
        -0.3892177939414978,
        0.0
      ],
      "plane_d": -919.9827270507812,
      "bbox_min": [
        1496.767822265625,
        1217.7266845703125,
        140.0
      ],
      "bbox_max": [
        1514.232177734375,
        1220.0,
        141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9211457371711731,
        -0.3892177939414978,
        0.0
      ],
      "plane_d": 1853.5870361328125,
      "bbox_min": [
        1496.767822265625,
        1217.7266845703125,
        140.0
      ],
      "bbox_max": [
        1497.7283935546875,
        1220.0,
        141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1555.0,
      "bbox_min": [
        1300.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1170.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1615.0,
      "bbox_min": [
        1555.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1170.0,
        465.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1555.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1615.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1555.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1615.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1555.0,
        1120.0,
        120.0
      ],
      "bbox_max": [
        1615.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 798.7683715820312,
      "bbox_min": [
        1590.0,
        1160.0,
        100.0
      ],
      "bbox_max": [
        1615.0,
        1170.0,
        116.66666412353516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1160.0,
      "bbox_min": [
        1590.0,
        1160.0,
        100.0
      ],
      "bbox_max": [
        1615.0,
        1170.0,
        116.66666412353516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        -0.8320502638816833
      ],
      "plane_d": -800.432373046875,
      "bbox_min": [
        1593.0,
        1160.0,
        100.0
      ],
      "bbox_max": [
        1615.0,
        1170.0,
        114.66666412353516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1615.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1615.0,
        1120.0,
        114.66666412353516
      ],
      "bbox_max": [
        1630.0,
        1170.0,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        1615.0,
        1120.0,
        114.66666412353516
      ],
      "bbox_max": [
        1630.0,
        1170.0,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 798.7683715820312,
      "bbox_min": [
        1617.0,
        1160.0,
        118.0
      ],
      "bbox_max": [
        1620.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1160.0,
      "bbox_min": [
        1617.0,
        1160.0,
        118.0
      ],
      "bbox_max": [
        1620.0,
        1160.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        -0.8320502638816833
      ],
      "plane_d": -800.432373046875,
      "bbox_min": [
        1615.0,
        1160.0,
        114.66666412353516
      ],
      "bbox_max": [
        1620.0,
        1170.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 798.7683715820312,
      "bbox_min": [
        1615.0,
        1160.0,
        114.66666412353516
      ],
      "bbox_max": [
        1620.0,
        1170.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1160.0,
      "bbox_min": [
        1615.0,
        1160.0,
        114.66666412353516
      ],
      "bbox_max": [
        1620.0,
        1160.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1455.0,
      "bbox_min": [
        1300.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1555.0,
        1170.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1395.0,
      "bbox_min": [
        1300.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1455.0,
        1170.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1395.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1455.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1395.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1455.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1395.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1455.0,
        1140.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1300.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1395.0,
        1170.0,
        260.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1389.9998779296875,
      "bbox_min": [
        1360.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1395.0,
        1140.0,
        260.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1360.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1390.0,
        1140.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1360.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1390.0,
        1140.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": -1171.6995849609375,
      "bbox_min": [
        1380.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1130.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1390.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1395.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1390.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1395.0,
        1140.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        1455.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1555.0,
        1170.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1535.0,
      "bbox_min": [
        1475.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1555.0,
        1170.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1475.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1535.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1475.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1535.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1475.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1535.0,
        1140.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1535.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1555.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1535.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1555.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1535.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1555.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1535.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1555.0,
        1140.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1455.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1475.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1455.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1475.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1455.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1475.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1455.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1475.0,
        1140.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        760.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1120.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        1250.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1120.0,
        515.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        1530.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1120.0,
        515.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        1600.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1120.0,
        515.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1629.9998779296875,
      "bbox_min": [
        1600.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1120.0,
        515.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1680.0,
      "bbox_min": [
        1630.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1120.0,
        410.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.13216373324394226,
        0.991227924823761
      ],
      "plane_d": 48.90058898925781,
      "bbox_min": [
        1630.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1630.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1680.0,
        1120.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1630.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1660.0,
        1120.0,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1650.0,
      "bbox_min": [
        1650.0,
        960.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        1120.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1660.0,
      "bbox_min": [
        1650.0,
        987.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        1000.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1650.0,
        1000.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        1000.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547002553939819,
        -0.8320503234863281
      ],
      "plane_d": -450.9713134765625,
      "bbox_min": [
        1650.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1660.0,
        990.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1650.0,
      "bbox_min": [
        1650.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1660.0,
        990.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1660.0,
      "bbox_min": [
        1650.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1660.0,
        990.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": 449.3072204589844,
      "bbox_min": [
        1650.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        1660.0,
        987.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1630.0,
        1030.0,
        138.0
      ],
      "bbox_max": [
        1680.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -139.99998474121094,
      "bbox_min": [
        1630.0,
        1030.0,
        138.0
      ],
      "bbox_max": [
        1680.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        1630.0,
        1030.0,
        138.0
      ],
      "bbox_max": [
        1680.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1660.0,
        1030.0,
        138.0
      ],
      "bbox_max": [
        1680.0,
        1030.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        1630.0,
        1030.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1050.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1630.0,
        1030.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1030.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        1680.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1120.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        1690.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1120.0,
        410.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        -0.6246950626373291,
        -0.0
      ],
      "plane_d": 1941.239990234375,
      "bbox_min": [
        1690.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1120.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688282966614,
        -0.6246950626373291,
        0.0
      ],
      "plane_d": -760.5662841796875,
      "bbox_min": [
        1700.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1120.0,
        410.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1700.0,
      "bbox_min": [
        1700.0,
        980.0,
        325.0
      ],
      "bbox_max": [
        1760.0,
        1120.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1700.0,
        980.0,
        325.0
      ],
      "bbox_max": [
        1760.0,
        1120.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1700.0,
        980.0,
        325.0
      ],
      "bbox_max": [
        1760.0,
        998.5078125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.780868411064148,
        -0.6246957182884216,
        -0.0
      ],
      "plane_d": 1951.2398681640625,
      "bbox_min": [
        1700.0,
        980.0,
        325.0
      ],
      "bbox_max": [
        1760.0,
        998.5078125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.780868411064148,
        -0.6246957182884216,
        0.0
      ],
      "plane_d": -750.5648193359375,
      "bbox_min": [
        1745.1937255859375,
        980.0,
        325.0
      ],
      "bbox_max": [
        1760.0,
        998.5078125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7273929715156555,
        -0.5819143652915955,
        0.36369648575782776
      ],
      "plane_d": 1771.92919921875,
      "bbox_min": [
        1690.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1710.0,
        995.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8921462297439575,
        -0.07137169688940048,
        0.44607311487197876
      ],
      "plane_d": 1534.1346435546875,
      "bbox_min": [
        1680.0,
        982.5,
        80.0
      ],
      "bbox_max": [
        1690.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7273929715156555,
        -0.5819143652915955,
        0.36369648575782776
      ],
      "plane_d": 1771.92919921875,
      "bbox_min": [
        1680.0,
        982.5,
        80.0
      ],
      "bbox_max": [
        1690.0,
        995.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": -1494.5458984375,
      "bbox_min": [
        1600.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1630.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1600.0,
        980.0,
        140.0
      ],
      "bbox_max": [
        1613.0,
        1110.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1605.0,
      "bbox_min": [
        1600.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1613.0,
        1110.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1600.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1605.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1605.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1613.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1600.0,
        980.0,
        140.0
      ],
      "bbox_max": [
        1605.0,
        1030.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1615.0,
      "bbox_min": [
        1600.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1630.0,
        1120.0,
        465.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1600.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1615.0,
        1110.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1605.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1615.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1600.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1615.0,
        1030.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1600.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1615.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1600.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1615.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1615.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1630.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1615.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1630.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1615.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1630.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        1600.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        960.0,
        360.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        1600.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        960.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1600.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        960.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1600.0,
        900.0,
        220.0
      ],
      "bbox_max": [
        1770.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1600.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        960.0,
        220.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1600.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1750.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1750.0,
      "bbox_min": [
        1750.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1750.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        1600.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1720.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1600.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1720.0,
        960.0,
        100.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1720.0,
      "bbox_min": [
        1720.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1720.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1700.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1720.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1720.0,
      "bbox_min": [
        1720.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1720.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1600.0,
        840.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        960.0,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        1630.0,
        840.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        960.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1630.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        960.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1630.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1630.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1630.0,
        940.0,
        118.0
      ],
      "bbox_max": [
        1650.0,
        960.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1650.0,
      "bbox_min": [
        1650.0,
        940.0,
        118.0
      ],
      "bbox_max": [
        1650.0,
        960.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        1750.0,
        840.0,
        118.0
      ],
      "bbox_max": [
        1750.0,
        920.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        1660.0,
        867.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        887.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        -0.44721361994743347,
        0.0
      ],
      "plane_d": 1881.427734375,
      "bbox_min": [
        1660.0,
        867.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        887.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.44721361994743347,
        0.0
      ],
      "plane_d": -1105.959228515625,
      "bbox_min": [
        1660.0,
        867.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        887.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -887.0,
      "bbox_min": [
        1660.0,
        887.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        887.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -989.9495849609375,
      "bbox_min": [
        1600.0,
        860.0,
        130.0
      ],
      "bbox_max": [
        1675.0,
        900.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -869.9999389648438,
      "bbox_min": [
        1600.0,
        860.0,
        200.0
      ],
      "bbox_max": [
        1620.0,
        900.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 859.9999389648438,
      "bbox_min": [
        1600.0,
        860.0,
        200.0
      ],
      "bbox_max": [
        1620.0,
        860.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 890.0,
      "bbox_min": [
        1600.0,
        890.0,
        200.0
      ],
      "bbox_max": [
        1620.0,
        900.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1600.0,
        900.0,
        200.0
      ],
      "bbox_max": [
        1620.0,
        900.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        0.0,
        0.24253562092781067
      ],
      "plane_d": 1578.9068603515625,
      "bbox_min": [
        1665.0,
        875.0,
        130.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 812.4943237304688,
      "bbox_min": [
        1665.0,
        875.0,
        130.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -894.9564819335938,
      "bbox_min": [
        1665.0,
        875.0,
        130.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        0.0,
        0.24253562092781067
      ],
      "plane_d": -1661.3690185546875,
      "bbox_min": [
        1665.0,
        875.0,
        130.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        -0.0,
        -0.24253562092781067
      ],
      "plane_d": 1651.6676025390625,
      "bbox_min": [
        1665.0,
        875.0,
        130.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": 885.2550048828125,
      "bbox_min": [
        1665.0,
        875.0,
        130.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": -822.1957397460938,
      "bbox_min": [
        1665.0,
        875.0,
        130.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        0.0,
        -0.24253562092781067
      ],
      "plane_d": -1588.6082763671875,
      "bbox_min": [
        1670.0,
        875.0,
        130.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 690.0,
      "bbox_min": [
        1600.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        840.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 700.0,
      "bbox_min": [
        1600.0,
        690.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        840.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1600.0,
        700.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        840.0,
        240.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        1600.0,
        700.0,
        80.0
      ],
      "bbox_max": [
        1750.0,
        810.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        1600.0,
        700.0,
        100.0
      ],
      "bbox_max": [
        1750.0,
        810.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1750.0,
      "bbox_min": [
        1750.0,
        700.0,
        100.0
      ],
      "bbox_max": [
        1750.0,
        810.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        1600.0,
        740.0,
        80.0
      ],
      "bbox_max": [
        1750.0,
        810.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1750.0,
      "bbox_min": [
        1750.0,
        740.0,
        80.0
      ],
      "bbox_max": [
        1750.0,
        810.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        1600.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        840.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1600.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        840.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1750.0,
      "bbox_min": [
        1750.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        840.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        1750.0,
        810.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        840.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1600.0,
        810.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        840.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -657.404052734375,
      "bbox_min": [
        1600.0,
        810.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        840.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1605.0,
      "bbox_min": [
        1600.0,
        810.0,
        140.0
      ],
      "bbox_max": [
        1605.0,
        840.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1600.0,
        810.0,
        160.0
      ],
      "bbox_max": [
        1605.0,
        840.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 257.9999694824219,
      "bbox_min": [
        1673.333251953125,
        690.0,
        245.33334350585938
      ],
      "bbox_max": [
        1770.0,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": 1009.5543212890625,
      "bbox_min": [
        1673.333251953125,
        690.0,
        258.0
      ],
      "bbox_max": [
        1680.0,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7848828434944153,
        -0.6196443438529968
      ],
      "plane_d": -389.54974365234375,
      "bbox_min": [
        1690.0,
        690.0,
        245.33334350585938
      ],
      "bbox_max": [
        1750.0,
        700.0,
        258.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1700.0,
      "bbox_min": [
        1690.0,
        690.0,
        245.33334350585938
      ],
      "bbox_max": [
        1750.0,
        700.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        1690.0,
        690.0,
        245.33334350585938
      ],
      "bbox_max": [
        1690.0,
        700.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1750.0,
      "bbox_min": [
        1740.0,
        690.0,
        245.33334350585938
      ],
      "bbox_max": [
        1750.0,
        700.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1740.0,
      "bbox_min": [
        1740.0,
        690.0,
        245.33334350585938
      ],
      "bbox_max": [
        1740.0,
        700.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 257.9999694824219,
      "bbox_min": [
        1666.6666259765625,
        680.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        690.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": 1009.5543212890625,
      "bbox_min": [
        1666.6666259765625,
        680.0,
        258.0
      ],
      "bbox_max": [
        1673.333251953125,
        690.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1690.0,
        680.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        690.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1711.0,
        680.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1711.0,
      "bbox_min": [
        1711.0,
        680.0,
        98.0
      ],
      "bbox_max": [
        1711.0,
        690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1700.0,
      "bbox_min": [
        1690.0,
        680.0,
        232.6666717529297
      ],
      "bbox_max": [
        1750.0,
        690.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        1690.0,
        680.0,
        232.6666717529297
      ],
      "bbox_max": [
        1700.0,
        690.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7848828434944153,
        -0.6196443438529968
      ],
      "plane_d": -389.54974365234375,
      "bbox_min": [
        1690.0,
        680.0,
        232.6666717529297
      ],
      "bbox_max": [
        1700.0,
        690.0,
        245.33334350585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1750.0,
      "bbox_min": [
        1740.0,
        680.0,
        232.6666717529297
      ],
      "bbox_max": [
        1750.0,
        690.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1740.0,
      "bbox_min": [
        1740.0,
        680.0,
        232.6666717529297
      ],
      "bbox_max": [
        1750.0,
        690.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7848828434944153,
        -0.6196443438529968
      ],
      "plane_d": -389.54974365234375,
      "bbox_min": [
        1740.0,
        680.0,
        232.6666717529297
      ],
      "bbox_max": [
        1750.0,
        690.0,
        245.33334350585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        1530.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        1120.0,
        515.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": -1494.5458984375,
      "bbox_min": [
        1530.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1659.7220458984375,
      "bbox_min": [
        1530.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1557.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        1110.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1557.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1600.0,
        1110.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1565.0,
      "bbox_min": [
        1565.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1565.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1565.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        1030.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1570.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1570.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1535.0,
      "bbox_min": [
        1530.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1571.0,
        1120.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1530.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1535.0,
        1110.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1530.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1535.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1530.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1535.0,
        1030.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1530.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1535.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1555.0,
      "bbox_min": [
        1535.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1571.0,
        1120.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1555.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1571.0,
        1110.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1555.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1565.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1555.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1571.0,
        1030.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1555.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1571.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1555.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1571.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1535.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1555.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1535.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1555.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1535.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1555.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1598.9998779296875,
        970.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        1530.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        960.0,
        360.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1530.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        960.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -220.0,
      "bbox_min": [
        1530.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        940.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1550.0,
        840.0,
        134.94479370117188
      ],
      "bbox_max": [
        1600.0,
        900.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -135.0,
      "bbox_min": [
        1550.0,
        840.0,
        134.94479370117188
      ],
      "bbox_max": [
        1600.0,
        900.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -884.0,
      "bbox_min": [
        1572.0,
        883.0,
        134.94479370117188
      ],
      "bbox_max": [
        1578.0,
        884.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1572.0,
      "bbox_min": [
        1572.0,
        883.0,
        134.94479370117188
      ],
      "bbox_max": [
        1578.0,
        884.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1578.0,
      "bbox_min": [
        1578.0,
        883.0,
        134.94479370117188
      ],
      "bbox_max": [
        1578.0,
        884.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 866.5,
      "bbox_min": [
        1572.0,
        866.5,
        134.94479370117188
      ],
      "bbox_max": [
        1578.0,
        867.5,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -867.5,
      "bbox_min": [
        1572.0,
        866.5,
        134.94479370117188
      ],
      "bbox_max": [
        1578.0,
        867.5,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1572.0,
      "bbox_min": [
        1572.0,
        866.5,
        134.94479370117188
      ],
      "bbox_max": [
        1578.0,
        867.5,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1578.0,
      "bbox_min": [
        1578.0,
        866.5,
        134.94479370117188
      ],
      "bbox_max": [
        1578.0,
        867.5,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1598.0,
      "bbox_min": [
        1550.0,
        840.0,
        135.0
      ],
      "bbox_max": [
        1600.0,
        900.0,
        160.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -138.5,
      "bbox_min": [
        1598.0,
        860.0,
        138.5
      ],
      "bbox_max": [
        1600.0,
        890.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        1598.0,
        860.0,
        138.5
      ],
      "bbox_max": [
        1600.0,
        890.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -860.0,
      "bbox_min": [
        1598.0,
        860.0,
        138.5
      ],
      "bbox_max": [
        1600.0,
        890.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 890.0,
      "bbox_min": [
        1598.0,
        890.0,
        138.5
      ],
      "bbox_max": [
        1600.0,
        890.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 900.0,
      "bbox_min": [
        1550.0,
        840.0,
        135.0
      ],
      "bbox_max": [
        1598.0,
        900.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -845.0,
      "bbox_min": [
        1568.0,
        840.0,
        135.0
      ],
      "bbox_max": [
        1598.0,
        890.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        1580.0,
        840.0,
        135.0
      ],
      "bbox_max": [
        1580.0,
        845.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 139.0,
      "bbox_min": [
        1568.0,
        860.0,
        135.0
      ],
      "bbox_max": [
        1582.0,
        890.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1568.0,
        860.0,
        139.0
      ],
      "bbox_max": [
        1582.0,
        890.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1568.0,
      "bbox_min": [
        1568.0,
        860.0,
        139.0
      ],
      "bbox_max": [
        1582.0,
        890.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1582.0,
      "bbox_min": [
        1568.0,
        860.0,
        139.0
      ],
      "bbox_max": [
        1582.0,
        890.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9535827040672302,
        -0.30113136768341064,
        0.0
      ],
      "plane_d": 1757.05126953125,
      "bbox_min": [
        1568.0,
        860.0,
        139.0
      ],
      "bbox_max": [
        1582.0,
        890.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9535827040672302,
        -0.30113136768341064,
        0.0
      ],
      "plane_d": -1246.734130859375,
      "bbox_min": [
        1568.0,
        860.0,
        139.0
      ],
      "bbox_max": [
        1582.0,
        890.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833214759827,
        0.3162277638912201,
        0.0
      ],
      "plane_d": 1208.938720703125,
      "bbox_min": [
        1568.0,
        860.0,
        139.0
      ],
      "bbox_max": [
        1582.0,
        890.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486833214759827,
        0.3162277638912201,
        -0.0
      ],
      "plane_d": -1779.4136962890625,
      "bbox_min": [
        1571.0,
        860.0,
        139.0
      ],
      "bbox_max": [
        1582.0,
        890.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 860.0,
      "bbox_min": [
        1571.0,
        860.0,
        139.0
      ],
      "bbox_max": [
        1579.0,
        890.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        1571.0,
        890.0,
        139.0
      ],
      "bbox_max": [
        1579.0,
        890.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 883.0,
      "bbox_min": [
        1572.0,
        866.5,
        135.0
      ],
      "bbox_max": [
        1578.0,
        884.0,
        139.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -884.0,
      "bbox_min": [
        1572.0,
        883.0,
        135.0
      ],
      "bbox_max": [
        1578.0,
        884.0,
        139.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1572.0,
      "bbox_min": [
        1572.0,
        883.0,
        135.0
      ],
      "bbox_max": [
        1578.0,
        884.0,
        139.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1578.0,
      "bbox_min": [
        1578.0,
        883.0,
        135.0
      ],
      "bbox_max": [
        1578.0,
        884.0,
        139.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 866.5,
      "bbox_min": [
        1572.0,
        866.5,
        135.0
      ],
      "bbox_max": [
        1578.0,
        867.5,
        139.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -867.5,
      "bbox_min": [
        1572.0,
        866.5,
        135.0
      ],
      "bbox_max": [
        1578.0,
        867.5,
        139.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1572.0,
      "bbox_min": [
        1572.0,
        866.5,
        135.0
      ],
      "bbox_max": [
        1578.0,
        867.5,
        139.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1578.0,
      "bbox_min": [
        1578.0,
        866.5,
        135.0
      ],
      "bbox_max": [
        1578.0,
        867.5,
        139.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1530.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1530.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1600.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1530.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1600.0,
        960.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -220.0,
      "bbox_min": [
        1530.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        840.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        1530.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        840.0,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1550.0,
      "bbox_min": [
        1550.0,
        810.0,
        134.94479370117188
      ],
      "bbox_max": [
        1562.5999755859375,
        840.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1550.0,
        810.0,
        134.94479370117188
      ],
      "bbox_max": [
        1562.5999755859375,
        840.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -830.0,
      "bbox_min": [
        1550.0,
        830.0,
        134.94479370117188
      ],
      "bbox_max": [
        1560.0,
        830.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1550.0,
        810.0,
        135.0
      ],
      "bbox_max": [
        1562.5999755859375,
        830.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1560.0,
      "bbox_min": [
        1550.0,
        810.0,
        135.0
      ],
      "bbox_max": [
        1560.0,
        830.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        1550.0,
        810.0,
        135.0
      ],
      "bbox_max": [
        1560.0,
        830.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -830.0,
      "bbox_min": [
        1550.0,
        830.0,
        135.0
      ],
      "bbox_max": [
        1560.0,
        830.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1530.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        760.0,
        135.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        1530.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        760.0,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        1530.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        760.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1535.0,
      "bbox_min": [
        1530.0,
        720.0,
        105.0
      ],
      "bbox_max": [
        1562.5999755859375,
        760.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1530.0,
        720.0,
        105.0
      ],
      "bbox_max": [
        1535.0,
        720.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1530.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1535.0,
        725.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -725.0,
      "bbox_min": [
        1530.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1535.0,
        725.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1535.0,
      "bbox_min": [
        1535.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1535.0,
        725.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1530.0,
        720.0,
        130.0
      ],
      "bbox_max": [
        1562.5999755859375,
        760.0,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1535.0,
      "bbox_min": [
        1530.0,
        720.0,
        130.0
      ],
      "bbox_max": [
        1562.5999755859375,
        760.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1530.0,
        720.0,
        130.0
      ],
      "bbox_max": [
        1535.0,
        720.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -725.0,
      "bbox_min": [
        1535.0,
        720.0,
        130.0
      ],
      "bbox_max": [
        1562.5999755859375,
        725.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1535.0,
        720.0,
        130.0
      ],
      "bbox_max": [
        1562.5999755859375,
        720.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -220.0,
      "bbox_min": [
        1562.5999755859375,
        720.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        840.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        1562.5999755859375,
        720.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        840.0,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1562.5999755859375,
        760.0,
        135.0
      ],
      "bbox_max": [
        1600.0,
        840.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -135.0,
      "bbox_min": [
        1562.5999755859375,
        760.0,
        135.0
      ],
      "bbox_max": [
        1600.0,
        840.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1580.0,
      "bbox_min": [
        1562.5999755859375,
        760.0,
        135.0
      ],
      "bbox_max": [
        1580.0,
        810.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1562.5999755859375,
        810.0,
        135.0
      ],
      "bbox_max": [
        1580.0,
        810.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1562.5999755859375,
        720.0,
        105.0
      ],
      "bbox_max": [
        1600.0,
        760.0,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        1562.5999755859375,
        720.0,
        105.0
      ],
      "bbox_max": [
        1600.0,
        725.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -725.0,
      "bbox_min": [
        1562.5999755859375,
        720.0,
        105.0
      ],
      "bbox_max": [
        1600.0,
        725.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        1562.5999755859375,
        720.0,
        105.0
      ],
      "bbox_max": [
        1600.0,
        725.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1562.5999755859375,
        720.0,
        105.0
      ],
      "bbox_max": [
        1600.0,
        720.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1562.5999755859375,
        720.0,
        130.0
      ],
      "bbox_max": [
        1600.0,
        725.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -725.0,
      "bbox_min": [
        1562.5999755859375,
        720.0,
        130.0
      ],
      "bbox_max": [
        1600.0,
        725.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1562.5999755859375,
        720.0,
        130.0
      ],
      "bbox_max": [
        1600.0,
        720.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        1250.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        515.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.2940859794616699,
        -0.955778956413269,
        0.0
      ],
      "plane_d": 511.26690673828125,
      "bbox_min": [
        1250.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1500.51611328125,
      "bbox_min": [
        1250.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": -1335.3399658203125,
      "bbox_min": [
        1397.0,
        969.1033325195312,
        80.0
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1397.0,
        969.1033325195312,
        80.0
      ],
      "bbox_max": [
        1453.0,
        1110.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1397.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1453.0,
        1110.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1445.0,
      "bbox_min": [
        1445.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1445.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1405.0,
        969.1033325195312,
        80.0
      ],
      "bbox_max": [
        1445.0001220703125,
        1030.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1410.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1440.0001220703125,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1410.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1440.0001220703125,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1580.1190185546875,
      "bbox_min": [
        1439.7935791015625,
        977.935302734375,
        95.87065124511719
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": -1414.94287109375,
      "bbox_min": [
        1477.0,
        992.9839477539062,
        140.0
      ],
      "bbox_max": [
        1530.0,
        1110.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1477.0,
        992.9839477539062,
        140.0
      ],
      "bbox_max": [
        1530.0,
        1110.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1525.0,
      "bbox_min": [
        1477.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1530.0,
        1110.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1477.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1525.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1525.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1530.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1485.0,
        992.9839477539062,
        140.0
      ],
      "bbox_max": [
        1525.0,
        1030.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1522.333251953125,
        1003.3321533203125,
        140.0
      ],
      "bbox_max": [
        1530.0,
        1079.999755859375,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1525.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1530.0,
        1079.999755859375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1455.0,
      "bbox_min": [
        1439.7935791015625,
        977.935302734375,
        95.87065124511719
      ],
      "bbox_max": [
        1488.7015380859375,
        1120.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1439.7935791015625,
        977.935302734375,
        95.87065124511719
      ],
      "bbox_max": [
        1455.0,
        1110.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1445.0001220703125,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1455.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1439.7935791015625,
        977.935302734375,
        95.87065124511719
      ],
      "bbox_max": [
        1455.0,
        1030.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1439.7935791015625,
        977.935302734375,
        95.87065124511719
      ],
      "bbox_max": [
        1446.5037841796875,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        1455.0,
        982.6141967773438,
        140.0
      ],
      "bbox_max": [
        1488.7015380859375,
        1120.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1475.0,
        988.76806640625,
        140.0
      ],
      "bbox_max": [
        1488.7015380859375,
        1110.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1475.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1485.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1475.0,
        988.76806640625,
        140.0
      ],
      "bbox_max": [
        1488.7015380859375,
        1030.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1455.0,
        982.6141967773438,
        140.0
      ],
      "bbox_max": [
        1475.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1395.0,
      "bbox_min": [
        1250.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1411.0001220703125,
        1120.0,
        465.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1395.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1411.0001220703125,
        1110.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1395.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1405.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1395.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1411.0001220703125,
        1030.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1395.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1411.0001220703125,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1395.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1411.0001220703125,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        1250.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1395.0,
        1120.0,
        330.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1389.9998779296875,
      "bbox_min": [
        1380.0,
        1050.0,
        90.66666412353516
      ],
      "bbox_max": [
        1395.0,
        1120.0,
        330.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": -1171.6995849609375,
      "bbox_min": [
        1380.0,
        1050.0,
        90.66666412353516
      ],
      "bbox_max": [
        1390.0,
        1120.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1380.0,
        1050.0,
        90.66666412353516
      ],
      "bbox_max": [
        1390.0,
        1120.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1380.0,
        1050.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1390.0,
        1050.0,
        140.0
      ],
      "bbox_max": [
        1395.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        1250.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1395.0,
        1050.0,
        283.118408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1347.5,
        960.0,
        80.0
      ],
      "bbox_max": [
        1395.0,
        1040.0,
        283.118408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": -1171.6995849609375,
      "bbox_min": [
        1347.5,
        960.0,
        80.0
      ],
      "bbox_max": [
        1390.0,
        1040.0,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -161.19998168945312,
      "bbox_min": [
        1381.4197998046875,
        960.0,
        160.0
      ],
      "bbox_max": [
        1390.0,
        962.6386108398438,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1381.4197998046875,
        960.0,
        160.0
      ],
      "bbox_max": [
        1390.0,
        962.6386108398438,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29408586025238037,
        -0.9557790756225586,
        0.0
      ],
      "plane_d": 521.2672119140625,
      "bbox_min": [
        1347.5,
        960.0,
        80.0
      ],
      "bbox_max": [
        1380.0,
        970.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1350.0,
        960.7692260742188,
        80.0
      ],
      "bbox_max": [
        1390.0,
        1040.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.29408586025238037,
        -0.9557790756225586,
        0.0
      ],
      "plane_d": 521.2672119140625,
      "bbox_min": [
        1350.0,
        960.7692260742188,
        80.0
      ],
      "bbox_max": [
        1380.0,
        970.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1380.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1390.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1380.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1390.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1390.0,
        962.6142578125,
        80.0
      ],
      "bbox_max": [
        1395.0,
        1040.0,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1390.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1395.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1390.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1395.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1390.0,
        962.6142578125,
        160.0
      ],
      "bbox_max": [
        1395.0,
        982.6386108398438,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -161.1999969482422,
      "bbox_min": [
        1390.0,
        962.6142578125,
        160.0
      ],
      "bbox_max": [
        1395.0,
        982.6386108398438,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -982.6386108398438,
      "bbox_min": [
        1390.0,
        982.6386108398438,
        160.0
      ],
      "bbox_max": [
        1395.0,
        982.6386108398438,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": -1171.6995849609375,
      "bbox_min": [
        1380.0,
        1040.0,
        89.33332824707031
      ],
      "bbox_max": [
        1395.0,
        1050.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1380.0,
        1040.0,
        89.33332824707031
      ],
      "bbox_max": [
        1395.0,
        1050.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1380.0,
        1040.0,
        140.0
      ],
      "bbox_max": [
        1395.0,
        1050.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": -1414.94287109375,
      "bbox_min": [
        1381.5037841796875,
        960.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        1005.691162109375,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1580.1190185546875,
      "bbox_min": [
        1381.5037841796875,
        960.0,
        80.0
      ],
      "bbox_max": [
        1522.333251953125,
        1003.3321533203125,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1488.7015380859375,
        960.0,
        80.0
      ],
      "bbox_max": [
        1522.333251953125,
        1003.3321533203125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1488.7015380859375,
        980.0,
        140.0
      ],
      "bbox_max": [
        1522.333251953125,
        1003.3321533203125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1490.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1520.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1490.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1520.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": -1335.3399658203125,
      "bbox_min": [
        1381.5037841796875,
        960.0,
        80.0
      ],
      "bbox_max": [
        1491.0,
        992.9839477539062,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1500.51611328125,
      "bbox_min": [
        1381.5037841796875,
        960.0,
        80.0
      ],
      "bbox_max": [
        1439.7935791015625,
        977.935302734375,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1411.0897216796875,
        960.0,
        80.0
      ],
      "bbox_max": [
        1439.7935791015625,
        977.935302734375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1414.0037841796875,
        970.0,
        80.0
      ],
      "bbox_max": [
        1439.7935791015625,
        977.935302734375,
        95.87065124511719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1381.5037841796875,
        960.0,
        160.0
      ],
      "bbox_max": [
        1395.0,
        964.1527099609375,
        161.1999969482422
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -161.19998168945312,
      "bbox_min": [
        1381.5037841796875,
        960.0,
        160.0
      ],
      "bbox_max": [
        1395.0,
        964.1527099609375,
        161.1999969482422
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1395.0,
      "bbox_min": [
        1395.0,
        960.0,
        160.0
      ],
      "bbox_max": [
        1395.0,
        964.1527099609375,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1439.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1491.0,
        992.9839477539062,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1446.5037841796875,
        980.0,
        140.0
      ],
      "bbox_max": [
        1490.0,
        992.9839477539062,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1439.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1491.0,
        980.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1519.0001220703125,
        970.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        1005.691162109375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1520.0,
        980.0,
        140.0
      ],
      "bbox_max": [
        1530.0,
        1005.691162109375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1519.0001220703125,
        970.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1250.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        350.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2940859794616699,
        -0.955778956413269,
        0.0
      ],
      "plane_d": 511.26690673828125,
      "bbox_min": [
        1250.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        80.0
      ],
      "bbox_max": [
        1381.5037841796875,
        960.0,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -161.19998168945312,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        161.1999969482422
      ],
      "bbox_max": [
        1381.5037841796875,
        960.0,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2630382478237152,
        -0.8548743724822998,
        -0.4472142457962036
      ],
      "plane_d": 528.8453979492188,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        80.0
      ],
      "bbox_max": [
        1381.5037841796875,
        960.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29408586025238037,
        -0.9557790756225586,
        0.0
      ],
      "plane_d": 521.2672119140625,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        80.0
      ],
      "bbox_max": [
        1381.5037841796875,
        960.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.2940855622291565,
        0.9557791948318481,
        0.0
      ],
      "plane_d": -511.7098693847656,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        98.0
      ],
      "bbox_max": [
        1381.5037841796875,
        960.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        98.0
      ],
      "bbox_max": [
        1381.5037841796875,
        960.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        100.0
      ],
      "bbox_max": [
        1381.5037841796875,
        960.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1250.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        350.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -880.0,
      "bbox_min": [
        1250.0,
        820.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        960.0,
        350.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 180.0,
      "bbox_min": [
        1281.0,
        820.0,
        160.0
      ],
      "bbox_max": [
        1330.0,
        880.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        1281.0,
        820.0,
        160.0
      ],
      "bbox_max": [
        1320.0,
        880.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": -733.4302978515625,
      "bbox_min": [
        1281.0,
        820.0,
        160.0
      ],
      "bbox_max": [
        1310.0,
        880.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1310.0,
      "bbox_min": [
        1281.0,
        820.0,
        160.0
      ],
      "bbox_max": [
        1310.0,
        880.0,
        179.49993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -845.0,
      "bbox_min": [
        1281.0,
        845.0,
        170.0
      ],
      "bbox_max": [
        1299.0,
        845.0,
        179.49993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        1281.0,
        840.0,
        170.0
      ],
      "bbox_max": [
        1300.0,
        880.0,
        180.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -845.0,
      "bbox_min": [
        1281.0,
        845.0,
        170.49998474121094
      ],
      "bbox_max": [
        1300.0,
        860.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 178.0,
      "bbox_min": [
        1299.0,
        850.0,
        173.60000610351562
      ],
      "bbox_max": [
        1300.0,
        860.0,
        178.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        1299.0,
        850.0,
        173.60000610351562
      ],
      "bbox_max": [
        1300.0,
        850.0,
        178.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.293938547372818,
        -0.9558243155479431,
        0.0
      ],
      "plane_d": 506.970947265625,
      "bbox_min": [
        1250.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        960.0,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1250.0,
        914.8063354492188,
        98.0
      ],
      "bbox_max": [
        1396.9600830078125,
        960.0,
        161.1999969482422
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1395.0,
      "bbox_min": [
        1395.0,
        959.397216796875,
        160.0
      ],
      "bbox_max": [
        1395.0,
        960.0,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1250.0,
        914.8063354492188,
        98.0
      ],
      "bbox_max": [
        1396.9600830078125,
        960.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1250.0,
        914.8063354492188,
        100.0
      ],
      "bbox_max": [
        1396.9600830078125,
        960.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.29408586025238037,
        0.9557790756225586,
        0.0
      ],
      "plane_d": -473.4782409667969,
      "bbox_min": [
        1250.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        960.0,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1250.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        950.7692260742188,
        125.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1380.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        950.7692260742188,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1445.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1480.0,
        950.7692260742188,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        1445.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1480.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27716064453125,
        0.9608235955238342,
        0.0
      ],
      "plane_d": -491.8677978515625,
      "bbox_min": [
        1276.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        1276.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        1290.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -910.0,
      "bbox_min": [
        1380.0,
        880.0,
        120.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1470.0,
      "bbox_min": [
        1470.0,
        880.0,
        120.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -910.0,
      "bbox_min": [
        1290.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1380.0,
      "bbox_min": [
        1290.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1470.0,
      "bbox_min": [
        1470.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1290.0,
      "bbox_min": [
        1290.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1290.0,
        884.0384521484375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1250.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1480.0,
        960.0,
        161.1999969482422
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1250.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1480.0,
        960.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.2940857708454132,
        -0.9557791352272034,
        0.0
      ],
      "plane_d": 492.5940246582031,
      "bbox_min": [
        1250.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1445.0,
        940.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        1340.0,
        907.6923217773438,
        98.0
      ],
      "bbox_max": [
        1445.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1340.0,
      "bbox_min": [
        1340.0,
        907.6923217773438,
        98.0
      ],
      "bbox_max": [
        1340.0,
        927.6923217773438,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1390.0,
        957.859619140625,
        160.0
      ],
      "bbox_max": [
        1395.0,
        959.397216796875,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1395.0,
      "bbox_min": [
        1395.0,
        957.859619140625,
        160.0
      ],
      "bbox_max": [
        1395.0,
        959.397216796875,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1480.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        100.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1480.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        100.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        1500.0,
        880.0,
        98.0
      ],
      "bbox_max": [
        1530.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1520.0,
      "bbox_min": [
        1500.0,
        880.0,
        98.0
      ],
      "bbox_max": [
        1520.0,
        904.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -491.9349670410156,
      "bbox_min": [
        1500.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1520.0,
        904.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1500.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1510.0,
        904.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1509.9998779296875,
      "bbox_min": [
        1510.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1510.0,
        904.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -491.9349670410156,
      "bbox_min": [
        1510.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1520.0,
        940.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1509.9998779296875,
      "bbox_min": [
        1510.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1520.0,
        940.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1519.9998779296875,
      "bbox_min": [
        1510.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1520.0,
        940.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        1510.0,
        930.0,
        83.00000762939453
      ],
      "bbox_max": [
        1520.0,
        930.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        1510.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1520.0,
        930.0,
        83.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1250.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        1500.0,
        720.0,
        338.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1250.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        1500.0,
        720.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 700.0,
      "bbox_min": [
        1390.0,
        680.0,
        98.0
      ],
      "bbox_max": [
        1500.0,
        720.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        1500.0,
        700.0,
        98.0
      ],
      "bbox_max": [
        1500.0,
        720.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": -711.0697021484375,
      "bbox_min": [
        1390.0,
        680.0,
        98.0
      ],
      "bbox_max": [
        1394.0,
        700.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1390.0,
        680.0,
        98.0
      ],
      "bbox_max": [
        1394.0,
        690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 689.9999389648438,
      "bbox_min": [
        1390.0,
        690.0,
        98.0
      ],
      "bbox_max": [
        1394.0,
        690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": -711.0697021484375,
      "bbox_min": [
        1390.0,
        690.0,
        80.0
      ],
      "bbox_max": [
        1430.0,
        700.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 709.2808227539062,
      "bbox_min": [
        1390.0,
        690.0,
        80.0
      ],
      "bbox_max": [
        1430.0,
        700.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 689.9999389648438,
      "bbox_min": [
        1390.0,
        690.0,
        80.0
      ],
      "bbox_max": [
        1430.0,
        700.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -699.9999389648438,
      "bbox_min": [
        1390.0,
        700.0,
        80.0
      ],
      "bbox_max": [
        1430.0,
        700.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        1260.0,
        680.0,
        232.6666717529297
      ],
      "bbox_max": [
        1383.3333740234375,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 257.9999694824219,
      "bbox_min": [
        1260.0,
        680.0,
        232.6666717529297
      ],
      "bbox_max": [
        1383.3333740234375,
        700.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        -0.0
      ],
      "plane_d": -1528.1990966796875,
      "bbox_min": [
        1260.0,
        680.0,
        258.0
      ],
      "bbox_max": [
        1383.3333740234375,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1260.0,
      "bbox_min": [
        1260.0,
        680.0,
        258.0
      ],
      "bbox_max": [
        1260.0,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7848828434944153,
        -0.6196443438529968
      ],
      "plane_d": -389.54974365234375,
      "bbox_min": [
        1300.0,
        680.0,
        232.6666717529297
      ],
      "bbox_max": [
        1360.0,
        700.0,
        258.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1310.0,
      "bbox_min": [
        1300.0,
        680.0,
        232.6666717529297
      ],
      "bbox_max": [
        1360.0,
        700.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1300.0,
        680.0,
        232.6666717529297
      ],
      "bbox_max": [
        1300.0,
        700.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1360.0,
      "bbox_min": [
        1350.0,
        680.0,
        232.6666717529297
      ],
      "bbox_max": [
        1360.0,
        700.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1350.0,
        680.0,
        232.6666717529297
      ],
      "bbox_max": [
        1350.0,
        700.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        760.0,
        701.7156982421875,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        810.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -707.730224609375,
      "bbox_min": [
        780.0,
        701.7156982421875,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9383428692817688,
        0.3457059860229492
      ],
      "plane_d": 636.09765625,
      "bbox_min": [
        788.2843017578125,
        701.7156982421875,
        80.0
      ],
      "bbox_max": [
        1190.468017578125,
        707.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9027172923088074,
        -0.0,
        0.43023425340652466
      ],
      "plane_d": -1109.0748291015625,
      "bbox_min": [
        1190.0,
        707.368408203125,
        80.0
      ],
      "bbox_max": [
        1190.468017578125,
        707.730224609375,
        80.98199462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -61.2132568359375,
      "bbox_min": [
        788.2843017578125,
        701.7156982421875,
        118.0
      ],
      "bbox_max": [
        794.298828125,
        707.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        780.0,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -860.0,
      "bbox_min": [
        820.0,
        930.0,
        108.0
      ],
      "bbox_max": [
        860.0,
        970.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        820.0,
        930.0,
        108.0
      ],
      "bbox_max": [
        860.0,
        970.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 107.99999237060547,
      "bbox_min": [
        840.0,
        930.0,
        108.0
      ],
      "bbox_max": [
        860.0,
        970.0,
        108.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": -474.04644775390625,
      "bbox_min": [
        820.0,
        930.0,
        110.0
      ],
      "bbox_max": [
        840.0,
        950.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1235.0,
      "bbox_min": [
        794.298828125,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        794.298828125,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        120.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        794.298828125,
        707.730224609375,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        794.298828125,
        707.730224609375,
        118.0
      ],
      "bbox_max": [
        1200.0,
        935.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        1000.0,
        935.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        794.298828125,
        707.730224609375,
        118.0
      ],
      "bbox_max": [
        1200.0,
        930.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1190.0,
      "bbox_min": [
        794.298828125,
        707.730224609375,
        118.0
      ],
      "bbox_max": [
        1190.0,
        867.8525390625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -61.2132568359375,
      "bbox_min": [
        794.298828125,
        707.730224609375,
        118.0
      ],
      "bbox_max": [
        926.1368408203125,
        867.8525390625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        900.2081909179688,
        841.9238891601562,
        118.0
      ],
      "bbox_max": [
        926.1368408203125,
        867.8525390625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -887.8524780273438,
      "bbox_min": [
        926.1368408203125,
        867.8525390625,
        118.0
      ],
      "bbox_max": [
        1200.0,
        930.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        882.0,
        118.0
      ],
      "bbox_max": [
        1000.0,
        887.8524780273438,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        946.1367797851562,
        887.8524780273438,
        118.0
      ],
      "bbox_max": [
        1113.0,
        930.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        887.8524780273438,
        118.0
      ],
      "bbox_max": [
        1113.0,
        930.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": -715.5632934570312,
      "bbox_min": [
        1100.0,
        887.8524780273438,
        118.0
      ],
      "bbox_max": [
        1113.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1100.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        1113.0,
        900.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        1200.0,
        867.8525390625,
        118.0
      ],
      "bbox_max": [
        1235.0,
        887.8524780273438,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -887.8524780273438,
      "bbox_min": [
        1200.0,
        887.8524780273438,
        118.0
      ],
      "bbox_max": [
        1215.0,
        887.8524780273438,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10468478500843048,
        0.9945054650306702
      ],
      "plane_d": 17.796409606933594,
      "bbox_min": [
        1010.0,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        1010.0,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8395703434944153,
        0.5432510375976562
      ],
      "plane_d": -782.281982421875,
      "bbox_min": [
        1010.0,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1235.0,
        920.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1190.0,
      "bbox_min": [
        1190.0,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1194.1214599609375,
        825.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9589435458183289,
        -0.03134186938405037,
        0.281859815120697
      ],
      "plane_d": -1141.786865234375,
      "bbox_min": [
        1190.0,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1194.1214599609375,
        825.0,
        94.02200317382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9027172923088074,
        -0.0,
        0.43023425340652466
      ],
      "plane_d": -1109.0748291015625,
      "bbox_min": [
        1190.0,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1190.468017578125,
        713.2186279296875,
        80.98199462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        1014.1600952148438,
        867.8525390625,
        80.0
      ],
      "bbox_max": [
        1235.0,
        920.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1080.0,
        887.8524780273438,
        80.0
      ],
      "bbox_max": [
        1235.0,
        920.0,
        118.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1110.0,
        887.8524780273438,
        98.0
      ],
      "bbox_max": [
        1235.0,
        920.0,
        118.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 900.0,
      "bbox_min": [
        1125.0,
        887.8524780273438,
        98.0
      ],
      "bbox_max": [
        1235.0,
        910.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -910.0,
      "bbox_min": [
        1125.0,
        910.0,
        98.0
      ],
      "bbox_max": [
        1140.0,
        910.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1137.0,
        887.8524780273438,
        98.0
      ],
      "bbox_max": [
        1150.0,
        900.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 887.8524780273438,
      "bbox_min": [
        1137.0,
        887.8524780273438,
        98.0
      ],
      "bbox_max": [
        1150.0,
        887.8524780273438,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5547002553939819,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": -715.5632934570312,
      "bbox_min": [
        1110.0,
        887.8524780273438,
        100.0
      ],
      "bbox_max": [
        1140.0,
        900.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1110.0,
        887.8524780273438,
        100.0
      ],
      "bbox_max": [
        1140.0,
        900.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 887.8524780273438,
      "bbox_min": [
        1110.0,
        887.8524780273438,
        100.0
      ],
      "bbox_max": [
        1140.0,
        887.8524780273438,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -909.9999389648438,
      "bbox_min": [
        1080.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1130.0,
        910.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 900.0,
      "bbox_min": [
        1080.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1130.0,
        910.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1095.0,
      "bbox_min": [
        1095.0,
        900.0,
        84.0000228881836
      ],
      "bbox_max": [
        1095.0,
        910.0,
        86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1095.0,
      "bbox_min": [
        1095.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1095.0,
        910.0,
        84.0000228881836
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10468478500843048,
        0.9945054650306702
      ],
      "plane_d": 17.796409606933594,
      "bbox_min": [
        1235.0,
        867.8525390625,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8395703434944153,
        0.5432510375976562
      ],
      "plane_d": -782.281982421875,
      "bbox_min": [
        1235.0,
        867.8525390625,
        80.0
      ],
      "bbox_max": [
        1250.0,
        920.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        1235.0,
        867.8525390625,
        98.0
      ],
      "bbox_max": [
        1250.0,
        920.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1235.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1235.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1235.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 900.0,
      "bbox_min": [
        1235.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        900.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        760.0,
        701.7157592773438,
        120.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        810.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -707.730224609375,
      "bbox_min": [
        780.0,
        707.730224609375,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        780.0,
        707.730224609375,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        1010.0,
        707.730224609375,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1010.0,
        930.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": 934.0531005859375,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9992009997367859,
        -0.0,
        0.039968036115169525
      ],
      "plane_d": -1194.2449951171875,
      "bbox_min": [
        1050.0,
        940.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.4156494140625,
      "bbox_min": [
        1050.0,
        940.0,
        130.0
      ],
      "bbox_max": [
        1190.0,
        970.4000244140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.42615509033203,
      "bbox_min": [
        1050.0,
        940.0,
        130.0
      ],
      "bbox_max": [
        1050.4000244140625,
        940.7999877929688,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968152642250061,
        -0.0,
        0.07974522560834885
      ],
      "plane_d": -1206.545166015625,
      "bbox_min": [
        1189.5999755859375,
        940.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        970.0000610351562,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.4156494140625,
      "bbox_min": [
        1189.5999755859375,
        960.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        970.0000610351562,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": 701.69580078125,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        940.4000244140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.42615509033203,
      "bbox_min": [
        1040.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        940.4000244140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968152642250061,
        -0.0,
        0.07974522560834885
      ],
      "plane_d": -1206.545166015625,
      "bbox_min": [
        1199.199951171875,
        930.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        940.4000244140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": 916.6713256835938,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        936.6666870117188,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.42615509033203,
      "bbox_min": [
        1040.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        936.6666870117188,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968152642250061,
        -0.0,
        0.07974522560834885
      ],
      "plane_d": -1206.545166015625,
      "bbox_min": [
        1199.199951171875,
        930.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        936.6666870117188,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1060.0,
      "bbox_min": [
        1014.1600952148438,
        707.730224609375,
        120.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        1014.1600952148438,
        867.8525390625,
        120.0
      ],
      "bbox_max": [
        1060.0,
        867.8525390625,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        1060.0,
        747.730224609375,
        120.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1107.5,
        825.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1117.5,
      "bbox_min": [
        1107.5,
        825.0,
        120.0
      ],
      "bbox_max": [
        1142.5,
        867.8525390625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -135.0,
      "bbox_min": [
        1107.5,
        825.0,
        135.0
      ],
      "bbox_max": [
        1117.5,
        867.8525390625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1107.5,
      "bbox_min": [
        1107.5,
        825.0,
        135.0
      ],
      "bbox_max": [
        1107.5,
        867.8525390625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -135.0,
      "bbox_min": [
        1132.5,
        825.0,
        135.0
      ],
      "bbox_max": [
        1142.5,
        867.8525390625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 747.730224609375,
      "bbox_min": [
        1100.0,
        747.730224609375,
        120.0
      ],
      "bbox_max": [
        1150.0,
        785.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1150.0,
        747.730224609375,
        120.0
      ],
      "bbox_max": [
        1150.0,
        785.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        760.0,
        701.7157592773438,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        810.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -707.730224609375,
      "bbox_min": [
        760.0,
        701.7157592773438,
        140.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        555.5635375976562
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        760.0,
        701.7157592773438,
        140.0
      ],
      "bbox_max": [
        766.0144653320312,
        707.730224609375,
        232.14804077148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.27159881591797,
      "bbox_min": [
        760.0,
        701.7157592773438,
        220.0
      ],
      "bbox_max": [
        766.0144653320312,
        707.730224609375,
        232.14804077148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.27159881591797,
      "bbox_min": [
        762.6031494140625,
        707.730224609375,
        140.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        555.5635375976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        766.0144653320312,
        707.730224609375,
        140.0
      ],
      "bbox_max": [
        926.1367797851562,
        867.8525390625,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1060.0,
        707.730224609375,
        140.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        290.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1107.5,
        825.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1117.5,
      "bbox_min": [
        1107.5,
        825.0,
        140.0
      ],
      "bbox_max": [
        1142.5,
        867.8525390625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 145.0,
      "bbox_min": [
        1107.5,
        825.0,
        140.0
      ],
      "bbox_max": [
        1117.5,
        867.8525390625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1107.5,
      "bbox_min": [
        1107.5,
        825.0,
        140.0
      ],
      "bbox_max": [
        1107.5,
        867.8525390625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        1117.5,
        825.0,
        145.0
      ],
      "bbox_max": [
        1142.5,
        867.8525390625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 145.0,
      "bbox_min": [
        1132.5,
        825.0,
        145.0
      ],
      "bbox_max": [
        1142.5,
        867.8525390625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1060.0,
      "bbox_min": [
        1060.0,
        707.730224609375,
        140.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 195.0,
      "bbox_min": [
        1060.0,
        707.730224609375,
        140.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -319.8031005859375,
      "bbox_min": [
        1150.0,
        707.730224609375,
        195.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1150.0,
        785.0,
        195.0
      ],
      "bbox_max": [
        1150.0,
        825.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 179.99998474121094,
      "bbox_min": [
        1060.0,
        707.730224609375,
        140.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        195.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1060.0,
        707.730224609375,
        180.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        195.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -319.8031005859375,
      "bbox_min": [
        1061.0,
        707.730224609375,
        190.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1272.085205078125,
      "bbox_min": [
        1061.0,
        709.0,
        190.0
      ],
      "bbox_max": [
        1170.0,
        825.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 749.0,
      "bbox_min": [
        1130.0,
        749.0,
        190.0
      ],
      "bbox_max": [
        1170.0,
        825.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1170.0,
      "bbox_min": [
        1170.0,
        749.0,
        190.0
      ],
      "bbox_max": [
        1170.0,
        770.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -319.8030090332031,
      "bbox_min": [
        1130.0,
        707.730224609375,
        180.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 749.0,
      "bbox_min": [
        1130.0,
        749.0,
        180.0
      ],
      "bbox_max": [
        1170.0,
        825.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1170.0,
      "bbox_min": [
        1170.0,
        749.0,
        180.0
      ],
      "bbox_max": [
        1170.0,
        770.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 747.730224609375,
      "bbox_min": [
        1100.0,
        747.730224609375,
        140.0
      ],
      "bbox_max": [
        1150.0,
        785.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1150.0,
        747.730224609375,
        140.0
      ],
      "bbox_max": [
        1150.0,
        785.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2940859794616699,
        -0.955778956413269,
        0.0
      ],
      "plane_d": 511.26690673828125,
      "bbox_min": [
        1240.0,
        911.7310791015625,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1050.0,
        330.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        1240.0,
        916.4603881835938,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1050.0,
        330.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        1240.0,
        916.4603881835938,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1040.0,
        283.118408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2630382478237152,
        -0.8548743724822998,
        -0.4472142457962036
      ],
      "plane_d": 528.8453979492188,
      "bbox_min": [
        1240.0,
        916.4603881835938,
        140.0
      ],
      "bbox_max": [
        1250.0,
        930.0,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -161.19998168945312,
      "bbox_min": [
        1240.0,
        916.4603881835938,
        160.0
      ],
      "bbox_max": [
        1250.0,
        919.5852661132812,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1240.0,
        916.4603881835938,
        160.0
      ],
      "bbox_max": [
        1250.0,
        919.5852661132812,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -161.19998168945312,
      "bbox_min": [
        1240.0,
        911.7310791015625,
        160.0
      ],
      "bbox_max": [
        1250.0,
        919.5372924804688,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1240.0,
        911.7310791015625,
        160.0
      ],
      "bbox_max": [
        1250.0,
        919.5372924804688,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.293938547372818,
        -0.9558243155479431,
        0.0
      ],
      "plane_d": 506.970947265625,
      "bbox_min": [
        1240.0,
        911.7310791015625,
        160.0
      ],
      "bbox_max": [
        1250.0,
        914.8063354492188,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9992009997367859,
        -0.0,
        0.039968036115169525
      ],
      "plane_d": -1194.2449951171875,
      "bbox_min": [
        1030.0,
        950.0,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        1109.5999755859375,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9993880391120911,
        0.034978583455085754
      ],
      "plane_d": 936.1267700195312,
      "bbox_min": [
        1030.0,
        950.0,
        140.0
      ],
      "bbox_max": [
        1189.5999755859375,
        980.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.42615509033203,
      "bbox_min": [
        1050.0,
        950.0,
        255.0000762939453
      ],
      "bbox_max": [
        1060.0,
        960.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": -1192.56982421875,
      "bbox_min": [
        1171.9998779296875,
        950.0,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        1100.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9993880391120911,
        0.034978583455085754
      ],
      "plane_d": 936.1267700195312,
      "bbox_min": [
        1171.9998779296875,
        950.0,
        380.0
      ],
      "bbox_max": [
        1180.0,
        957.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968152642250061,
        -0.0,
        0.07974522560834885
      ],
      "plane_d": -1206.545166015625,
      "bbox_min": [
        1180.0,
        950.0,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        970.0000610351562,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.4156494140625,
      "bbox_min": [
        1180.0,
        960.4000244140625,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        970.0000610351562,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 957.0,
      "bbox_min": [
        1037.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1173.0,
      "bbox_min": [
        1173.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35496851801872253,
        -0.9348782300949097,
        0.0
      ],
      "plane_d": 598.481689453125,
      "bbox_min": [
        807.7501220703125,
        968.6068725585938,
        170.0
      ],
      "bbox_max": [
        946.9471435546875,
        1099.6556396484375,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35496851801872253,
        -0.9348782300949097,
        -0.0
      ],
      "plane_d": 1212.5772705078125,
      "bbox_min": [
        807.7501220703125,
        968.6068725585938,
        170.0
      ],
      "bbox_max": [
        946.9471435546875,
        1099.6556396484375,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112825989723206,
        0.4117816090583801,
        0.0
      ],
      "plane_d": -1293.248291015625,
      "bbox_min": [
        922.2498779296875,
        990.3443603515625,
        170.0
      ],
      "bbox_max": [
        946.9471435546875,
        1099.6556396484375,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112825989723206,
        -0.4117816090583801,
        0.0
      ],
      "plane_d": -432.6246337890625,
      "bbox_min": [
        922.2498779296875,
        990.3443603515625,
        170.0
      ],
      "bbox_max": [
        946.9471435546875,
        1045.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": 934.0531005859375,
      "bbox_min": [
        950.0,
        900.0,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968152642250061,
        -0.0,
        0.07974522560834885
      ],
      "plane_d": -1206.545166015625,
      "bbox_min": [
        995.8233032226562,
        940.3999633789062,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9992009997367859,
        -0.0,
        0.039968036115169525
      ],
      "plane_d": -1194.2449951171875,
      "bbox_min": [
        995.8233032226562,
        940.3999633789062,
        140.0
      ],
      "bbox_max": [
        1189.5999755859375,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.42615509033203,
      "bbox_min": [
        995.8233032226562,
        940.3999633789062,
        140.0
      ],
      "bbox_max": [
        1055.0,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.27159881591797,
      "bbox_min": [
        995.8233032226562,
        943.5999755859375,
        220.0
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        245.16859436035156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": 916.6713256835938,
      "bbox_min": [
        950.0,
        900.0,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        950.0,
        380.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9968152642250061,
        -0.0,
        0.07974522560834885
      ],
      "plane_d": -1206.545166015625,
      "bbox_min": [
        986.7498168945312,
        930.7999877929688,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.42615509033203,
      "bbox_min": [
        986.7498168945312,
        930.7999877929688,
        140.0
      ],
      "bbox_max": [
        1163.3333740234375,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        986.7498168945312,
        930.7999877929688,
        140.0
      ],
      "bbox_max": [
        1001.8842163085938,
        944.6067504882812,
        263.4952392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.27159881591797,
      "bbox_min": [
        986.7498168945312,
        937.2000122070312,
        220.0
      ],
      "bbox_max": [
        1001.8842163085938,
        944.6067504882812,
        263.4952392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": 701.69580078125,
      "bbox_min": [
        1046.6666259765625,
        936.6666870117188,
        140.0
      ],
      "bbox_max": [
        1163.3333740234375,
        940.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.27159881591797,
      "bbox_min": [
        950.0,
        900.0,
        140.0
      ],
      "bbox_max": [
        995.4842529296875,
        940.6796264648438,
        337.72265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        958.2842407226562,
        900.0,
        140.0
      ],
      "bbox_max": [
        995.4842529296875,
        937.2000122070312,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.27159881591797,
      "bbox_min": [
        892.7614135742188,
        900.0,
        249.50100708007812
      ],
      "bbox_max": [
        950.0,
        924.7737426757812,
        453.3333435058594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 957.0,
      "bbox_min": [
        1037.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1173.0,
      "bbox_min": [
        1050.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.707107663154602,
        -0.7071058750152588,
        0.0
      ],
      "plane_d": 1496.9451904296875,
      "bbox_min": [
        1050.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        994.14208984375,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -1515.329833984375,
      "bbox_min": [
        1148.85791015625,
        970.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        994.14208984375,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707107663154602,
        -0.7071058750152588,
        0.0
      ],
      "plane_d": -65.76275634765625,
      "bbox_min": [
        1050.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1074.14208984375,
        981.1421508789062,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.27159881591797,
      "bbox_min": [
        831.906494140625,
        867.8525390625,
        140.0
      ],
      "bbox_max": [
        958.2842407226562,
        900.0,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        926.1367797851562,
        867.8525390625,
        140.0
      ],
      "bbox_max": [
        958.2842407226562,
        900.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        310.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1000.0,
        460.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        310.0,
        749.9961547851562,
        80.0
      ],
      "bbox_max": [
        720.0,
        1000.0,
        460.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        720.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        720.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        700.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        440.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        310.0,
        749.9961547851562,
        80.0
      ],
      "bbox_max": [
        559.7156982421875,
        980.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        310.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        440.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071070671081543,
        -0.7071065902709961,
        0.0
      ],
      "plane_d": 176.77639770507812,
      "bbox_min": [
        410.03387451171875,
        749.9961547851562,
        80.0
      ],
      "bbox_max": [
        559.7156982421875,
        869.8349609375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6504544615745544,
        -0.7595453858375549,
        0.0
      ],
      "plane_d": 302.95068359375,
      "bbox_min": [
        410.03387451171875,
        749.9961547851562,
        360.0
      ],
      "bbox_max": [
        549.9862060546875,
        869.8349609375,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4225330054759979,
        -0.49339815974235535,
        0.7602789998054504
      ],
      "plane_d": -152.93255615234375,
      "bbox_min": [
        450.3636474609375,
        749.9961547851562,
        360.0
      ],
      "bbox_max": [
        549.9862060546875,
        837.8707885742188,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48428842425346375,
        -0.4842880964279175,
        0.7286493182182312
      ],
      "plane_d": -177.67437744140625,
      "bbox_min": [
        499.9961853027344,
        749.9961547851562,
        360.0
      ],
      "bbox_max": [
        549.9862060546875,
        837.8707885742188,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7121667861938477,
        0.7020103335380554,
        -0.0
      ],
      "plane_d": -953.280517578125,
      "bbox_min": [
        512.6419067382812,
        799.9862060546875,
        360.0
      ],
      "bbox_max": [
        549.9862060546875,
        837.8707885742188,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24342486262321472,
        -0.24342486262321472,
        -0.9388762712478638
      ],
      "plane_d": 123.0291976928711,
      "bbox_min": [
        553.146240234375,
        750.0,
        80.0
      ],
      "bbox_max": [
        559.7156982421875,
        753.2847290039062,
        81.70327758789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 91.92388916015625,
      "bbox_min": [
        410.0213928222656,
        680.0,
        80.0
      ],
      "bbox_max": [
        620.0,
        750.0,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        7.630560139659792e-05,
        -1.0,
        0.0
      ],
      "plane_d": 749.9580078125,
      "bbox_min": [
        410.0213928222656,
        680.0,
        80.0
      ],
      "bbox_max": [
        620.0,
        750.0,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6504544615745544,
        -0.7595453858375549,
        0.0
      ],
      "plane_d": 302.95068359375,
      "bbox_min": [
        410.0213928222656,
        749.9893188476562,
        360.0
      ],
      "bbox_max": [
        410.03387451171875,
        750.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -550.0,
      "bbox_min": [
        546.4309692382812,
        680.0,
        80.0
      ],
      "bbox_max": [
        620.0,
        750.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.24342486262321472,
        -0.24342486262321472,
        -0.9388762712478638
      ],
      "plane_d": 123.0291976928711,
      "bbox_min": [
        546.4309692382812,
        739.7156982421875,
        80.0
      ],
      "bbox_max": [
        550.0,
        746.853759765625,
        81.85070037841797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -911.966796875,
      "bbox_min": [
        546.4309692382812,
        739.7156982421875,
        80.0
      ],
      "bbox_max": [
        550.0,
        743.2847290039062,
        81.85070037841797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        550.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        620.0,
        750.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24342486262321472,
        -0.24342486262321472,
        -0.9388762712478638
      ],
      "plane_d": 123.0291976928711,
      "bbox_min": [
        550.0,
        719.1421508789062,
        80.0
      ],
      "bbox_max": [
        580.8578491210938,
        750.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 111.92391967773438,
      "bbox_min": [
        560.8578491210938,
        719.1421508789062,
        90.0
      ],
      "bbox_max": [
        580.8578491210938,
        739.1421508789062,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -911.966796875,
      "bbox_min": [
        550.0,
        719.1421508789062,
        80.0
      ],
      "bbox_max": [
        565.7156982421875,
        739.7156982421875,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 111.92391967773438,
      "bbox_min": [
        560.8578491210938,
        719.1421508789062,
        80.0
      ],
      "bbox_max": [
        565.7156982421875,
        724.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 510.0,
      "bbox_min": [
        1250.0,
        470.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        1250.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -5.386648354033241e-07,
        0.09974443167448044,
        0.9950131177902222
      ],
      "plane_d": -126.48493194580078,
      "bbox_min": [
        1250.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -68.0,
      "bbox_min": [
        1683.6575927734375,
        510.0,
        68.0
      ],
      "bbox_max": [
        1740.0,
        556.557861328125,
        75.99519348144531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1740.0,
      "bbox_min": [
        1740.0,
        510.0,
        68.0
      ],
      "bbox_max": [
        1740.0,
        556.557861328125,
        75.99519348144531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.09950371086597443,
        0.9950371384620667
      ],
      "plane_d": -126.36972045898438,
      "bbox_min": [
        1250.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": -1283.4954833984375,
      "bbox_min": [
        1290.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        75.99519348144531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1290.0,
      "bbox_min": [
        1290.0,
        510.0,
        67.07054138183594
      ],
      "bbox_max": [
        1290.0,
        599.029052734375,
        75.99513244628906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": 659.3378295898438,
      "bbox_min": [
        1290.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        75.99519348144531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1683.6575927734375,
        510.0,
        66.2496337890625
      ],
      "bbox_max": [
        1770.0,
        607.2925415039062,
        75.99519348144531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6369963884353638,
        -0.770866870880127,
        0.0
      ],
      "plane_d": -679.3416748046875,
      "bbox_min": [
        1683.6575927734375,
        510.0,
        71.32803344726562
      ],
      "bbox_max": [
        1740.0,
        556.557861328125,
        75.99519348144531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1740.0,
      "bbox_min": [
        1740.0,
        510.0,
        71.32803344726562
      ],
      "bbox_max": [
        1740.0,
        556.557861328125,
        75.99519348144531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.001050728838890791,
        0.09950366616249084,
        0.9950367212295532
      ],
      "plane_d": -124.48885345458984,
      "bbox_min": [
        1763.599365234375,
        570.0,
        66.2496337890625
      ],
      "bbox_max": [
        1770.0,
        607.2925415039062,
        69.9788818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        -0.7761140465736389,
        -0.0
      ],
      "plane_d": 1294.6552734375,
      "bbox_min": [
        1290.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        75.99513244628906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6305926442146301,
        -0.7761139869689941,
        0.0
      ],
      "plane_d": -628.65234375,
      "bbox_min": [
        1290.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        75.99513244628906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1290.0,
        522.5,
        60.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        74.75000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1290.0,
      "bbox_min": [
        1290.0,
        522.5,
        60.0
      ],
      "bbox_max": [
        1640.097412109375,
        670.0,
        74.75000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -4.0690105151952594e-07,
        1.0
      ],
      "plane_d": -74.74186706542969,
      "bbox_min": [
        1409.9024658203125,
        522.5,
        74.74208068847656
      ],
      "bbox_max": [
        1640.097412109375,
        522.5792846679688,
        74.75000762939453
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1410.0,
      "bbox_min": [
        1410.0,
        522.5,
        74.74208068847656
      ],
      "bbox_max": [
        1640.0,
        522.5792846679688,
        74.75000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1640.0,
      "bbox_min": [
        1640.0,
        522.5,
        74.74209594726562
      ],
      "bbox_max": [
        1640.0,
        522.5791015625,
        74.75000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.09887950867414474,
        0.9950994849205017
      ],
      "plane_d": -125.95524597167969,
      "bbox_min": [
        1760.0,
        620.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        64.96832275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.001050728838890791,
        0.09950366616249084,
        0.9950367212295532
      ],
      "plane_d": -124.48885345458984,
      "bbox_min": [
        1760.0,
        620.0,
        63.31221389770508
      ],
      "bbox_max": [
        1770.0,
        636.6666870117188,
        64.96832275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.001050728838890791,
        0.09950366616249084,
        0.9950367212295532
      ],
      "plane_d": -124.48885345458984,
      "bbox_min": [
        1760.0,
        602.0033569335938,
        64.16638946533203
      ],
      "bbox_max": [
        1770.0,
        628.125,
        66.77178955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": 659.3378295898438,
      "bbox_min": [
        1290.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        1760.0,
        670.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1683.6575927734375,
        510.0,
        67.09709930419922
      ],
      "bbox_max": [
        1760.0,
        599.029052734375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6369963884353638,
        -0.770866870880127,
        0.0
      ],
      "plane_d": -679.3416748046875,
      "bbox_min": [
        1683.6575927734375,
        510.0,
        71.34420776367188
      ],
      "bbox_max": [
        1740.0,
        556.557861328125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1740.0,
      "bbox_min": [
        1740.0,
        510.0,
        71.34420776367188
      ],
      "bbox_max": [
        1740.0,
        556.557861328125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": -1283.4954833984375,
      "bbox_min": [
        1290.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        1760.0,
        670.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1290.0,
      "bbox_min": [
        1290.0,
        510.0,
        67.09709930419922
      ],
      "bbox_max": [
        1290.0,
        599.029052734375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6305926442146301,
        -0.7761139869689941,
        0.0
      ],
      "plane_d": -628.65234375,
      "bbox_min": [
        1290.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        1760.0,
        670.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        -0.7761140465736389,
        -0.0
      ],
      "plane_d": 1294.6552734375,
      "bbox_min": [
        1290.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        1760.0,
        670.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1290.0,
        522.5,
        60.0
      ],
      "bbox_max": [
        1760.0,
        670.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1290.0,
      "bbox_min": [
        1290.0,
        522.5,
        60.0
      ],
      "bbox_max": [
        1660.0,
        670.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -74.74209594726562,
      "bbox_min": [
        1390.0,
        522.5,
        74.73999786376953
      ],
      "bbox_max": [
        1660.0,
        560.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1640.0,
      "bbox_min": [
        1390.0,
        522.5,
        74.74208068847656
      ],
      "bbox_max": [
        1660.0,
        560.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1410.0,
      "bbox_min": [
        1390.0,
        522.5,
        74.74208068847656
      ],
      "bbox_max": [
        1410.0,
        560.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1390.0,
        538.75,
        74.74209594726562
      ],
      "bbox_max": [
        1410.0,
        560.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 560.0,
      "bbox_min": [
        1390.0,
        560.0,
        74.74209594726562
      ],
      "bbox_max": [
        1410.0,
        560.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        1640.0,
        538.75,
        74.74209594726562
      ],
      "bbox_max": [
        1660.0,
        560.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 560.0,
      "bbox_min": [
        1640.0,
        560.0,
        74.74209594726562
      ],
      "bbox_max": [
        1660.0,
        560.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        1250.0,
        470.0,
        75.99349975585938
      ],
      "bbox_max": [
        1770.0,
        510.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.09950371831655502,
        0.9950371980667114
      ],
      "plane_d": -126.36972045898438,
      "bbox_min": [
        1250.0,
        470.0,
        75.99349975585938
      ],
      "bbox_max": [
        1770.0,
        510.0,
        80.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0001616392401047051,
        0.0997437834739685,
        0.9950131773948669
      ],
      "plane_d": -126.76995849609375,
      "bbox_min": [
        1760.0,
        483.3333435058594,
        75.99349975585938
      ],
      "bbox_max": [
        1770.0,
        510.0,
        78.66666412353516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 490.0,
      "bbox_min": [
        1290.0,
        470.0,
        75.9950942993164
      ],
      "bbox_max": [
        1760.0,
        510.0,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.049937617033720016,
        0.9987523555755615
      ],
      "plane_d": -103.3708724975586,
      "bbox_min": [
        1290.0,
        490.0,
        75.9950942993164
      ],
      "bbox_max": [
        1760.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        -0.7761140465736389,
        0.0
      ],
      "plane_d": 1294.6551513671875,
      "bbox_min": [
        1290.0,
        490.0,
        75.9950942993164
      ],
      "bbox_max": [
        1570.0,
        510.0,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1480.0,
        490.0,
        78.0
      ],
      "bbox_max": [
        1570.0,
        510.0,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        1570.0,
        490.0,
        78.0
      ],
      "bbox_max": [
        1570.0,
        510.0,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": -1283.4954833984375,
      "bbox_min": [
        1290.0,
        490.0,
        75.9950942993164
      ],
      "bbox_max": [
        1421.943115234375,
        510.0,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": 659.3378295898438,
      "bbox_min": [
        1628.056884765625,
        490.0,
        75.9950942993164
      ],
      "bbox_max": [
        1760.0,
        510.0,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6305926442146301,
        -0.7761140465736389,
        0.0
      ],
      "plane_d": -628.65234375,
      "bbox_min": [
        1290.0,
        490.0,
        78.0
      ],
      "bbox_max": [
        1760.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        -0.7761140465736389,
        0.0
      ],
      "plane_d": 1294.6551513671875,
      "bbox_min": [
        1290.0,
        490.0,
        78.0
      ],
      "bbox_max": [
        1570.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1550.0,
      "bbox_min": [
        1480.0,
        490.0,
        78.0
      ],
      "bbox_max": [
        1570.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1480.0,
        490.0,
        78.0
      ],
      "bbox_max": [
        1500.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1500.0,
      "bbox_min": [
        1500.0,
        490.0,
        78.0
      ],
      "bbox_max": [
        1500.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        1570.0,
        490.0,
        78.0
      ],
      "bbox_max": [
        1570.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": -1283.4954833984375,
      "bbox_min": [
        1290.0,
        490.0,
        78.0
      ],
      "bbox_max": [
        1421.943115234375,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1290.0,
      "bbox_min": [
        1290.0,
        490.0,
        78.0
      ],
      "bbox_max": [
        1290.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": 659.3378295898438,
      "bbox_min": [
        1628.056884765625,
        490.0,
        78.0
      ],
      "bbox_max": [
        1760.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1760.0,
        490.0,
        78.0
      ],
      "bbox_max": [
        1760.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.049937617033720016,
        0.9987523555755615
      ],
      "plane_d": -103.3708724975586,
      "bbox_min": [
        1480.0,
        470.0,
        78.0
      ],
      "bbox_max": [
        1570.0,
        490.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        1480.0,
        470.0,
        78.0
      ],
      "bbox_max": [
        1570.0,
        490.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        1480.0,
        470.0,
        78.0
      ],
      "bbox_max": [
        1480.0,
        490.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1550.0,
      "bbox_min": [
        1500.0,
        470.0,
        79.0
      ],
      "bbox_max": [
        1550.0,
        490.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1500.0,
      "bbox_min": [
        1500.0,
        470.0,
        79.0
      ],
      "bbox_max": [
        1500.0,
        490.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1290.0,
      "bbox_min": [
        550.0,
        420.0,
        79.99999237060547
      ],
      "bbox_max": [
        1770.0,
        670.0,
        348.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 510.0,
      "bbox_min": [
        1290.0,
        420.0,
        79.99999237060547
      ],
      "bbox_max": [
        1562.5999755859375,
        670.0,
        348.0
      ],
      "face_count": 15
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        -0.7761140465736389,
        -0.0
      ],
      "plane_d": 1294.6552734375,
      "bbox_min": [
        1290.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        670.0,
        348.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1290.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        670.0,
        348.0
      ],
      "face_count": 15
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -1285.5201416015625,
      "bbox_min": [
        1290.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1290.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        348.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": 1409.9998779296875,
      "bbox_min": [
        1390.0,
        520.0,
        98.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        348.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.0,
        -0.9238730072975159,
        -0.38269925117492676
      ],
      "plane_d": 627.198486328125,
      "bbox_min": [
        1410.0,
        520.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.38268932700157166,
        -0.9238771796226501
      ],
      "plane_d": 347.947021484375,
      "bbox_min": [
        1410.0,
        630.0,
        102.75
      ],
      "bbox_max": [
        1480.0,
        670.0,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.38268932700157166,
        -0.9238771796226501
      ],
      "plane_d": 353.6873779296875,
      "bbox_min": [
        1410.0,
        630.0,
        104.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -317.0,
      "bbox_min": [
        1410.0,
        630.0,
        105.30136108398438
      ],
      "bbox_max": [
        1480.0,
        670.0,
        331.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 669.0,
      "bbox_min": [
        1425.0,
        657.25,
        105.30136108398438
      ],
      "bbox_max": [
        1466.6986083984375,
        670.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -1111.57177734375,
      "bbox_min": [
        1465.0,
        669.0,
        105.30136108398438
      ],
      "bbox_max": [
        1466.6986083984375,
        670.0,
        107.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1462.75,
      "bbox_min": [
        1462.25,
        657.25,
        110.37557220458984
      ],
      "bbox_max": [
        1462.75,
        657.75,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 657.25,
      "bbox_min": [
        1462.25,
        657.25,
        110.5826644897461
      ],
      "bbox_max": [
        1462.75,
        657.25,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 331.0,
      "bbox_min": [
        1410.0,
        637.0,
        317.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        1410.0,
        637.0,
        317.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        331.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        1410.0,
        637.0,
        317.0
      ],
      "bbox_max": [
        1480.0,
        645.0,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        1410.0,
        637.0,
        330.0
      ],
      "bbox_max": [
        1480.0,
        637.0,
        331.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        1410.0,
        637.0,
        317.0
      ],
      "bbox_max": [
        1480.0,
        637.0,
        330.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1445.5,
      "bbox_min": [
        1415.5,
        645.0,
        317.0
      ],
      "bbox_max": [
        1474.5,
        670.0,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1444.5,
      "bbox_min": [
        1415.5,
        645.0,
        317.0
      ],
      "bbox_max": [
        1445.5,
        670.0,
        331.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        1444.5,
        645.0,
        330.0
      ],
      "bbox_max": [
        1445.5,
        670.0,
        330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1423.5,
      "bbox_min": [
        1415.5,
        654.0,
        317.0
      ],
      "bbox_max": [
        1438.5,
        670.0,
        328.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -322.0,
      "bbox_min": [
        1415.5,
        654.0,
        317.0
      ],
      "bbox_max": [
        1423.5,
        670.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1423.0,
      "bbox_min": [
        1422.5,
        656.862548828125,
        317.0
      ],
      "bbox_max": [
        1423.0,
        665.137451171875,
        321.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.4999796152114868,
        -0.8660371899604797
      ],
      "plane_d": -54.384063720703125,
      "bbox_min": [
        1422.5,
        657.862548828125,
        317.0
      ],
      "bbox_max": [
        1423.0,
        661.0,
        321.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999847710132599,
        0.866034209728241
      ],
      "plane_d": -607.0914306640625,
      "bbox_min": [
        1422.5,
        658.208984375,
        319.388671875
      ],
      "bbox_max": [
        1423.0,
        661.0,
        321.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -323.0,
      "bbox_min": [
        1415.5,
        668.0,
        323.0
      ],
      "bbox_max": [
        1423.5,
        670.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1431.5,
      "bbox_min": [
        1423.5,
        666.0,
        317.0
      ],
      "bbox_max": [
        1438.5,
        670.0,
        328.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 669.4999389648438,
      "bbox_min": [
        1431.5,
        669.5,
        320.5
      ],
      "bbox_max": [
        1438.5,
        670.0,
        328.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -328.5,
      "bbox_min": [
        1431.5,
        669.5,
        321.0
      ],
      "bbox_max": [
        1438.5,
        670.0,
        328.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1438.0,
      "bbox_min": [
        1432.0,
        669.5,
        321.0
      ],
      "bbox_max": [
        1438.0,
        670.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1432.0,
      "bbox_min": [
        1432.0,
        669.5,
        321.0
      ],
      "bbox_max": [
        1438.0,
        670.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 328.0,
      "bbox_min": [
        1432.0,
        669.5,
        321.0
      ],
      "bbox_max": [
        1438.0,
        670.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -321.0,
      "bbox_min": [
        1432.0,
        669.5,
        321.0
      ],
      "bbox_max": [
        1438.0,
        670.0,
        321.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.0,
      "bbox_min": [
        1423.5,
        666.0,
        317.0
      ],
      "bbox_max": [
        1429.5,
        670.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1429.5,
      "bbox_min": [
        1423.5,
        666.0,
        317.0
      ],
      "bbox_max": [
        1429.5,
        670.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721364974975586,
        0.8944272994995117
      ],
      "plane_d": 9.83868408203125,
      "bbox_min": [
        1423.5,
        666.0,
        322.0
      ],
      "bbox_max": [
        1429.5,
        670.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -323.0,
      "bbox_min": [
        1423.5,
        668.0,
        323.0
      ],
      "bbox_max": [
        1429.5,
        670.0,
        323.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1466.5,
      "bbox_min": [
        1451.5,
        654.0,
        317.0
      ],
      "bbox_max": [
        1474.5,
        670.0,
        328.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -322.0,
      "bbox_min": [
        1466.5,
        654.0,
        317.0
      ],
      "bbox_max": [
        1474.5,
        670.0,
        327.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1466.5,
        656.862548828125,
        317.0
      ],
      "bbox_max": [
        1474.5,
        668.0,
        322.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1467.0,
      "bbox_min": [
        1467.0,
        656.862548828125,
        317.0
      ],
      "bbox_max": [
        1467.5,
        665.137451171875,
        321.0000305175781
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.49998077750205994,
        0.8660365343093872
      ],
      "plane_d": -607.0894775390625,
      "bbox_min": [
        1467.0,
        658.208984375,
        317.0
      ],
      "bbox_max": [
        1467.5,
        665.137451171875,
        321.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -323.0,
      "bbox_min": [
        1466.5,
        668.0,
        322.0
      ],
      "bbox_max": [
        1474.5,
        670.0,
        327.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1466.5,
        668.0,
        322.0
      ],
      "bbox_max": [
        1474.5,
        668.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1458.5,
      "bbox_min": [
        1451.5,
        666.0,
        317.0
      ],
      "bbox_max": [
        1466.5,
        670.0,
        328.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 669.4999389648438,
      "bbox_min": [
        1451.5,
        669.5,
        320.5
      ],
      "bbox_max": [
        1458.5,
        670.0,
        328.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1452.0,
      "bbox_min": [
        1452.0,
        669.5,
        321.0
      ],
      "bbox_max": [
        1458.0,
        670.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1458.0,
      "bbox_min": [
        1452.0,
        669.5,
        321.0
      ],
      "bbox_max": [
        1458.0,
        670.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 328.0,
      "bbox_min": [
        1452.0,
        669.5,
        321.0
      ],
      "bbox_max": [
        1458.0,
        670.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -321.0,
      "bbox_min": [
        1452.0,
        669.5,
        321.0
      ],
      "bbox_max": [
        1458.0,
        670.0,
        321.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.0,
      "bbox_min": [
        1460.5,
        666.0,
        317.0
      ],
      "bbox_max": [
        1466.5,
        670.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1460.5,
      "bbox_min": [
        1460.5,
        666.0,
        317.0
      ],
      "bbox_max": [
        1466.5,
        670.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1460.5,
        666.0,
        317.0
      ],
      "bbox_max": [
        1466.5,
        670.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -323.0,
      "bbox_min": [
        1460.5,
        668.0,
        323.0
      ],
      "bbox_max": [
        1466.5,
        670.0,
        323.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.44721364974975586,
        0.8944272994995117
      ],
      "plane_d": 9.83868408203125,
      "bbox_min": [
        1460.5,
        666.0,
        322.0
      ],
      "bbox_max": [
        1464.5,
        668.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1462.75,
      "bbox_min": [
        1462.25,
        657.25,
        104.0
      ],
      "bbox_max": [
        1468.0,
        670.0,
        110.5826644897461
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 657.25,
      "bbox_min": [
        1462.25,
        657.25,
        104.36932373046875
      ],
      "bbox_max": [
        1462.75,
        657.25,
        110.5826644897461
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 668.9999389648438,
      "bbox_min": [
        1465.284423828125,
        669.0,
        104.0
      ],
      "bbox_max": [
        1468.0,
        670.0,
        105.71559143066406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -1111.57177734375,
      "bbox_min": [
        1466.284423828125,
        669.0,
        104.0
      ],
      "bbox_max": [
        1468.0,
        670.0,
        105.71558380126953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 657.25,
      "bbox_min": [
        1462.25,
        655.41748046875,
        102.75
      ],
      "bbox_max": [
        1464.58251953125,
        657.75,
        104.36932373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1462.75,
      "bbox_min": [
        1462.75,
        657.25,
        102.75
      ],
      "bbox_max": [
        1464.58251953125,
        657.75,
        104.36932373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41312819719314575,
        -0.171185702085495,
        0.8944386839866638
      ],
      "plane_d": -584.4093017578125,
      "bbox_min": [
        1463.3963623046875,
        657.25,
        102.75
      ],
      "bbox_max": [
        1464.58251953125,
        657.5,
        103.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17118467390537262,
        -0.4131256937980652,
        0.8944399952888489
      ],
      "plane_d": -71.49150848388672,
      "bbox_min": [
        1462.5,
        655.41748046875,
        102.75
      ],
      "bbox_max": [
        1464.4788818359375,
        657.25,
        103.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41312819719314575,
        -0.171185702085495,
        0.8944386839866638
      ],
      "plane_d": -584.4093017578125,
      "bbox_min": [
        1463.20703125,
        656.027587890625,
        102.75
      ],
      "bbox_max": [
        1464.4788818359375,
        657.25,
        103.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 621.0,
      "bbox_min": [
        1410.0,
        520.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        634.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -103.99999237060547,
      "bbox_min": [
        1479.0,
        621.0,
        104.0
      ],
      "bbox_max": [
        1480.0,
        634.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 116.0,
      "bbox_min": [
        1410.0,
        520.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        621.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8137334585189819,
        -0.0,
        0.5812382102012634
      ],
      "plane_d": -1272.91162109375,
      "bbox_min": [
        1440.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1480.0,
        605.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        1440.0,
        570.0,
        118.0
      ],
      "bbox_max": [
        1480.0,
        590.0,
        132.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 590.0,
      "bbox_min": [
        1440.0,
        570.0,
        118.0
      ],
      "bbox_max": [
        1480.0,
        590.0,
        132.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.0,
      "bbox_min": [
        1460.0,
        570.0,
        132.0
      ],
      "bbox_max": [
        1470.0,
        590.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": -1127.6021728515625,
      "bbox_min": [
        1470.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1480.0,
        605.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 132.0,
      "bbox_min": [
        1470.0,
        570.0,
        125.0
      ],
      "bbox_max": [
        1480.0,
        590.0,
        132.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 590.0,
      "bbox_min": [
        1470.0,
        590.0,
        125.0
      ],
      "bbox_max": [
        1480.0,
        590.0,
        132.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        1475.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1480.0,
        605.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6311687231063843,
        -0.6311687231063843,
        0.45083481073379517
      ],
      "plane_d": -608.626953125,
      "bbox_min": [
        1475.0,
        600.0,
        118.0
      ],
      "bbox_max": [
        1480.0,
        605.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6311687231063843,
        -0.6311687231063843,
        -0.45083481073379517
      ],
      "plane_d": -495.9183654785156,
      "bbox_min": [
        1475.0,
        600.0,
        125.0
      ],
      "bbox_max": [
        1480.0,
        605.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1422.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        621.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1390.0,
        538.75,
        98.0
      ],
      "bbox_max": [
        1410.0,
        670.0,
        348.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 560.0,
      "bbox_min": [
        1390.0,
        560.0,
        98.0
      ],
      "bbox_max": [
        1410.0,
        650.0,
        318.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        1390.0,
        650.0,
        98.0
      ],
      "bbox_max": [
        1410.0,
        650.0,
        318.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 610.0,
      "bbox_min": [
        1390.0,
        522.5,
        80.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        98.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 91.0,
      "bbox_min": [
        1390.0,
        610.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1410.0,
      "bbox_min": [
        1390.0,
        650.0,
        91.0
      ],
      "bbox_max": [
        1410.0,
        670.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1390.0,
        650.0,
        91.0
      ],
      "bbox_max": [
        1410.0,
        670.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        1390.0,
        650.0,
        91.0
      ],
      "bbox_max": [
        1410.0,
        650.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1410.0,
      "bbox_min": [
        1390.0,
        610.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 90.0,
      "bbox_min": [
        1478.0,
        610.0,
        90.0
      ],
      "bbox_max": [
        1480.0,
        620.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1390.0,
        650.0,
        80.0
      ],
      "bbox_max": [
        1410.0,
        670.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        1390.0,
        650.0,
        80.0
      ],
      "bbox_max": [
        1410.0,
        650.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1390.0,
        522.5,
        80.0
      ],
      "bbox_max": [
        1410.0,
        560.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1390.0,
        538.75,
        80.0
      ],
      "bbox_max": [
        1410.0,
        560.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 560.0,
      "bbox_min": [
        1390.0,
        560.0,
        80.0
      ],
      "bbox_max": [
        1410.0,
        560.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -630.0,
      "bbox_min": [
        1480.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        670.0,
        338.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1480.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        338.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1480.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1480.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        98.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        1480.0,
        610.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        98.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 628.0,
      "bbox_min": [
        1480.0,
        610.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        98.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 90.0,
      "bbox_min": [
        1515.0,
        628.0,
        80.0
      ],
      "bbox_max": [
        1535.0,
        630.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.0,
        0.44721361994743347
      ],
      "plane_d": -1393.0704345703125,
      "bbox_min": [
        1515.0,
        628.0,
        80.0
      ],
      "bbox_max": [
        1535.0,
        630.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": -1317.0440673828125,
      "bbox_min": [
        1515.0,
        628.0,
        80.0
      ],
      "bbox_max": [
        1535.0,
        630.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 1410.958984375,
      "bbox_min": [
        1532.5,
        628.0,
        80.0
      ],
      "bbox_max": [
        1535.0,
        630.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        0.44721361994743347
      ],
      "plane_d": 1334.9326171875,
      "bbox_min": [
        1532.5,
        628.0,
        80.0
      ],
      "bbox_max": [
        1535.0,
        630.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -621.0,
      "bbox_min": [
        1480.0,
        610.0,
        80.0
      ],
      "bbox_max": [
        1480.5,
        621.0,
        96.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1480.5,
      "bbox_min": [
        1480.0,
        610.0,
        80.0
      ],
      "bbox_max": [
        1480.5,
        621.0,
        96.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -619.0,
      "bbox_min": [
        1480.0,
        612.5,
        91.0
      ],
      "bbox_max": [
        1480.5,
        619.0,
        96.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 96.0,
      "bbox_min": [
        1480.0,
        612.5,
        91.0
      ],
      "bbox_max": [
        1480.5,
        618.5,
        96.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -612.5,
      "bbox_min": [
        1480.0,
        612.5,
        91.0
      ],
      "bbox_max": [
        1480.5,
        612.5,
        96.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 115.99999237060547,
      "bbox_min": [
        1480.0,
        510.0,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        140.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 131.99998474121094,
      "bbox_min": [
        1480.0,
        510.0,
        116.0
      ],
      "bbox_max": [
        1562.5999755859375,
        625.0,
        140.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.0,
        -0.7808687686920166
      ],
      "plane_d": -833.9678955078125,
      "bbox_min": [
        1500.0,
        540.0,
        132.0
      ],
      "bbox_max": [
        1550.0,
        600.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6246950626373291,
        -0.0,
        -0.7808687686920166
      ],
      "plane_d": 1071.35205078125,
      "bbox_min": [
        1500.0,
        540.0,
        132.0
      ],
      "bbox_max": [
        1550.0,
        600.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6246950626373291,
        -0.7808687686920166
      ],
      "plane_d": 477.8917236328125,
      "bbox_min": [
        1500.0,
        590.0,
        132.0
      ],
      "bbox_max": [
        1550.0,
        600.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        1480.0,
        510.0,
        116.0
      ],
      "bbox_max": [
        1562.5999755859375,
        625.0,
        132.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        1500.0,
        540.0,
        116.0
      ],
      "bbox_max": [
        1550.0,
        600.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        1500.0,
        540.0,
        116.0
      ],
      "bbox_max": [
        1550.0,
        600.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        1500.0,
        600.0,
        116.0
      ],
      "bbox_max": [
        1550.0,
        600.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        1480.0,
        510.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        625.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -122.0,
      "bbox_min": [
        1480.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1500.0,
        625.0,
        132.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6311687231063843,
        -0.6311687231063843,
        0.45083481073379517
      ],
      "plane_d": -608.626953125,
      "bbox_min": [
        1480.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1500.0,
        622.8571166992188,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        1480.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1500.0,
        540.0,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6963106393814087,
        -0.6963106393814087,
        0.17407765984535217
      ],
      "plane_d": 1398.5399169921875,
      "bbox_min": [
        1498.0,
        538.0,
        118.0
      ],
      "bbox_max": [
        1500.0,
        540.0,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6311687231063843,
        -0.6311687231063843,
        -0.45083481073379517
      ],
      "plane_d": -495.9183654785156,
      "bbox_min": [
        1480.0,
        520.0,
        122.0
      ],
      "bbox_max": [
        1500.0,
        625.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6311687231063843,
        -0.6311687231063843,
        0.45083481073379517
      ],
      "plane_d": -608.626953125,
      "bbox_min": [
        1480.0,
        520.0,
        122.0
      ],
      "bbox_max": [
        1500.0,
        625.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        1480.0,
        520.0,
        122.0
      ],
      "bbox_max": [
        1500.0,
        520.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        1500.0,
        510.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        625.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -122.0,
      "bbox_min": [
        1550.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        625.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6311687231063843,
        -0.6311687231063843,
        0.45083481073379517
      ],
      "plane_d": 1316.4376220703125,
      "bbox_min": [
        1550.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        622.8571166992188,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        1550.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        540.0,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6963106393814087,
        -0.6963106393814087,
        0.17407765984535217
      ],
      "plane_d": -725.20751953125,
      "bbox_min": [
        1550.0,
        538.0,
        118.0
      ],
      "bbox_max": [
        1552.0,
        540.0,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6311687231063843,
        -0.6311687231063843,
        -0.45083481073379517
      ],
      "plane_d": 1429.1463623046875,
      "bbox_min": [
        1550.0,
        520.0,
        122.0
      ],
      "bbox_max": [
        1562.5999755859375,
        625.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6311687231063843,
        -0.6311687231063843,
        0.45083481073379517
      ],
      "plane_d": 1316.4376220703125,
      "bbox_min": [
        1550.0,
        520.0,
        122.0
      ],
      "bbox_max": [
        1562.5999755859375,
        625.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        1550.0,
        520.0,
        122.0
      ],
      "bbox_max": [
        1562.5999755859375,
        520.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": 581.2381591796875,
      "bbox_min": [
        1500.0,
        510.0,
        118.0
      ],
      "bbox_max": [
        1550.0,
        625.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": 435.9286193847656,
      "bbox_min": [
        1500.0,
        510.0,
        118.0
      ],
      "bbox_max": [
        1550.0,
        625.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 493.3175048828125,
      "bbox_min": [
        1500.0,
        510.0,
        118.0
      ],
      "bbox_max": [
        1550.0,
        601.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        1500.0,
        539.0,
        118.0
      ],
      "bbox_max": [
        1550.0,
        601.0,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -122.0,
      "bbox_min": [
        1500.0,
        600.0,
        122.0
      ],
      "bbox_max": [
        1550.0,
        601.0,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -122.0,
      "bbox_min": [
        1500.0,
        539.0,
        122.0
      ],
      "bbox_max": [
        1550.0,
        540.0,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -445.477294921875,
      "bbox_min": [
        1500.0,
        510.0,
        118.0
      ],
      "bbox_max": [
        1550.0,
        520.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9417420029640198,
        0.0,
        0.3363364040851593
      ],
      "plane_d": 1410.594970703125,
      "bbox_min": [
        1509.2857666015625,
        510.0,
        118.0
      ],
      "bbox_max": [
        1540.7142333984375,
        512.0,
        120.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9417420029640198,
        -0.0,
        0.3363364040851593
      ],
      "plane_d": -1461.7181396484375,
      "bbox_min": [
        1509.2857666015625,
        510.0,
        118.0
      ],
      "bbox_max": [
        1510.0,
        512.0,
        120.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        1500.0,
        510.0,
        118.0
      ],
      "bbox_max": [
        1550.0,
        520.0,
        132.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9417420029640198,
        0.0,
        -0.3363364040851593
      ],
      "plane_d": -1377.634033203125,
      "bbox_min": [
        1507.5,
        510.0,
        118.0
      ],
      "bbox_max": [
        1542.5,
        520.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9417420029640198,
        -0.0,
        0.3363364040851593
      ],
      "plane_d": -1461.7181396484375,
      "bbox_min": [
        1507.5,
        510.0,
        118.0
      ],
      "bbox_max": [
        1542.5,
        520.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9417420029640198,
        0.0,
        -0.3363364040851593
      ],
      "plane_d": 1494.6790771484375,
      "bbox_min": [
        1540.0,
        510.0,
        125.0
      ],
      "bbox_max": [
        1542.5,
        520.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 598.0,
      "bbox_min": [
        1480.0,
        510.0,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        116.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.3586997738457285e-05,
        -0.9906144142150879,
        0.13668644428253174
      ],
      "plane_d": 609.5709228515625,
      "bbox_min": [
        1480.0,
        625.0,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -104.9000015258789,
      "bbox_min": [
        1480.0,
        629.7439575195312,
        104.5
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        104.9000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -104.5,
      "bbox_min": [
        1558.0,
        629.7439575195312,
        104.5
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        104.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701564311981201,
        0.24248012900352478
      ],
      "plane_d": 585.786376953125,
      "bbox_min": [
        1480.0,
        625.0,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -102.0,
      "bbox_min": [
        1480.0,
        629.2999267578125,
        102.0
      ],
      "bbox_max": [
        1497.800048828125,
        629.400146484375,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -102.0,
      "bbox_min": [
        1480.0,
        625.0,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2268329555809032e-05,
        -0.8944716453552246,
        -0.4471249282360077
      ],
      "plane_d": 606.4588623046875,
      "bbox_min": [
        1480.0,
        625.0,
        100.0
      ],
      "bbox_max": [
        1558.0,
        627.2001953125,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 625.0,
      "bbox_min": [
        1544.800048828125,
        625.0,
        100.0
      ],
      "bbox_max": [
        1558.0,
        625.0,
        102.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 625.0,
      "bbox_min": [
        1544.800048828125,
        625.0,
        102.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        1544.800048828125,
        625.0,
        104.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -104.5,
      "bbox_min": [
        1558.0,
        627.0,
        104.0
      ],
      "bbox_max": [
        1562.5999755859375,
        629.7440185546875,
        104.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 627.0,
      "bbox_min": [
        1558.0,
        627.0,
        104.0
      ],
      "bbox_max": [
        1562.5999755859375,
        627.0,
        104.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        1480.0,
        510.0,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        598.0,
        116.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9593654870986938,
        0.0,
        -0.28216633200645447
      ],
      "plane_d": -1415.91064453125,
      "bbox_min": [
        1507.5,
        510.0,
        100.0
      ],
      "bbox_max": [
        1542.5,
        520.0,
        116.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9593654870986938,
        0.0,
        -0.28216633200645447
      ],
      "plane_d": 1510.1541748046875,
      "bbox_min": [
        1507.5,
        510.0,
        100.0
      ],
      "bbox_max": [
        1542.5,
        520.0,
        116.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9486833810806274,
        -0.0,
        0.3162277936935425
      ],
      "plane_d": -1464.134765625,
      "bbox_min": [
        1507.5,
        510.0,
        100.0
      ],
      "bbox_max": [
        1542.5,
        520.0,
        107.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9486833810806274,
        0.0,
        0.3162277936935425
      ],
      "plane_d": 1429.349609375,
      "bbox_min": [
        1540.0,
        510.0,
        100.0
      ],
      "bbox_max": [
        1542.5,
        520.0,
        107.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 595.0,
      "bbox_min": [
        1480.0,
        520.0,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        598.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -105.0,
      "bbox_min": [
        1487.071044921875,
        595.0,
        100.0
      ],
      "bbox_max": [
        1535.0,
        598.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        0.3826870620250702,
        0.0
      ],
      "plane_d": -1602.36376953125,
      "bbox_min": [
        1487.071044921875,
        595.0,
        100.0
      ],
      "bbox_max": [
        1487.928955078125,
        597.071044921875,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        0.3826870620250702,
        0.0
      ],
      "plane_d": -1602.36376953125,
      "bbox_min": [
        1487.071044921875,
        595.0,
        105.0
      ],
      "bbox_max": [
        1487.928955078125,
        597.071044921875,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870322227478,
        -0.923878014087677,
        0.0
      ],
      "plane_d": -85.96026611328125,
      "bbox_min": [
        1480.0,
        520.0,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        595.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870620250702,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": -30.52752685546875,
      "bbox_min": [
        1480.0,
        522.928955078125,
        100.0
      ],
      "bbox_max": [
        1545.0,
        595.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -1150.79296875,
      "bbox_min": [
        1487.071044921875,
        582.928955078125,
        100.0
      ],
      "bbox_max": [
        1490.0,
        595.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        0.3826870620250702,
        0.0
      ],
      "plane_d": -1602.36376953125,
      "bbox_min": [
        1487.928955078125,
        590.0,
        100.0
      ],
      "bbox_max": [
        1490.0,
        595.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        0.3826870620250702,
        -0.0
      ],
      "plane_d": -1579.4024658203125,
      "bbox_min": [
        1487.071044921875,
        522.928955078125,
        100.0
      ],
      "bbox_max": [
        1545.0,
        590.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -1173.7542724609375,
      "bbox_min": [
        1487.071044921875,
        522.928955078125,
        100.0
      ],
      "bbox_max": [
        1490.0,
        530.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 1476.2122802734375,
      "bbox_min": [
        1505.0,
        570.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        590.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -680.46337890625,
      "bbox_min": [
        1505.0,
        570.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        590.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881466269493103,
        -0.965927004814148,
        -0.0
      ],
      "plane_d": 945.270751953125,
      "bbox_min": [
        1505.0,
        570.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        590.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.965927004814148,
        -0.25881466269493103,
        -0.0
      ],
      "plane_d": 1606.4207763671875,
      "bbox_min": [
        1505.0,
        570.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        590.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881466269493103,
        -0.965927004814148,
        0.0
      ],
      "plane_d": 155.88601684570312,
      "bbox_min": [
        1505.0,
        570.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        590.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965927004814148,
        -0.25881466269493103,
        0.0
      ],
      "plane_d": -1339.656494140625,
      "bbox_min": [
        1505.0,
        570.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        590.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -105.0,
      "bbox_min": [
        1505.0,
        570.0,
        105.0
      ],
      "bbox_max": [
        1545.0,
        590.0,
        105.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.9238780736923218,
        0.3826870620250702,
        0.0
      ],
      "plane_d": 1238.4256591796875,
      "bbox_min": [
        1499.97265625,
        521.784423828125,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        536.27685546875,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238780736923218,
        -0.3826870620250702,
        -0.0
      ],
      "plane_d": 1644.0738525390625,
      "bbox_min": [
        1560.0,
        523.72314453125,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        530.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -103.0,
      "bbox_min": [
        1499.97265625,
        521.784423828125,
        100.0
      ],
      "bbox_max": [
        1550.02734375,
        525.8154296875,
        112.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8542449474334717,
        -0.4931878447532654,
        -0.16441155970096588
      ],
      "plane_d": 1595.3929443359375,
      "bbox_min": [
        1501.1363525390625,
        521.784423828125,
        100.0
      ],
      "bbox_max": [
        1548.8636474609375,
        525.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9863938689231873,
        -0.16439898312091827
      ],
      "plane_d": 531.6180419921875,
      "bbox_min": [
        1545.37255859375,
        521.784423828125,
        100.0
      ],
      "bbox_max": [
        1548.8636474609375,
        525.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.986393928527832,
        -0.16439899802207947
      ],
      "plane_d": -501.7280578613281,
      "bbox_min": [
        1545.37255859375,
        523.800048828125,
        100.0
      ],
      "bbox_max": [
        1548.8636474609375,
        525.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542196154594421,
        0.4932329058647156,
        -0.1644088476896286
      ],
      "plane_d": 1078.666259765625,
      "bbox_min": [
        1545.37255859375,
        523.800048828125,
        100.0
      ],
      "bbox_max": [
        1546.824951171875,
        525.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542530536651611,
        -0.49317699670791626,
        -0.16440273821353912
      ],
      "plane_d": -1010.0729370117188,
      "bbox_min": [
        1501.1363525390625,
        521.784423828125,
        100.0
      ],
      "bbox_max": [
        1504.62744140625,
        525.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.986393928527832,
        -0.16439899802207947
      ],
      "plane_d": -501.7280578613281,
      "bbox_min": [
        1501.1363525390625,
        523.800048828125,
        100.0
      ],
      "bbox_max": [
        1504.62744140625,
        525.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.854218065738678,
        0.4932362735271454,
        -0.16440637409687042
      ],
      "plane_d": -1526.7032470703125,
      "bbox_min": [
        1503.175048828125,
        523.800048828125,
        100.0
      ],
      "bbox_max": [
        1504.62744140625,
        525.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        -0.7070940732955933,
        0.0
      ],
      "plane_d": -691.9622192382812,
      "bbox_min": [
        1500.62060546875,
        522.145263671875,
        103.0
      ],
      "bbox_max": [
        1549.37939453125,
        525.53955078125,
        112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1432.711669921875,
      "bbox_min": [
        1500.62060546875,
        523.80712890625,
        103.0
      ],
      "bbox_max": [
        1504.0853271484375,
        525.53955078125,
        112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.489622978416264e-09,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -351.9329528808594,
      "bbox_min": [
        1500.62060546875,
        523.80712890625,
        103.0
      ],
      "bbox_max": [
        1504.0853271484375,
        525.53955078125,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1432.711669921875,
      "bbox_min": [
        1500.691162109375,
        522.145263671875,
        103.0
      ],
      "bbox_max": [
        1549.37939453125,
        525.53955078125,
        112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.787668902077712e-05,
        -0.5156153440475464,
        0.8568202257156372
      ],
      "plane_d": 180.91677856445312,
      "bbox_min": [
        1500.691162109375,
        522.145263671875,
        103.0
      ],
      "bbox_max": [
        1504.0146484375,
        523.80712890625,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071195244789124,
        -0.7070940732955933,
        -0.0
      ],
      "plane_d": 1464.75244140625,
      "bbox_min": [
        1502.3529052734375,
        522.145263671875,
        103.0
      ],
      "bbox_max": [
        1549.37939453125,
        525.53955078125,
        112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 723.9641723632812,
      "bbox_min": [
        1545.9146728515625,
        523.80712890625,
        103.0
      ],
      "bbox_max": [
        1549.37939453125,
        525.53955078125,
        112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -351.9329528808594,
      "bbox_min": [
        1545.9146728515625,
        523.80712890625,
        103.0
      ],
      "bbox_max": [
        1549.37939453125,
        525.53955078125,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 723.9641723632812,
      "bbox_min": [
        1502.3529052734375,
        522.145263671875,
        103.0
      ],
      "bbox_max": [
        1549.308837890625,
        525.53955078125,
        112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.7876685382798314e-05,
        -0.5156153440475464,
        0.8568202257156372
      ],
      "plane_d": 181.03231811523438,
      "bbox_min": [
        1545.9853515625,
        522.145263671875,
        103.0
      ],
      "bbox_max": [
        1549.308837890625,
        523.80712890625,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5078026056289673,
        -0.01057465560734272,
        0.861408531665802
      ],
      "plane_d": 701.8517456054688,
      "bbox_min": [
        1502.3529052734375,
        522.1455078125,
        103.0
      ],
      "bbox_max": [
        1547.6470947265625,
        525.53955078125,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5078026056289673,
        -0.01057465560734272,
        0.8614086508750916
      ],
      "plane_d": -846.9461669921875,
      "bbox_min": [
        1502.3529052734375,
        522.1455078125,
        103.0
      ],
      "bbox_max": [
        1504.0853271484375,
        525.53955078125,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        1480.0,
        590.0,
        140.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 590.0,
      "bbox_min": [
        1480.0,
        590.0,
        140.0
      ],
      "bbox_max": [
        1562.5999755859375,
        610.0,
        160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 610.0,
      "bbox_min": [
        1520.0,
        590.0,
        140.0
      ],
      "bbox_max": [
        1540.0,
        610.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        1520.0,
        590.0,
        140.0
      ],
      "bbox_max": [
        1540.0,
        610.0,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1520.0,
      "bbox_min": [
        1520.0,
        590.0,
        140.0
      ],
      "bbox_max": [
        1540.0,
        610.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        1530.0,
        590.0,
        140.0
      ],
      "bbox_max": [
        1540.0,
        610.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        1530.0,
        590.0,
        140.0
      ],
      "bbox_max": [
        1530.0,
        600.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1540.0,
      "bbox_min": [
        1540.0,
        600.0,
        140.0
      ],
      "bbox_max": [
        1540.0,
        610.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 317.0,
      "bbox_min": [
        1480.0,
        600.0,
        310.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5734623670578003,
        0.0,
        -0.8192319273948669
      ],
      "plane_d": -594.7623901367188,
      "bbox_min": [
        1480.0,
        600.0,
        310.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        317.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        1480.0,
        600.0,
        310.0
      ],
      "bbox_max": [
        1490.0,
        600.0,
        317.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5734623670578003,
        -0.0,
        -0.8192319273948669
      ],
      "plane_d": 1154.2978515625,
      "bbox_min": [
        1560.0,
        600.0,
        315.1800231933594
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        317.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        1560.0,
        600.0,
        315.1800231933594
      ],
      "bbox_max": [
        1562.5999755859375,
        600.0,
        317.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        1480.0,
        630.0,
        120.0
      ],
      "bbox_max": [
        1562.5999755859375,
        670.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        1480.0,
        630.0,
        120.0
      ],
      "bbox_max": [
        1562.5999755859375,
        670.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2316918820142746,
        0.9727892875671387,
        0.0
      ],
      "plane_d": -298.43865966796875,
      "bbox_min": [
        1480.0,
        630.0,
        120.0
      ],
      "bbox_max": [
        1562.5999755859375,
        670.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2316918820142746,
        0.9727892875671387,
        -0.0
      ],
      "plane_d": -1005.098876953125,
      "bbox_min": [
        1480.0,
        630.0,
        120.0
      ],
      "bbox_max": [
        1562.5999755859375,
        670.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6643652319908142,
        0.7474080920219421,
        0.0
      ],
      "plane_d": 501.45062255859375,
      "bbox_min": [
        1480.0,
        630.0,
        120.0
      ],
      "bbox_max": [
        1562.5999755859375,
        664.64111328125,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9574458599090576,
        0.28861290216445923,
        0.0
      ],
      "plane_d": 1235.1937255859375,
      "bbox_min": [
        1480.0,
        630.0,
        120.0
      ],
      "bbox_max": [
        1562.5999755859375,
        664.64111328125,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6643652319908142,
        0.7474080920219421,
        0.0
      ],
      "plane_d": -1524.86328125,
      "bbox_min": [
        1547.5,
        651.2188720703125,
        120.0
      ],
      "bbox_max": [
        1562.5999755859375,
        664.64111328125,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": -1283.4954833984375,
      "bbox_min": [
        1290.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        1397.7398681640625,
        599.029052734375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -88.0,
      "bbox_min": [
        1290.0,
        510.0,
        88.0
      ],
      "bbox_max": [
        1397.7398681640625,
        599.029052734375,
        98.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6246249675750732,
        0.7558982372283936,
        0.19611550867557526
      ],
      "plane_d": -1261.1207275390625,
      "bbox_min": [
        1305.0,
        510.0,
        88.0
      ],
      "bbox_max": [
        1374.1917724609375,
        567.175537109375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -98.0,
      "bbox_min": [
        1305.0,
        510.0,
        88.0
      ],
      "bbox_max": [
        1371.052001953125,
        567.175537109375,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6369963884353638,
        -0.770866870880127,
        -0.0
      ],
      "plane_d": 1263.497314453125,
      "bbox_min": [
        1305.0,
        510.0,
        88.0
      ],
      "bbox_max": [
        1366.3424072265625,
        567.175537109375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9805806875228882,
        0.0,
        0.1961161345243454
      ],
      "plane_d": 1262.399658203125,
      "bbox_min": [
        1305.0,
        559.0369262695312,
        88.0
      ],
      "bbox_max": [
        1307.0,
        567.175537109375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -90.0,
      "bbox_min": [
        1305.0,
        510.0,
        88.0
      ],
      "bbox_max": [
        1366.3424072265625,
        560.6896362304688,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9805806875228882,
        0.0,
        0.1961161345243454
      ],
      "plane_d": 1262.399658203125,
      "bbox_min": [
        1305.0,
        510.0,
        88.0
      ],
      "bbox_max": [
        1310.0,
        560.6896362304688,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1310.0,
      "bbox_min": [
        1310.0,
        510.0,
        88.0
      ],
      "bbox_max": [
        1310.0,
        556.557861328125,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9805806875228882,
        0.0,
        0.1961161345243454
      ],
      "plane_d": 1262.399658203125,
      "bbox_min": [
        1305.4000244140625,
        510.0,
        90.0
      ],
      "bbox_max": [
        1310.0,
        560.3590698242188,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1310.0,
      "bbox_min": [
        1310.0,
        510.0,
        90.0
      ],
      "bbox_max": [
        1310.0,
        556.557861328125,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 490.0,
      "bbox_min": [
        1290.0,
        420.0,
        79.99999237060547
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        348.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1290.0,
        490.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        348.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        -0.7761140465736389,
        0.0
      ],
      "plane_d": 1294.6551513671875,
      "bbox_min": [
        1290.0,
        490.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        510.0,
        348.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1425.3846435546875,
        490.0,
        98.0
      ],
      "bbox_max": [
        1480.0,
        510.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -1285.5201416015625,
      "bbox_min": [
        1470.0,
        490.0,
        338.0
      ],
      "bbox_max": [
        1480.0,
        510.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -87.99999237060547,
      "bbox_min": [
        1290.0,
        490.0,
        80.0
      ],
      "bbox_max": [
        1421.943115234375,
        510.0,
        98.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": -1283.4954833984375,
      "bbox_min": [
        1397.7398681640625,
        490.0,
        80.0
      ],
      "bbox_max": [
        1421.943115234375,
        510.0,
        88.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9805806875228882,
        0.1961161345243454
      ],
      "plane_d": 477.9350280761719,
      "bbox_min": [
        1305.0,
        505.0,
        88.0
      ],
      "bbox_max": [
        1380.2425537109375,
        510.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -97.99999237060547,
      "bbox_min": [
        1305.0,
        505.0,
        88.0
      ],
      "bbox_max": [
        1380.2425537109375,
        510.0,
        98.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6246249675750732,
        0.7558982372283936,
        0.19611550867557526
      ],
      "plane_d": -1261.1207275390625,
      "bbox_min": [
        1305.0,
        505.0,
        88.0
      ],
      "bbox_max": [
        1380.2425537109375,
        510.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9805806875228882,
        0.0,
        0.1961161345243454
      ],
      "plane_d": 1262.399658203125,
      "bbox_min": [
        1305.0,
        505.0,
        88.0
      ],
      "bbox_max": [
        1307.0,
        510.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1480.0,
        490.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1480.0,
        490.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1485.22216796875,
        490.0,
        138.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35558271408081055,
        -0.10718903690576553,
        0.9284780025482178
      ],
      "plane_d": 454.65576171875,
      "bbox_min": [
        1485.22216796875,
        490.0,
        138.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35558319091796875,
        -0.10718917846679688,
        0.9284778833389282
      ],
      "plane_d": -629.8721923828125,
      "bbox_min": [
        1490.4078369140625,
        490.0,
        138.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24674342572689056,
        -0.2775822579860687,
        0.9284749627113342
      ],
      "plane_d": -376.1568603515625,
      "bbox_min": [
        1490.4078369140625,
        490.0,
        138.0
      ],
      "bbox_max": [
        1559.5921630859375,
        495.5947265625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24673829972743988,
        -0.2775764763355255,
        0.9284781217575073
      ],
      "plane_d": 376.3996887207031,
      "bbox_min": [
        1490.4078369140625,
        490.0,
        138.0
      ],
      "bbox_max": [
        1501.0806884765625,
        495.5947265625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1480.0,
        490.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        138.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.35558992624282837,
        -0.10718918591737747,
        0.9284752011299133
      ],
      "plane_d": 471.3795166015625,
      "bbox_min": [
        1480.0,
        490.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3560672104358673,
        -0.10719012469053268,
        0.9282921552658081
      ],
      "plane_d": -613.8941650390625,
      "bbox_min": [
        1486.02880859375,
        490.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        502.7655334472656,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24687258899211884,
        -0.2777306139469147,
        0.9283962845802307
      ],
      "plane_d": 393.3970031738281,
      "bbox_min": [
        1486.02880859375,
        490.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        492.800048828125,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.24687258899211884,
        -0.2777306139469147,
        0.9283962845802307
      ],
      "plane_d": -359.56439208984375,
      "bbox_min": [
        1556.448974609375,
        490.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        492.800048828125,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.745241641998291,
        0.6667945384979248,
        0.0
      ],
      "plane_d": -1490.875244140625,
      "bbox_min": [
        1559.5999755859375,
        490.0,
        118.0
      ],
      "bbox_max": [
        1562.1053466796875,
        492.800048828125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.745241641998291,
        0.6667945384979248,
        0.0
      ],
      "plane_d": -1490.875244140625,
      "bbox_min": [
        1559.5999755859375,
        490.0,
        118.49617767333984
      ],
      "bbox_max": [
        1562.1053466796875,
        492.800048828125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.745241641998291,
        0.6667945384979248,
        0.0
      ],
      "plane_d": 782.11181640625,
      "bbox_min": [
        1487.894775390625,
        490.0,
        118.49620056152344
      ],
      "bbox_max": [
        1490.4000244140625,
        492.800048828125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.745241641998291,
        0.6667945384979248,
        0.0
      ],
      "plane_d": -1490.875244140625,
      "bbox_min": [
        1559.5999755859375,
        490.0,
        118.7156982421875
      ],
      "bbox_max": [
        1562.1053466796875,
        492.800048828125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.745241641998291,
        0.6667945384979248,
        0.0
      ],
      "plane_d": 782.11181640625,
      "bbox_min": [
        1487.894775390625,
        490.0,
        118.7146224975586
      ],
      "bbox_max": [
        1490.4000244140625,
        492.800048828125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9574445486068726,
        0.28861749172210693,
        -0.0
      ],
      "plane_d": -1574.212890625,
      "bbox_min": [
        1490.4444580078125,
        495.0,
        120.0
      ],
      "bbox_max": [
        1559.5555419921875,
        510.0,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1494.4000244140625,
      "bbox_min": [
        1494.4000244140625,
        495.0,
        120.0
      ],
      "bbox_max": [
        1494.966064453125,
        495.60009765625,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 495.0,
      "bbox_min": [
        1494.4000244140625,
        495.0,
        120.0
      ],
      "bbox_max": [
        1494.966064453125,
        495.60009765625,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -495.60009765625,
      "bbox_min": [
        1494.4000244140625,
        495.60009765625,
        120.0
      ],
      "bbox_max": [
        1494.7852783203125,
        495.60009765625,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9574445486068726,
        -0.28861749172210693,
        0.0
      ],
      "plane_d": -1345.9930419921875,
      "bbox_min": [
        1494.7852783203125,
        495.0,
        120.0
      ],
      "bbox_max": [
        1559.5555419921875,
        510.0,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1495.0,
      "bbox_min": [
        1494.7852783203125,
        495.0,
        120.0
      ],
      "bbox_max": [
        1555.2147216796875,
        495.60009765625,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -495.60009765625,
      "bbox_min": [
        1494.7852783203125,
        495.0,
        120.0
      ],
      "bbox_max": [
        1495.0,
        495.60009765625,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 495.0,
      "bbox_min": [
        1494.966064453125,
        495.0,
        120.0
      ],
      "bbox_max": [
        1495.0,
        495.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1555.0,
      "bbox_min": [
        1555.0,
        495.0,
        120.0
      ],
      "bbox_max": [
        1555.2147216796875,
        495.60009765625,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -495.60009765625,
      "bbox_min": [
        1555.0,
        495.0,
        120.0
      ],
      "bbox_max": [
        1555.2147216796875,
        495.60009765625,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 495.0,
      "bbox_min": [
        1555.0,
        495.0,
        120.0
      ],
      "bbox_max": [
        1555.0338134765625,
        495.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1555.5999755859375,
      "bbox_min": [
        1555.0338134765625,
        495.0,
        120.0
      ],
      "bbox_max": [
        1555.5999755859375,
        495.60009765625,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 495.0,
      "bbox_min": [
        1555.0338134765625,
        495.0,
        120.0
      ],
      "bbox_max": [
        1555.5999755859375,
        495.60009765625,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -495.60009765625,
      "bbox_min": [
        1555.2147216796875,
        495.60009765625,
        120.0
      ],
      "bbox_max": [
        1555.5999755859375,
        495.60009765625,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1480.0,
        490.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        118.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1480.0,
        490.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        100.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1550.0,
      "bbox_min": [
        1500.0,
        490.0,
        80.0
      ],
      "bbox_max": [
        1550.0,
        510.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 995.6064453125,
      "bbox_min": [
        1500.0,
        490.0,
        92.0
      ],
      "bbox_max": [
        1506.0,
        510.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -1161.0694580078125,
      "bbox_min": [
        1544.0,
        490.0,
        92.0
      ],
      "bbox_max": [
        1550.0,
        510.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1548.0,
      "bbox_min": [
        1548.0,
        490.0,
        80.0
      ],
      "bbox_max": [
        1548.0,
        510.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9575520753860474,
        0.2882605195045471,
        -0.0
      ],
      "plane_d": -1569.1904296875,
      "bbox_min": [
        1485.22216796875,
        490.0,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9575520753860474,
        -0.2882605195045471,
        0.0
      ],
      "plane_d": -1351.3433837890625,
      "bbox_min": [
        1490.4000244140625,
        490.0,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        502.7655334472656,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6646878123283386,
        -0.747121274471283,
        0.0
      ],
      "plane_d": -668.4656982421875,
      "bbox_min": [
        1490.4000244140625,
        490.0,
        100.0
      ],
      "bbox_max": [
        1559.5999755859375,
        492.800048828125,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6646878123283386,
        0.747121274471283,
        -0.0
      ],
      "plane_d": -1358.8321533203125,
      "bbox_min": [
        1490.4000244140625,
        490.0,
        100.0
      ],
      "bbox_max": [
        1493.54736328125,
        492.800048828125,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -420.0,
      "bbox_min": [
        1290.0,
        420.0,
        79.99999237060547
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 450.0,
      "bbox_min": [
        1290.0,
        450.0,
        79.99999237060547
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        140.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1290.0,
        450.0,
        79.99999237060547
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        140.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1290.0,
        450.0,
        79.99999237060547
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        1386.0,
        450.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7213867902755737,
        -0.692532479763031,
        0.0
      ],
      "plane_d": -753.127197265625,
      "bbox_min": [
        1386.0,
        450.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        470.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 514.295654296875,
      "bbox_min": [
        1386.0,
        450.0,
        118.0
      ],
      "bbox_max": [
        1390.0,
        470.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        1386.0,
        460.0,
        118.0
      ],
      "bbox_max": [
        1390.0,
        470.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -459.9999694824219,
      "bbox_min": [
        1386.0,
        460.0,
        118.0
      ],
      "bbox_max": [
        1390.0,
        460.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7213867902755737,
        -0.692532479763031,
        0.0
      ],
      "plane_d": 1447.1024169921875,
      "bbox_min": [
        1554.7999267578125,
        461.875,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        470.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.745241641998291,
        0.6667945384979248,
        0.0
      ],
      "plane_d": 782.11181640625,
      "bbox_min": [
        1470.0,
        470.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08604772388935089,
        -0.3612828254699707,
        0.9284774661064148
      ],
      "plane_d": -70.9802017211914,
      "bbox_min": [
        1487.068115234375,
        470.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08604908734560013,
        -0.36128857731819153,
        0.9284752011299133
      ],
      "plane_d": 191.4704132080078,
      "bbox_min": [
        1487.068115234375,
        470.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24687258899211884,
        -0.2777306139469147,
        0.9283962845802307
      ],
      "plane_d": 393.3970031738281,
      "bbox_min": [
        1487.068115234375,
        475.35888671875,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.24687258899211884,
        -0.2777306139469147,
        0.9283962845802307
      ],
      "plane_d": -359.56439208984375,
      "bbox_min": [
        1501.3369140625,
        475.35888671875,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7213867902755737,
        -0.692532479763031,
        0.0
      ],
      "plane_d": 1447.1024169921875,
      "bbox_min": [
        1501.3369140625,
        476.392578125,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.745241641998291,
        0.6667945384979248,
        0.0
      ],
      "plane_d": -1490.875244140625,
      "bbox_min": [
        1562.1053466796875,
        489.4471130371094,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        118.49616241455078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7213867902755737,
        -0.692532479763031,
        0.0
      ],
      "plane_d": -753.127197265625,
      "bbox_min": [
        1501.3369140625,
        476.392578125,
        118.0
      ],
      "bbox_max": [
        1504.800048828125,
        480.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7213867902755737,
        -0.692532479763031,
        0.0
      ],
      "plane_d": 1447.1024169921875,
      "bbox_min": [
        1545.199951171875,
        475.77667236328125,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.745241641998291,
        0.6667945384979248,
        0.0
      ],
      "plane_d": -1490.875244140625,
      "bbox_min": [
        1562.1053466796875,
        489.4471130371094,
        118.19926452636719
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7213867902755737,
        -0.692532479763031,
        0.0
      ],
      "plane_d": -753.127197265625,
      "bbox_min": [
        1500.7457275390625,
        475.7767028808594,
        118.0
      ],
      "bbox_max": [
        1504.800048828125,
        480.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7213867902755737,
        -0.692532479763031,
        0.0
      ],
      "plane_d": -753.127197265625,
      "bbox_min": [
        1495.2000732421875,
        470.0,
        118.0
      ],
      "bbox_max": [
        1504.76171875,
        479.96002197265625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7213867902755737,
        -0.692532479763031,
        0.0
      ],
      "plane_d": 1447.1024169921875,
      "bbox_min": [
        1545.23828125,
        470.0,
        118.0
      ],
      "bbox_max": [
        1554.7999267578125,
        479.9600830078125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24687258899211884,
        -0.2777306139469147,
        0.9283962845802307
      ],
      "plane_d": 393.3970031738281,
      "bbox_min": [
        1486.02880859375,
        489.0761413574219,
        118.0
      ],
      "bbox_max": [
        1487.894775390625,
        490.0,
        118.49618530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1290.0,
        450.0,
        79.99999237060547
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        118.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        1290.0,
        450.0,
        79.99999237060547
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        100.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1290.0,
        450.0,
        79.99999237060547
      ],
      "bbox_max": [
        1562.5999755859375,
        470.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38461539149284363,
        0.0,
        0.9230769872665405
      ],
      "plane_d": 487.6922912597656,
      "bbox_min": [
        1350.0,
        450.0,
        98.0
      ],
      "bbox_max": [
        1547.0,
        470.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.0,
        0.9284767508506775
      ],
      "plane_d": -665.5321044921875,
      "bbox_min": [
        1503.199951171875,
        450.0,
        98.0
      ],
      "bbox_max": [
        1547.0,
        470.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1542.0,
      "bbox_min": [
        1503.199951171875,
        460.0,
        98.0
      ],
      "bbox_max": [
        1547.0,
        470.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1508.0,
      "bbox_min": [
        1503.199951171875,
        460.0,
        98.0
      ],
      "bbox_max": [
        1508.0,
        470.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        1503.199951171875,
        460.0,
        98.0
      ],
      "bbox_max": [
        1508.0,
        460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        1542.0,
        460.0,
        98.0
      ],
      "bbox_max": [
        1547.0,
        460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 459.9999694824219,
      "bbox_min": [
        1350.0,
        450.0,
        98.0
      ],
      "bbox_max": [
        1354.0,
        470.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38461539149284363,
        0.0,
        0.9230769872665405
      ],
      "plane_d": 487.6922912597656,
      "bbox_min": [
        1350.0,
        450.0,
        79.99999237060547
      ],
      "bbox_max": [
        1562.5999755859375,
        470.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        1460.0,
        450.0,
        79.99999237060547
      ],
      "bbox_max": [
        1562.5999755859375,
        460.04998779296875,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1477.25,
      "bbox_min": [
        1477.25,
        450.04998779296875,
        85.18753051757812
      ],
      "bbox_max": [
        1477.25,
        460.0,
        86.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.0,
        -0.9284767508506775
      ],
      "plane_d": 663.6751708984375,
      "bbox_min": [
        1464.7999267578125,
        450.0,
        79.99999237060547
      ],
      "bbox_max": [
        1562.5999755859375,
        460.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.0,
        0.9284767508506775
      ],
      "plane_d": -665.5321044921875,
      "bbox_min": [
        1547.0,
        450.0,
        91.760009765625
      ],
      "bbox_max": [
        1562.5999755859375,
        460.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 450.0499572753906,
      "bbox_min": [
        1464.7999267578125,
        450.04998779296875,
        79.99999237060547
      ],
      "bbox_max": [
        1477.25,
        460.0,
        85.18753051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1477.25,
      "bbox_min": [
        1477.25,
        450.04998779296875,
        80.0
      ],
      "bbox_max": [
        1477.25,
        460.0,
        85.18753051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -460.04998779296875,
      "bbox_min": [
        1463.286376953125,
        460.0,
        79.99999237060547
      ],
      "bbox_max": [
        1477.25,
        460.04998779296875,
        86.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1477.25,
      "bbox_min": [
        1477.25,
        460.0,
        80.0
      ],
      "bbox_max": [
        1477.25,
        460.04998779296875,
        86.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": -693.18115234375,
      "bbox_min": [
        1350.0,
        460.0,
        79.99999237060547
      ],
      "bbox_max": [
        1390.0,
        470.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 459.9999694824219,
      "bbox_min": [
        1350.0,
        460.0,
        79.99999237060547
      ],
      "bbox_max": [
        1390.0,
        470.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1374.9000244140625,
      "bbox_min": [
        1374.9000244140625,
        460.0,
        85.54999542236328
      ],
      "bbox_max": [
        1374.9000244140625,
        470.0,
        86.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1374.9000244140625,
      "bbox_min": [
        1374.9000244140625,
        460.0,
        80.0
      ],
      "bbox_max": [
        1374.9000244140625,
        470.0,
        85.54999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1486.02880859375,
        470.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        100.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.2317100316286087,
        -0.9727849364280701,
        -4.0704031562199816e-05
      ],
      "plane_d": 810.5703735351562,
      "bbox_min": [
        1502.5,
        474.048828125,
        98.0
      ],
      "bbox_max": [
        1508.0,
        475.35888671875,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6643652319908142,
        -0.7474080920219421,
        0.0
      ],
      "plane_d": -672.818115234375,
      "bbox_min": [
        1542.0,
        474.048828125,
        98.0
      ],
      "bbox_max": [
        1562.5999755859375,
        488.7811279296875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2317100316286087,
        -0.9727849364280701,
        -4.0704031562199816e-05
      ],
      "plane_d": 103.8547592163086,
      "bbox_min": [
        1542.0,
        474.048828125,
        98.0
      ],
      "bbox_max": [
        1547.5,
        475.35888671875,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 995.6064453125,
      "bbox_min": [
        1506.0,
        470.0,
        98.0
      ],
      "bbox_max": [
        1508.0,
        472.2476806640625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1550.0,
      "bbox_min": [
        1500.0,
        470.0,
        80.0
      ],
      "bbox_max": [
        1550.0,
        490.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1500.0,
      "bbox_min": [
        1500.0,
        470.0,
        80.0
      ],
      "bbox_max": [
        1550.0,
        490.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -1161.0694580078125,
      "bbox_min": [
        1500.0,
        470.0,
        80.0
      ],
      "bbox_max": [
        1550.0,
        490.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 995.6064453125,
      "bbox_min": [
        1500.0,
        470.0,
        80.0
      ],
      "bbox_max": [
        1548.0,
        490.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1502.0,
      "bbox_min": [
        1502.0,
        470.0,
        80.0
      ],
      "bbox_max": [
        1548.0,
        490.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1548.0,
      "bbox_min": [
        1502.0,
        470.0,
        80.0
      ],
      "bbox_max": [
        1548.0,
        490.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7241400480270386,
        0.0,
        -0.6896529793739319
      ],
      "plane_d": -1024.89990234375,
      "bbox_min": [
        1502.0,
        470.0,
        91.0
      ],
      "bbox_max": [
        1548.0,
        490.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7241400480270386,
        0.0,
        -0.6896529793739319
      ],
      "plane_d": 1183.7271728515625,
      "bbox_min": [
        1541.3333740234375,
        470.0,
        91.0
      ],
      "bbox_max": [
        1548.0,
        490.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -516.0845336914062,
      "bbox_min": [
        1350.0,
        450.0,
        100.0
      ],
      "bbox_max": [
        1556.45263671875,
        490.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 514.295654296875,
      "bbox_min": [
        1350.0,
        450.0,
        100.0
      ],
      "bbox_max": [
        1390.0,
        460.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -459.9999694824219,
      "bbox_min": [
        1350.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        1390.0,
        460.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6646878123283386,
        -0.747121274471283,
        0.0
      ],
      "plane_d": -668.4656982421875,
      "bbox_min": [
        1493.54736328125,
        478.0,
        100.0
      ],
      "bbox_max": [
        1556.45263671875,
        490.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6646878123283386,
        0.747121274471283,
        -0.0
      ],
      "plane_d": -1358.8321533203125,
      "bbox_min": [
        1493.54736328125,
        478.0,
        100.0
      ],
      "bbox_max": [
        1545.0999755859375,
        490.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.22360631823539734,
        -0.9746794104576111,
        0.0006081170286051929
      ],
      "plane_d": 122.19364166259766,
      "bbox_min": [
        1504.9000244140625,
        478.0,
        100.0
      ],
      "bbox_max": [
        1545.0999755859375,
        479.89990234375,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.22360636293888092,
        0.9746795892715454,
        -0.0
      ],
      "plane_d": -804.2538452148438,
      "bbox_min": [
        1504.9000244140625,
        478.0,
        100.0
      ],
      "bbox_max": [
        1509.0,
        479.89990234375,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1508.0,
      "bbox_min": [
        1508.0,
        478.0,
        100.0
      ],
      "bbox_max": [
        1509.0,
        479.188720703125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23156701028347015,
        0.9728189706802368,
        -0.0
      ],
      "plane_d": -815.366943359375,
      "bbox_min": [
        1508.0,
        478.0,
        100.0
      ],
      "bbox_max": [
        1509.0,
        479.188720703125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 478.0,
      "bbox_min": [
        1508.0,
        478.0,
        100.0
      ],
      "bbox_max": [
        1509.0,
        478.95068359375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1509.0,
      "bbox_min": [
        1509.0,
        478.0,
        100.0
      ],
      "bbox_max": [
        1509.0,
        478.95068359375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22024792432785034,
        -0.9754440188407898,
        0.0
      ],
      "plane_d": 127.8104248046875,
      "bbox_min": [
        1541.0,
        478.0,
        100.0
      ],
      "bbox_max": [
        1545.0999755859375,
        479.89990234375,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1542.0,
      "bbox_min": [
        1541.0,
        478.0,
        100.0
      ],
      "bbox_max": [
        1542.0,
        479.199951171875,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23156701028347015,
        0.9728189706802368,
        0.0
      ],
      "plane_d": -109.08755493164062,
      "bbox_min": [
        1541.0,
        478.0,
        100.0
      ],
      "bbox_max": [
        1542.0,
        479.199951171875,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 478.0,
      "bbox_min": [
        1541.0,
        478.0,
        100.0
      ],
      "bbox_max": [
        1542.0,
        478.95068359375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1541.0,
      "bbox_min": [
        1541.0,
        478.0,
        100.0
      ],
      "bbox_max": [
        1541.0,
        478.95068359375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24186664819717407,
        0.970309317111969,
        -0.0006053904653526843
      ],
      "plane_d": -91.9423599243164,
      "bbox_min": [
        1541.0,
        478.95068359375,
        100.0
      ],
      "bbox_max": [
        1542.0,
        479.199951171875,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1493.5548095703125,
        475.139892578125,
        120.0
      ],
      "bbox_max": [
        1556.4451904296875,
        490.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1493.5548095703125,
        475.139892578125,
        138.0
      ],
      "bbox_max": [
        1556.4451904296875,
        490.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08604604750871658,
        -0.36128291487693787,
        0.9284776449203491
      ],
      "plane_d": -87.69021606445312,
      "bbox_min": [
        1493.5548095703125,
        475.139892578125,
        138.0
      ],
      "bbox_max": [
        1556.4451904296875,
        490.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08604757487773895,
        -0.3612893223762512,
        0.9284750819206238
      ],
      "plane_d": 174.7559356689453,
      "bbox_min": [
        1493.5548095703125,
        475.139892578125,
        138.0
      ],
      "bbox_max": [
        1556.4451904296875,
        490.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24674342572689056,
        -0.2775822579860687,
        0.9284749627113342
      ],
      "plane_d": -376.1568603515625,
      "bbox_min": [
        1493.5548095703125,
        479.931396484375,
        138.0
      ],
      "bbox_max": [
        1556.4451904296875,
        490.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24673829972743988,
        -0.2775764763355255,
        0.9284781217575073
      ],
      "plane_d": 376.3996887207031,
      "bbox_min": [
        1493.5548095703125,
        479.931396484375,
        138.0
      ],
      "bbox_max": [
        1507.263671875,
        490.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23168207705020905,
        -0.9727915525436401,
        0.0
      ],
      "plane_d": 113.89697265625,
      "bbox_min": [
        1506.6640625,
        480.27978515625,
        120.0
      ],
      "bbox_max": [
        1543.3359375,
        484.800048828125,
        138.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.23168207705020905,
        -0.9727915525436401,
        0.0
      ],
      "plane_d": 820.5272827148438,
      "bbox_min": [
        1506.6640625,
        480.27978515625,
        120.0
      ],
      "bbox_max": [
        1543.3359375,
        484.800048828125,
        138.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1507.2640380859375,
      "bbox_min": [
        1506.6640625,
        484.5038146972656,
        120.0
      ],
      "bbox_max": [
        1543.3359375,
        484.800048828125,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -484.800048828125,
      "bbox_min": [
        1506.6640625,
        484.646728515625,
        120.0
      ],
      "bbox_max": [
        1507.2640380859375,
        484.800048828125,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1506.6640625,
      "bbox_min": [
        1506.6640625,
        484.646728515625,
        120.0
      ],
      "bbox_max": [
        1506.6640625,
        484.800048828125,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -484.800048828125,
      "bbox_min": [
        1542.7359619140625,
        484.50384521484375,
        120.0
      ],
      "bbox_max": [
        1543.3359375,
        484.800048828125,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1542.7359619140625,
      "bbox_min": [
        1542.7359619140625,
        484.50384521484375,
        120.0
      ],
      "bbox_max": [
        1543.3359375,
        484.800048828125,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1543.3359375,
      "bbox_min": [
        1543.3359375,
        484.6466979980469,
        120.0
      ],
      "bbox_max": [
        1543.3359375,
        484.800048828125,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 484.199951171875,
      "bbox_min": [
        1506.6640625,
        484.199951171875,
        120.0
      ],
      "bbox_max": [
        1507.2640380859375,
        484.646728515625,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1506.6640625,
      "bbox_min": [
        1506.6640625,
        484.199951171875,
        120.0
      ],
      "bbox_max": [
        1507.2640380859375,
        484.646728515625,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1507.2640380859375,
      "bbox_min": [
        1507.2640380859375,
        484.199951171875,
        120.0
      ],
      "bbox_max": [
        1507.2640380859375,
        484.5038146972656,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 484.199951171875,
      "bbox_min": [
        1542.7359619140625,
        484.199951171875,
        120.0
      ],
      "bbox_max": [
        1543.3359375,
        484.6466979980469,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1543.3359375,
      "bbox_min": [
        1542.7359619140625,
        484.199951171875,
        120.0
      ],
      "bbox_max": [
        1543.3359375,
        484.6466979980469,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1542.7359619140625,
      "bbox_min": [
        1542.7359619140625,
        484.199951171875,
        120.0
      ],
      "bbox_max": [
        1542.7359619140625,
        484.50384521484375,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 510.0,
      "bbox_min": [
        1562.5999755859375,
        420.0,
        79.99999237060547
      ],
      "bbox_max": [
        1770.0,
        670.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": 659.3378295898438,
      "bbox_min": [
        1562.5999755859375,
        510.0,
        80.0
      ],
      "bbox_max": [
        1760.0,
        670.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1683.6575927734375,
        510.0,
        80.0
      ],
      "bbox_max": [
        1760.0,
        599.029052734375,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6369963884353638,
        -0.770866870880127,
        0.0
      ],
      "plane_d": -679.3416748046875,
      "bbox_min": [
        1683.6575927734375,
        510.0,
        80.0
      ],
      "bbox_max": [
        1740.0,
        556.557861328125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1740.0,
      "bbox_min": [
        1740.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        1740.0,
        556.557861328125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6305926442146301,
        -0.7761139869689941,
        0.0
      ],
      "plane_d": -628.65234375,
      "bbox_min": [
        1562.5999755859375,
        510.0,
        80.0
      ],
      "bbox_max": [
        1760.0,
        670.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1562.5999755859375,
        522.5,
        80.0
      ],
      "bbox_max": [
        1760.0,
        670.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        1562.5999755859375,
        522.5,
        80.0
      ],
      "bbox_max": [
        1660.0,
        670.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1640.0,
      "bbox_min": [
        1570.0,
        522.5,
        80.0
      ],
      "bbox_max": [
        1660.0,
        670.0,
        85.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 630.0,
      "bbox_min": [
        1570.0,
        630.0,
        80.0
      ],
      "bbox_max": [
        1640.0,
        670.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1580.0,
        630.0,
        80.0
      ],
      "bbox_max": [
        1625.0,
        670.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1620.0,
        650.0,
        80.0
      ],
      "bbox_max": [
        1625.0,
        650.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1580.0,
      "bbox_min": [
        1580.0,
        652.5,
        80.0
      ],
      "bbox_max": [
        1580.0,
        667.5,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        1640.0,
        538.75,
        80.0
      ],
      "bbox_max": [
        1660.0,
        670.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        1640.0,
        560.0,
        80.0
      ],
      "bbox_max": [
        1660.0,
        650.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 560.0,
      "bbox_min": [
        1640.0,
        560.0,
        80.0
      ],
      "bbox_max": [
        1660.0,
        560.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 610.0,
      "bbox_min": [
        1562.5999755859375,
        610.0,
        80.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -630.0,
      "bbox_min": [
        1562.5999755859375,
        628.0,
        80.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 628.0,
      "bbox_min": [
        1562.5999755859375,
        628.0,
        80.0
      ],
      "bbox_max": [
        1570.0,
        628.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -420.0,
      "bbox_min": [
        1562.5999755859375,
        420.0,
        79.99999237060547
      ],
      "bbox_max": [
        1770.0,
        510.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 490.0,
      "bbox_min": [
        1570.0,
        450.0,
        79.99999237060547
      ],
      "bbox_max": [
        1760.0,
        510.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6305926442146301,
        -0.7761140465736389,
        0.0
      ],
      "plane_d": -628.65234375,
      "bbox_min": [
        1570.0,
        490.0,
        80.0
      ],
      "bbox_max": [
        1760.0,
        510.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        1570.0,
        490.0,
        80.0
      ],
      "bbox_max": [
        1570.0,
        510.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": 659.3378295898438,
      "bbox_min": [
        1628.056884765625,
        490.0,
        80.0
      ],
      "bbox_max": [
        1760.0,
        510.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1760.0,
        490.0,
        80.0
      ],
      "bbox_max": [
        1760.0,
        510.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.0,
        0.9284767508506775
      ],
      "plane_d": -665.5321044921875,
      "bbox_min": [
        1574.5,
        450.0,
        79.99999237060547
      ],
      "bbox_max": [
        1707.5999755859375,
        460.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        1574.5,
        450.0,
        79.99999237060547
      ],
      "bbox_max": [
        1592.0,
        460.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 449.9999694824219,
      "bbox_min": [
        1574.5,
        450.0,
        79.99999237060547
      ],
      "bbox_max": [
        1592.0,
        460.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.0,
        -0.9284767508506775
      ],
      "plane_d": 663.6751708984375,
      "bbox_min": [
        1574.5,
        450.0,
        80.0
      ],
      "bbox_max": [
        1587.0,
        460.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1575.5,
      "bbox_min": [
        1575.5,
        450.0,
        84.59999084472656
      ],
      "bbox_max": [
        1575.5,
        460.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1575.5,
      "bbox_min": [
        1575.5,
        450.0,
        80.0
      ],
      "bbox_max": [
        1575.5,
        460.0,
        84.59999084472656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.0,
        0.9284767508506775
      ],
      "plane_d": 553.3721923828125,
      "bbox_min": [
        1690.0,
        450.0,
        80.0
      ],
      "bbox_max": [
        1707.5999755859375,
        460.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -459.9999694824219,
      "bbox_min": [
        1690.0,
        450.0,
        80.0
      ],
      "bbox_max": [
        1707.5999755859375,
        460.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.0,
        -0.9284767508506775
      ],
      "plane_d": -555.2291259765625,
      "bbox_min": [
        1690.0,
        450.0,
        80.0
      ],
      "bbox_max": [
        1707.5999755859375,
        460.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 450.0,
      "bbox_min": [
        1690.0,
        450.0,
        80.0
      ],
      "bbox_max": [
        1707.5,
        450.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1707.5999755859375,
      "bbox_min": [
        1707.5999755859375,
        450.0,
        80.0
      ],
      "bbox_max": [
        1707.5999755859375,
        460.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 510.0,
      "bbox_min": [
        1562.5999755859375,
        420.0,
        85.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        348.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.6305926442146301,
        -0.7761140465736389,
        0.0
      ],
      "plane_d": -628.65234375,
      "bbox_min": [
        1562.5999755859375,
        510.0,
        85.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        348.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1640.0,
      "bbox_min": [
        1562.5999755859375,
        510.0,
        85.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        348.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        1562.5999755859375,
        510.0,
        85.0
      ],
      "bbox_max": [
        1640.0,
        670.0,
        348.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 871.155517578125,
      "bbox_min": [
        1570.0,
        510.0,
        85.0
      ],
      "bbox_max": [
        1640.0,
        670.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1580.0,
      "bbox_min": [
        1570.0,
        510.0,
        85.0
      ],
      "bbox_max": [
        1640.0,
        670.0,
        317.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1570.0,
        510.0,
        85.0
      ],
      "bbox_max": [
        1580.0,
        630.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": 1208.9754638671875,
      "bbox_min": [
        1570.0,
        520.0,
        100.0
      ],
      "bbox_max": [
        1580.0,
        605.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 116.0,
      "bbox_min": [
        1570.0,
        545.0,
        100.0
      ],
      "bbox_max": [
        1580.0,
        605.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        1570.0,
        545.0,
        118.0
      ],
      "bbox_max": [
        1580.0,
        560.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": 383.03594970703125,
      "bbox_min": [
        1570.0,
        555.0,
        118.0
      ],
      "bbox_max": [
        1580.0,
        560.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": 528.3455200195312,
      "bbox_min": [
        1575.0,
        555.0,
        125.0
      ],
      "bbox_max": [
        1580.0,
        560.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1570.0,
        585.0,
        100.0
      ],
      "bbox_max": [
        1580.0,
        605.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        -0.5299989581108093
      ],
      "plane_d": 570.2788696289062,
      "bbox_min": [
        1570.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        1580.0,
        605.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": 455.799072265625,
      "bbox_min": [
        1570.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        1580.0,
        605.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        -0.0,
        -0.5812382102012634
      ],
      "plane_d": 1354.2850341796875,
      "bbox_min": [
        1570.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1580.0,
        605.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.0,
      "bbox_min": [
        1570.0,
        545.0,
        125.0
      ],
      "bbox_max": [
        1580.0,
        560.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": 528.3455200195312,
      "bbox_min": [
        1570.0,
        555.0,
        125.0
      ],
      "bbox_max": [
        1580.0,
        560.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        1570.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1575.0,
        605.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6311687231063843,
        -0.6311687231063843,
        0.45083481073379517
      ],
      "plane_d": 1316.4376220703125,
      "bbox_min": [
        1570.0,
        600.0,
        118.0
      ],
      "bbox_max": [
        1575.0,
        605.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6311687231063843,
        -0.6311687231063843,
        -0.45083481073379517
      ],
      "plane_d": 1429.1463623046875,
      "bbox_min": [
        1570.0,
        600.0,
        125.0
      ],
      "bbox_max": [
        1575.0,
        605.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 630.0,
      "bbox_min": [
        1570.0,
        630.0,
        85.0
      ],
      "bbox_max": [
        1580.0,
        630.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1580.0,
        510.0,
        85.0
      ],
      "bbox_max": [
        1640.0,
        670.0,
        195.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -637.5,
      "bbox_min": [
        1580.0,
        545.0,
        100.0
      ],
      "bbox_max": [
        1637.5,
        670.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -635.0,
      "bbox_min": [
        1580.0,
        545.0,
        100.0
      ],
      "bbox_max": [
        1625.0,
        637.5,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": 1249.662109375,
      "bbox_min": [
        1580.0,
        545.0,
        100.0
      ],
      "bbox_max": [
        1625.0,
        605.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        -0.0,
        -0.5812382102012634
      ],
      "plane_d": 1394.9716796875,
      "bbox_min": [
        1580.0,
        545.0,
        100.0
      ],
      "bbox_max": [
        1625.0,
        605.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        1580.0,
        545.0,
        100.0
      ],
      "bbox_max": [
        1605.0,
        605.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 116.0,
      "bbox_min": [
        1580.0,
        585.0,
        100.0
      ],
      "bbox_max": [
        1590.0,
        605.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1580.0,
        585.0,
        100.0
      ],
      "bbox_max": [
        1590.0,
        605.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        -0.5299989581108093
      ],
      "plane_d": 570.2788696289062,
      "bbox_min": [
        1580.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        1590.0,
        605.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": 455.799072265625,
      "bbox_min": [
        1580.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        1590.0,
        605.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.0,
      "bbox_min": [
        1580.0,
        545.0,
        118.0
      ],
      "bbox_max": [
        1605.0,
        560.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": 383.03594970703125,
      "bbox_min": [
        1580.0,
        555.0,
        118.0
      ],
      "bbox_max": [
        1605.0,
        560.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": 528.3455200195312,
      "bbox_min": [
        1580.0,
        555.0,
        125.0
      ],
      "bbox_max": [
        1605.0,
        560.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        1595.0,
        635.0,
        180.0
      ],
      "bbox_max": [
        1624.0,
        637.5,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 195.0,
      "bbox_min": [
        1595.0,
        635.0,
        180.0
      ],
      "bbox_max": [
        1624.0,
        637.5,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1624.0,
      "bbox_min": [
        1624.0,
        635.0,
        180.0
      ],
      "bbox_max": [
        1624.0,
        637.5,
        195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        1580.0,
        637.5,
        180.0
      ],
      "bbox_max": [
        1625.0,
        670.0,
        195.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 195.0,
      "bbox_min": [
        1580.0,
        637.5,
        180.0
      ],
      "bbox_max": [
        1625.0,
        670.0,
        195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 669.0,
      "bbox_min": [
        1580.0,
        637.5,
        180.0
      ],
      "bbox_max": [
        1625.0,
        670.0,
        195.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1585.0,
      "bbox_min": [
        1585.0,
        669.0,
        184.0
      ],
      "bbox_max": [
        1595.0,
        670.0,
        194.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1595.0,
      "bbox_min": [
        1585.0,
        669.0,
        184.0
      ],
      "bbox_max": [
        1595.0,
        670.0,
        194.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -184.0,
      "bbox_min": [
        1585.0,
        669.0,
        184.0
      ],
      "bbox_max": [
        1595.0,
        670.0,
        184.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1624.0,
      "bbox_min": [
        1580.0,
        637.5,
        180.0
      ],
      "bbox_max": [
        1625.0,
        669.0,
        195.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1624.0,
        640.0,
        180.0
      ],
      "bbox_max": [
        1625.0,
        650.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        1624.0,
        640.0,
        180.0
      ],
      "bbox_max": [
        1625.0,
        640.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -655.0,
      "bbox_min": [
        1580.0,
        655.0,
        180.0
      ],
      "bbox_max": [
        1595.0,
        655.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1580.0,
        630.0,
        85.0
      ],
      "bbox_max": [
        1640.0,
        670.0,
        98.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 630.0,
      "bbox_min": [
        1620.0,
        630.0,
        85.0
      ],
      "bbox_max": [
        1640.0,
        650.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1620.0,
        640.0,
        85.0
      ],
      "bbox_max": [
        1625.0,
        650.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        1620.0,
        640.0,
        95.0
      ],
      "bbox_max": [
        1625.0,
        650.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 630.0,
      "bbox_min": [
        1580.0,
        630.0,
        85.0
      ],
      "bbox_max": [
        1600.0,
        630.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1562.5999755859375,
        510.0,
        85.0
      ],
      "bbox_max": [
        1570.0,
        651.2188720703125,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 116.0,
      "bbox_min": [
        1562.5999755859375,
        510.0,
        85.0
      ],
      "bbox_max": [
        1570.0,
        651.2188720703125,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        1562.5999755859375,
        520.0,
        116.0
      ],
      "bbox_max": [
        1570.0,
        651.2188720703125,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -630.0,
      "bbox_min": [
        1562.5999755859375,
        630.0,
        116.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 131.99998474121094,
      "bbox_min": [
        1562.5999755859375,
        520.0,
        118.0
      ],
      "bbox_max": [
        1570.0,
        651.2188720703125,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9574458599090576,
        0.28861290216445923,
        0.0
      ],
      "plane_d": -1685.01611328125,
      "bbox_min": [
        1562.5999755859375,
        630.0,
        132.0
      ],
      "bbox_max": [
        1570.0,
        651.2188720703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6643652319908142,
        0.7474080920219421,
        0.0
      ],
      "plane_d": -1524.86328125,
      "bbox_min": [
        1562.5999755859375,
        650.0,
        132.0
      ],
      "bbox_max": [
        1563.97119140625,
        651.2188720703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9574458599090576,
        0.28861290216445923,
        0.0
      ],
      "plane_d": -1685.01611328125,
      "bbox_min": [
        1562.5999755859375,
        520.0,
        118.0
      ],
      "bbox_max": [
        1570.0,
        651.2188720703125,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        1562.5999755859375,
        520.0,
        118.0
      ],
      "bbox_max": [
        1570.0,
        651.2188720703125,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6311687231063843,
        -0.6311687231063843,
        -0.45083481073379517
      ],
      "plane_d": 1429.1463623046875,
      "bbox_min": [
        1562.5999755859375,
        600.0,
        120.0
      ],
      "bbox_max": [
        1570.0,
        651.2188720703125,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6311687231063843,
        -0.6311687231063843,
        0.45083481073379517
      ],
      "plane_d": 1316.4376220703125,
      "bbox_min": [
        1562.5999755859375,
        520.0,
        118.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -630.0,
      "bbox_min": [
        1562.5999755859375,
        630.0,
        118.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        1562.5999755859375,
        520.0,
        118.0
      ],
      "bbox_max": [
        1570.0,
        520.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1562.5999755859375,
        510.0,
        85.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        116.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1562.5999755859375,
        520.0,
        98.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -630.0,
      "bbox_min": [
        1562.5999755859375,
        630.0,
        98.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870322227478,
        -0.923878014087677,
        -0.0
      ],
      "plane_d": 1081.2352294921875,
      "bbox_min": [
        1562.5999755859375,
        520.0,
        100.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 630.0,
      "bbox_min": [
        1562.5999755859375,
        522.928955078125,
        100.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        116.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238780736923218,
        0.3826870620250702,
        0.0
      ],
      "plane_d": 1238.4256591796875,
      "bbox_min": [
        1562.5999755859375,
        522.928955078125,
        100.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238780736923218,
        -0.3826870620250702,
        -0.0
      ],
      "plane_d": 1644.0738525390625,
      "bbox_min": [
        1562.5999755859375,
        522.928955078125,
        100.0
      ],
      "bbox_max": [
        1562.928955078125,
        523.72314453125,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 612.0,
      "bbox_min": [
        1562.5999755859375,
        612.0,
        100.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1564.800048828125,
      "bbox_min": [
        1562.5999755859375,
        612.0,
        100.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        1564.800048828125,
        612.0,
        104.0
      ],
      "bbox_max": [
        1570.0,
        626.199951171875,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1567.0,
      "bbox_min": [
        1564.800048828125,
        618.0,
        104.0
      ],
      "bbox_max": [
        1567.0,
        626.199951171875,
        104.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1549.27099609375,
      "bbox_min": [
        1564.800048828125,
        624.0,
        104.0
      ],
      "bbox_max": [
        1567.0,
        626.199951171875,
        104.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -104.5,
      "bbox_min": [
        1562.5999755859375,
        626.199951171875,
        104.0
      ],
      "bbox_max": [
        1564.800048828125,
        630.0,
        104.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 627.0,
      "bbox_min": [
        1562.5999755859375,
        626.199951171875,
        104.0
      ],
      "bbox_max": [
        1564.800048828125,
        627.0,
        104.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1549.27099609375,
      "bbox_min": [
        1564.0,
        626.199951171875,
        104.0
      ],
      "bbox_max": [
        1564.800048828125,
        627.0,
        104.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        1562.5999755859375,
        520.0,
        100.0
      ],
      "bbox_max": [
        1570.0,
        520.0,
        116.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        1562.5999755859375,
        610.0,
        85.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        98.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -630.0,
      "bbox_min": [
        1562.5999755859375,
        628.0,
        85.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 628.0,
      "bbox_min": [
        1562.5999755859375,
        628.0,
        85.0
      ],
      "bbox_max": [
        1570.0,
        628.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        1562.5999755859375,
        590.0,
        140.0
      ],
      "bbox_max": [
        1570.0,
        651.2188720703125,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9574458599090576,
        0.28861290216445923,
        0.0
      ],
      "plane_d": -1685.01611328125,
      "bbox_min": [
        1562.5999755859375,
        590.0,
        140.0
      ],
      "bbox_max": [
        1570.0,
        651.2188720703125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6643652319908142,
        0.7474080920219421,
        -0.0
      ],
      "plane_d": -1524.8634033203125,
      "bbox_min": [
        1562.5999755859375,
        590.0,
        140.0
      ],
      "bbox_max": [
        1570.0,
        651.2188720703125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 590.0,
      "bbox_min": [
        1562.5999755859375,
        590.0,
        140.0
      ],
      "bbox_max": [
        1570.0,
        590.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5734623670578003,
        -0.0,
        -0.8192319273948669
      ],
      "plane_d": 1154.2978515625,
      "bbox_min": [
        1562.5999755859375,
        600.0,
        310.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -630.0,
      "bbox_min": [
        1562.5999755859375,
        600.0,
        310.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        1562.5999755859375,
        600.0,
        310.0
      ],
      "bbox_max": [
        1570.0,
        600.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        1640.0,
        538.75,
        85.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        348.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1640.0,
        538.75,
        85.0
      ],
      "bbox_max": [
        1770.0,
        650.0,
        348.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1640.0,
        538.75,
        98.0
      ],
      "bbox_max": [
        1770.0,
        650.0,
        348.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        1640.0,
        538.75,
        98.0
      ],
      "bbox_max": [
        1660.0,
        650.0,
        348.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 560.0,
      "bbox_min": [
        1640.0,
        560.0,
        98.0
      ],
      "bbox_max": [
        1660.0,
        560.0,
        318.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1760.0,
        620.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        650.0,
        258.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1760.0,
        620.0,
        220.0
      ],
      "bbox_max": [
        1770.0,
        650.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 257.9999694824219,
      "bbox_min": [
        1760.0,
        620.0,
        258.0
      ],
      "bbox_max": [
        1770.0,
        650.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1640.0,
        538.75,
        85.0
      ],
      "bbox_max": [
        1760.0,
        650.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 560.0,
      "bbox_min": [
        1640.0,
        560.0,
        85.0
      ],
      "bbox_max": [
        1660.0,
        560.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1660.0,
        650.0,
        85.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        348.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        1660.0,
        650.0,
        85.0
      ],
      "bbox_max": [
        1760.0,
        670.0,
        348.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1660.0,
        650.0,
        98.0
      ],
      "bbox_max": [
        1760.0,
        670.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1760.0,
        650.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 257.9999694824219,
      "bbox_min": [
        1760.0,
        650.0,
        258.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": 659.3378295898438,
      "bbox_min": [
        1652.2601318359375,
        510.0,
        85.0
      ],
      "bbox_max": [
        1770.0,
        628.125,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -88.0,
      "bbox_min": [
        1652.2601318359375,
        510.0,
        85.0
      ],
      "bbox_max": [
        1760.0,
        599.029052734375,
        98.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1683.6575927734375,
        510.0,
        85.0
      ],
      "bbox_max": [
        1760.0,
        599.029052734375,
        88.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1740.0,
      "bbox_min": [
        1725.0,
        510.0,
        85.0
      ],
      "bbox_max": [
        1740.0,
        556.557861328125,
        88.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 86.0,
      "bbox_min": [
        1725.0,
        510.0,
        86.0
      ],
      "bbox_max": [
        1740.0,
        515.0,
        88.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -515.0,
      "bbox_min": [
        1725.0,
        510.0,
        86.0
      ],
      "bbox_max": [
        1740.0,
        515.0,
        88.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1725.0,
      "bbox_min": [
        1725.0,
        510.0,
        86.0
      ],
      "bbox_max": [
        1725.0,
        515.0,
        88.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6246256828308105,
        0.7558990716934204,
        0.19611048698425293
      ],
      "plane_d": 643.9866333007812,
      "bbox_min": [
        1675.8082275390625,
        510.0,
        88.0
      ],
      "bbox_max": [
        1745.0,
        567.175537109375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -98.0,
      "bbox_min": [
        1678.947998046875,
        510.0,
        88.0
      ],
      "bbox_max": [
        1745.0,
        567.175537109375,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6369963884353638,
        -0.770866870880127,
        0.0
      ],
      "plane_d": -679.3416748046875,
      "bbox_min": [
        1683.6575927734375,
        510.0,
        88.0
      ],
      "bbox_max": [
        1745.0,
        567.175537109375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805806279182434,
        -0.0,
        0.1961161345243454
      ],
      "plane_d": -1728.371337890625,
      "bbox_min": [
        1743.0,
        559.0369262695312,
        88.0
      ],
      "bbox_max": [
        1745.0,
        567.175537109375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -90.0,
      "bbox_min": [
        1683.6575927734375,
        510.0,
        88.0
      ],
      "bbox_max": [
        1745.0,
        560.6896362304688,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9805806279182434,
        -0.0,
        0.1961161345243454
      ],
      "plane_d": -1728.371337890625,
      "bbox_min": [
        1740.0,
        510.0,
        88.0
      ],
      "bbox_max": [
        1745.0,
        560.6896362304688,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1740.0,
      "bbox_min": [
        1740.0,
        510.0,
        88.0
      ],
      "bbox_max": [
        1740.0,
        556.557861328125,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805806279182434,
        -0.0,
        0.1961161345243454
      ],
      "plane_d": -1728.371337890625,
      "bbox_min": [
        1740.0,
        510.0,
        90.0
      ],
      "bbox_max": [
        1744.5999755859375,
        560.3590698242188,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1740.0,
      "bbox_min": [
        1740.0,
        510.0,
        90.0
      ],
      "bbox_max": [
        1740.0,
        556.557861328125,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 620.0,
      "bbox_min": [
        1760.0,
        620.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        628.125,
        338.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1760.0,
        620.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        628.125,
        258.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1760.0,
        620.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        628.125,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1760.0,
        620.0,
        220.0
      ],
      "bbox_max": [
        1770.0,
        628.125,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 257.9999694824219,
      "bbox_min": [
        1760.0,
        620.0,
        258.0
      ],
      "bbox_max": [
        1770.0,
        628.125,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -420.0,
      "bbox_min": [
        1562.5999755859375,
        420.0,
        85.0
      ],
      "bbox_max": [
        1770.0,
        510.0,
        348.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        1562.5999755859375,
        450.0,
        85.0
      ],
      "bbox_max": [
        1760.0,
        510.0,
        348.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1562.5999755859375,
        450.0,
        85.0
      ],
      "bbox_max": [
        1760.0,
        470.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1562.5999755859375,
        450.0,
        85.0
      ],
      "bbox_max": [
        1760.0,
        470.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 460.0,
      "bbox_min": [
        1661.4000244140625,
        450.0,
        98.0
      ],
      "bbox_max": [
        1760.0,
        470.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.39872613549232483,
        0.0,
        -0.9170700907707214
      ],
      "plane_d": 754.150634765625,
      "bbox_min": [
        1661.4000244140625,
        460.0,
        98.0
      ],
      "bbox_max": [
        1760.0,
        470.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1760.0,
        460.0,
        98.0
      ],
      "bbox_max": [
        1760.0,
        470.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 450.0,
      "bbox_min": [
        1735.0,
        450.0,
        98.0
      ],
      "bbox_max": [
        1760.0,
        460.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1760.0,
        450.0,
        98.0
      ],
      "bbox_max": [
        1760.0,
        460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.0,
        0.9284767508506775
      ],
      "plane_d": 553.3721923828125,
      "bbox_min": [
        1562.5999755859375,
        450.0,
        85.0
      ],
      "bbox_max": [
        1740.0,
        460.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -459.9999694824219,
      "bbox_min": [
        1702.5,
        450.0,
        85.0
      ],
      "bbox_max": [
        1740.0,
        460.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 450.0,
      "bbox_min": [
        1702.5,
        450.0,
        85.0
      ],
      "bbox_max": [
        1740.0,
        460.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1707.5999755859375,
      "bbox_min": [
        1707.5999755859375,
        450.0,
        85.03997039794922
      ],
      "bbox_max": [
        1707.5999755859375,
        460.0,
        86.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1707.5999755859375,
      "bbox_min": [
        1707.5999755859375,
        450.0,
        85.0
      ],
      "bbox_max": [
        1707.5999755859375,
        460.0,
        85.03997039794922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.0,
        0.9284767508506775
      ],
      "plane_d": -665.5321044921875,
      "bbox_min": [
        1562.5999755859375,
        450.0,
        85.0
      ],
      "bbox_max": [
        1579.5,
        460.0,
        91.760009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.0,
        -0.9284767508506775
      ],
      "plane_d": 663.6751708984375,
      "bbox_min": [
        1562.5999755859375,
        450.0,
        85.0
      ],
      "bbox_max": [
        1579.5,
        460.0,
        91.760009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        1562.5999755859375,
        450.0,
        85.0
      ],
      "bbox_max": [
        1579.5,
        460.0,
        91.760009765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 449.9999694824219,
      "bbox_min": [
        1562.5999755859375,
        450.0,
        85.0
      ],
      "bbox_max": [
        1579.5,
        460.0,
        91.760009765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1575.5,
      "bbox_min": [
        1575.5,
        450.0,
        85.0
      ],
      "bbox_max": [
        1575.5,
        460.0,
        86.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39872613549232483,
        0.0,
        0.9170700907707214
      ],
      "plane_d": -755.9847412109375,
      "bbox_min": [
        1562.5999755859375,
        450.0,
        100.0
      ],
      "bbox_max": [
        1666.0,
        470.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1562.5999755859375,
        450.0,
        100.0
      ],
      "bbox_max": [
        1666.0,
        470.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 460.0,
      "bbox_min": [
        1562.5999755859375,
        450.0,
        100.0
      ],
      "bbox_max": [
        1666.0,
        470.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1562.5999755859375,
        460.0,
        118.0
      ],
      "bbox_max": [
        1620.0,
        470.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7213867902755737,
        -0.692532479763031,
        0.0
      ],
      "plane_d": 1447.1024169921875,
      "bbox_min": [
        1562.5999755859375,
        460.0,
        118.0
      ],
      "bbox_max": [
        1564.4000244140625,
        461.875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 450.0,
      "bbox_min": [
        1564.4000244140625,
        450.0,
        118.0
      ],
      "bbox_max": [
        1620.0,
        460.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1564.4000244140625,
        450.0,
        118.0
      ],
      "bbox_max": [
        1620.0,
        460.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1620.0,
        450.0,
        118.0
      ],
      "bbox_max": [
        1620.0,
        460.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 490.0,
      "bbox_min": [
        1562.5999755859375,
        470.0,
        85.0
      ],
      "bbox_max": [
        1760.0,
        510.0,
        348.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6305926442146301,
        -0.7761140465736389,
        0.0
      ],
      "plane_d": -628.65234375,
      "bbox_min": [
        1562.5999755859375,
        490.0,
        85.0
      ],
      "bbox_max": [
        1760.0,
        510.0,
        348.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        1562.5999755859375,
        490.0,
        85.0
      ],
      "bbox_max": [
        1624.6153564453125,
        510.0,
        348.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1570.0,
        490.0,
        98.0
      ],
      "bbox_max": [
        1624.6153564453125,
        510.0,
        348.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 871.155517578125,
      "bbox_min": [
        1570.0,
        490.0,
        338.0
      ],
      "bbox_max": [
        1580.0,
        510.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1562.5999755859375,
        490.0,
        98.0
      ],
      "bbox_max": [
        1570.0,
        510.0,
        138.8340606689453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35558992624282837,
        -0.10718918591737747,
        0.9284752011299133
      ],
      "plane_d": -613.1697998046875,
      "bbox_min": [
        1562.5999755859375,
        490.0,
        118.0
      ],
      "bbox_max": [
        1570.0,
        510.0,
        138.8340606689453
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1562.5999755859375,
        490.0,
        118.0
      ],
      "bbox_max": [
        1564.77783203125,
        510.0,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.24687258899211884,
        -0.2777306139469147,
        0.9283962845802307
      ],
      "plane_d": -359.56439208984375,
      "bbox_min": [
        1562.5999755859375,
        490.0,
        118.0
      ],
      "bbox_max": [
        1563.97119140625,
        490.87835693359375,
        118.62738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35558319091796875,
        -0.10718917846679688,
        0.9284778833389282
      ],
      "plane_d": -629.8721923828125,
      "bbox_min": [
        1562.5999755859375,
        502.7752990722656,
        138.0
      ],
      "bbox_max": [
        1564.77783203125,
        510.0,
        138.8340606689453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1562.5999755859375,
        502.7752990722656,
        138.0
      ],
      "bbox_max": [
        1564.77783203125,
        510.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9574458599090576,
        -0.28861290216445923,
        0.0
      ],
      "plane_d": -1355.9974365234375,
      "bbox_min": [
        1562.5999755859375,
        490.0,
        98.0
      ],
      "bbox_max": [
        1570.0,
        510.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9575520753860474,
        -0.2882605195045471,
        0.0
      ],
      "plane_d": -1351.3433837890625,
      "bbox_min": [
        1562.5999755859375,
        490.0,
        98.0
      ],
      "bbox_max": [
        1570.0,
        510.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1562.5999755859375,
        502.7655334472656,
        100.0
      ],
      "bbox_max": [
        1564.77783203125,
        510.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1562.5999755859375,
        490.0,
        98.0
      ],
      "bbox_max": [
        1570.0,
        510.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1562.5999755859375,
        490.0,
        100.0
      ],
      "bbox_max": [
        1570.0,
        510.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -88.0,
      "bbox_min": [
        1628.056884765625,
        490.0,
        85.0
      ],
      "bbox_max": [
        1760.0,
        510.0,
        98.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": 659.3378295898438,
      "bbox_min": [
        1628.056884765625,
        490.0,
        85.0
      ],
      "bbox_max": [
        1760.0,
        510.0,
        88.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1760.0,
        490.0,
        85.0
      ],
      "bbox_max": [
        1760.0,
        510.0,
        88.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9805806875228882,
        0.1961161345243454
      ],
      "plane_d": 477.9350280761719,
      "bbox_min": [
        1669.7574462890625,
        505.0,
        88.0
      ],
      "bbox_max": [
        1745.0,
        510.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -97.99999237060547,
      "bbox_min": [
        1669.7574462890625,
        505.0,
        88.0
      ],
      "bbox_max": [
        1745.0,
        510.0,
        98.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6246256828308105,
        0.7558990716934204,
        0.19611048698425293
      ],
      "plane_d": 643.9866333007812,
      "bbox_min": [
        1669.7574462890625,
        505.0,
        88.0
      ],
      "bbox_max": [
        1745.0,
        510.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805806279182434,
        -0.0,
        0.1961161345243454
      ],
      "plane_d": -1728.371337890625,
      "bbox_min": [
        1743.0,
        505.0,
        88.0
      ],
      "bbox_max": [
        1745.0,
        510.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1562.5999755859375,
        470.0,
        98.0
      ],
      "bbox_max": [
        1580.0,
        490.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1562.5999755859375,
        470.0,
        118.0
      ],
      "bbox_max": [
        1580.0,
        490.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.745241641998291,
        0.6667945384979248,
        0.0
      ],
      "plane_d": -1490.875244140625,
      "bbox_min": [
        1562.5999755859375,
        470.0,
        118.0
      ],
      "bbox_max": [
        1580.0,
        490.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24687258899211884,
        -0.2777306139469147,
        0.9283962845802307
      ],
      "plane_d": -359.56439208984375,
      "bbox_min": [
        1562.5999755859375,
        488.7811279296875,
        118.0
      ],
      "bbox_max": [
        1562.931884765625,
        489.4471435546875,
        118.19923400878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24687258899211884,
        -0.2777306139469147,
        0.9283962845802307
      ],
      "plane_d": -359.56439208984375,
      "bbox_min": [
        1562.5999755859375,
        489.0761413574219,
        118.0
      ],
      "bbox_max": [
        1563.97119140625,
        490.0,
        118.3646240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6643652319908142,
        -0.7474080920219421,
        0.0
      ],
      "plane_d": -672.818115234375,
      "bbox_min": [
        1562.5999755859375,
        488.7811279296875,
        98.0
      ],
      "bbox_max": [
        1563.97119140625,
        490.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1562.5999755859375,
        488.7811279296875,
        98.0
      ],
      "bbox_max": [
        1563.97119140625,
        490.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1562.5999755859375,
        488.7811279296875,
        98.0
      ],
      "bbox_max": [
        1563.97119140625,
        490.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -420.0,
      "bbox_min": [
        550.0,
        420.0,
        80.0
      ],
      "bbox_max": [
        1290.0,
        670.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        550.0,
        420.0,
        80.0
      ],
      "bbox_max": [
        1290.0,
        670.0,
        338.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -550.0,
      "bbox_min": [
        550.0,
        580.0,
        100.0
      ],
      "bbox_max": [
        550.0,
        670.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1250.0,
        420.0,
        98.0
      ],
      "bbox_max": [
        1290.0,
        670.0,
        338.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1250.0,
        420.0,
        98.0
      ],
      "bbox_max": [
        1290.0,
        670.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1270.0,
      "bbox_min": [
        1270.0,
        420.0,
        98.0
      ],
      "bbox_max": [
        1290.0,
        670.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        1270.0,
        450.0,
        98.0
      ],
      "bbox_max": [
        1290.0,
        470.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 450.0,
      "bbox_min": [
        1270.0,
        450.0,
        98.0
      ],
      "bbox_max": [
        1290.0,
        450.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1260.0,
      "bbox_min": [
        1260.0,
        620.0,
        220.0
      ],
      "bbox_max": [
        1290.0,
        670.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 620.0,
      "bbox_min": [
        1260.0,
        620.0,
        220.0
      ],
      "bbox_max": [
        1290.0,
        670.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1260.0,
        620.0,
        220.0
      ],
      "bbox_max": [
        1290.0,
        670.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 258.0,
      "bbox_min": [
        1260.0,
        620.0,
        258.0
      ],
      "bbox_max": [
        1290.0,
        670.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1840.0,
        1470.0,
        1060.0
      ],
      "bbox_max": [
        2091.7158203125,
        2050.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1840.0,
        1470.0,
        1060.0
      ],
      "bbox_max": [
        1971.7369384765625,
        2050.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2483755201101303,
        -0.9686638712882996,
        -0.0
      ],
      "plane_d": 2353.7021484375,
      "bbox_min": [
        1910.0,
        1595.58154296875,
        1060.0
      ],
      "bbox_max": [
        1971.7369384765625,
        1940.0999755859375,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1910.0,
        1595.58154296875,
        1060.0
      ],
      "bbox_max": [
        1971.7369384765625,
        1893.3603515625,
        1150.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2632.51806640625,
      "bbox_min": [
        1910.0,
        1805.0001220703125,
        1130.0
      ],
      "bbox_max": [
        1917.9423828125,
        1812.9425048828125,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659263491630554,
        -0.2588171064853668,
        3.2501047826372087e-06
      ],
      "plane_d": 2319.75244140625,
      "bbox_min": [
        1910.0,
        1704.3255615234375,
        1060.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1812.9427490234375,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1921.2918701171875,
        1772.5001220703125,
        1110.0
      ],
      "bbox_max": [
        1928.516845703125,
        1793.0001220703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882038474082947,
        -0.9659255146980286,
        0.0
      ],
      "plane_d": 1213.446533203125,
      "bbox_min": [
        1926.6507568359375,
        1772.5001220703125,
        1110.0
      ],
      "bbox_max": [
        1928.516845703125,
        1773.0001220703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1910.0,
        1704.3255615234375,
        1060.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1812.9427490234375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1910.0,
        1704.3255615234375,
        1110.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1792.5001220703125,
        1115.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25882038474082947,
        -0.9659255146980286,
        0.0
      ],
      "plane_d": 1213.446533203125,
      "bbox_min": [
        1910.0,
        1768.03857421875,
        1110.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1772.5001220703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.7438646864320617e-06,
        -1.0,
        0.0
      ],
      "plane_d": 1579.9033203125,
      "bbox_min": [
        1840.0,
        1578.9056396484375,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1912.11669921875,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1840.0,
        1579.900146484375,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1912.11669921875,
        1150.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.258819580078125,
        -0.9659257531166077,
        -0.0
      ],
      "plane_d": 2263.19091796875,
      "bbox_min": [
        1840.0001220703125,
        1812.9425048828125,
        1130.0
      ],
      "bbox_max": [
        1910.0,
        1850.0001220703125,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2632.51806640625,
      "bbox_min": [
        1885.0001220703125,
        1812.9425048828125,
        1130.0
      ],
      "bbox_max": [
        1910.0,
        1837.9423828125,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1840.0,
        1689.84228515625,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1850.0001220703125,
        1130.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.2588171064853668,
        -0.9659263491630554,
        -6.22936750005465e-06
      ],
      "plane_d": 2263.1943359375,
      "bbox_min": [
        1840.0,
        1689.84228515625,
        1110.0
      ],
      "bbox_max": [
        1910.0,
        1850.0001220703125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660261034965515,
        -0.4999989867210388,
        0.0
      ],
      "plane_d": -713.4900512695312,
      "bbox_min": [
        1885.0001220703125,
        1837.9423828125,
        1110.0
      ],
      "bbox_max": [
        1886.000244140625,
        1839.674560546875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2535.23193359375,
      "bbox_min": [
        1840.0,
        1689.84228515625,
        1110.0
      ],
      "bbox_max": [
        1910.0,
        1768.03857421875,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882038474082947,
        -0.9659255146980286,
        0.0
      ],
      "plane_d": 1213.446533203125,
      "bbox_min": [
        1860.0,
        1725.3590087890625,
        1110.0
      ],
      "bbox_max": [
        1910.0,
        1768.03857421875,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -95.20556640625,
      "bbox_min": [
        1860.0,
        1725.3590087890625,
        1115.0
      ],
      "bbox_max": [
        1874.6409912109375,
        1740.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882017612457275,
        -0.9659255146980286,
        0.0
      ],
      "plane_d": 1185.1627197265625,
      "bbox_min": [
        1840.0,
        1720.0,
        1110.0
      ],
      "bbox_max": [
        1860.0,
        1725.3590087890625,
        1125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2588171064853668,
        -0.9659263491630554,
        6.86823625528632e-07
      ],
      "plane_d": 2263.186767578125,
      "bbox_min": [
        1840.0001220703125,
        1812.9425048828125,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1850.0001220703125,
        1110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660261034965515,
        -0.4999989867210388,
        0.0
      ],
      "plane_d": -713.4900512695312,
      "bbox_min": [
        1885.000244140625,
        1837.9425048828125,
        1106.0
      ],
      "bbox_max": [
        1886.000244140625,
        1839.674560546875,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1885.0001220703125,
        1812.9425048828125,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1837.9425048828125,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1847.498046875,
        1578.9056396484375,
        1130.0
      ],
      "bbox_max": [
        1851.47607421875,
        1579.900146484375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1549.998779296875,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        1060.0
      ],
      "bbox_max": [
        1840.000244140625,
        2011.7158203125,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        1060.0
      ],
      "bbox_max": [
        1840.000244140625,
        1912.11669921875,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2162.533447265625,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        1060.0
      ],
      "bbox_max": [
        1840.000244140625,
        1912.11669921875,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.7438585473428247e-06,
        -1.0,
        0.0
      ],
      "plane_d": 1579.89697265625,
      "bbox_min": [
        1763.941650390625,
        1579.9000244140625,
        1060.0
      ],
      "bbox_max": [
        1840.000244140625,
        1912.11669921875,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1763.941650390625,
        1671.4832763671875,
        1060.0
      ],
      "bbox_max": [
        1840.000244140625,
        1912.11669921875,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1769.84228515625,
        1671.4832763671875,
        1060.0
      ],
      "bbox_max": [
        1840.000244140625,
        1850.0001220703125,
        1115.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2535.23193359375,
      "bbox_min": [
        1769.84228515625,
        1780.0,
        1110.0
      ],
      "bbox_max": [
        1805.3590087890625,
        1815.5167236328125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882136821746826,
        -0.9659252762794495,
        6.868348805255664e-07
      ],
      "plane_d": 1310.7298583984375,
      "bbox_min": [
        1794.9998779296875,
        1837.9422607421875,
        1060.0
      ],
      "bbox_max": [
        1840.000244140625,
        1850.0001220703125,
        1106.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}